(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6337],{

/***/ 93642:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prediction",
      function () {
        return __webpack_require__(78872);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75943);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44147);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24686);
/* harmony import */ var _Text_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62077);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82004);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);










var BalanceInput = function BalanceInput(_param) {
    var value = _param.value, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "0.0" : _placeholder, onUserInput = _param.onUserInput, currencyValue = _param.currencyValue, inputProps = _param.inputProps, innerRef = _param.innerRef, _isWarning = _param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, _decimals = _param.decimals, decimals = _decimals === void 0 ? 18 : _decimals, unit = _param.unit, switchEditingUnits = _param.switchEditingUnits, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "placeholder",
        "onUserInput",
        "currencyValue",
        "inputProps",
        "innerRef",
        "isWarning",
        "decimals",
        "unit",
        "switchEditingUnits"
    ]);
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
    var handleOnChange = function handleOnChange(e) {
        if (e.currentTarget.validity.valid) {
            onUserInput(e.currentTarget.value.replace(/,/g, "."));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledBalanceInput */ .FX, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        isWarning: isWarning
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            pb: "10px",
            style: {
                borderBottom: "1px solid ".concat(theme.colors.backgroundDisabled)
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledInput */ .Fy, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                    pattern: "^[0-9]*[.,]?[0-9]{0,".concat(decimals, "}$"),
                                    inputMode: "decimal",
                                    min: "0",
                                    textAlign: "left",
                                    value: value,
                                    onChange: handleOnChange,
                                    placeholder: placeholder,
                                    ref: innerRef
                                }, inputProps)),
                                unit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .UnitContainer */ .HH, {
                                    children: unit
                                })
                            ]
                        }),
                        currencyValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Text_Text__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            fontSize: "14px",
                            textAlign: "left",
                            color: "textSubtle",
                            children: currencyValue
                        })
                    ]
                }),
                switchEditingUnits && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    alignItems: "center",
                    pl: "12px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .SwitchUnitsButton */ .sN, {
                        scale: "sm",
                        variant: "text",
                        onClick: switchEditingUnits,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            color: "textSubtle"
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BalanceInput);


/***/ }),

/***/ 82004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ StyledBalanceInput; },
/* harmony export */   "Fy": function() { return /* binding */ StyledInput; },
/* harmony export */   "HH": function() { return /* binding */ UnitContainer; },
/* harmony export */   "sN": function() { return /* binding */ SwitchUnitsButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var _Input_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32762);
/* harmony import */ var _Text_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62077);
/* harmony import */ var _Button_IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89663);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 4px;\n  text-align: right;\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 16px;\n  padding: 8px 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  padding-left: 0;\n  padding-right: 0;\n  text-align: ",
        ";\n  border: none;\n\n  ::placeholder {\n    color: ",
        ";\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var SwitchUnitsButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Button_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fb642bb5-0"
}).withConfig({
    componentId: "sc-6258f4b6-0"
})(_templateObject());
var UnitContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fb642bb5-1"
}).withConfig({
    componentId: "sc-6258f4b6-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var StyledBalanceInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Box_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fb642bb5-2"
}).withConfig({
    componentId: "sc-6258f4b6-2"
})(_templateObject2());
var StyledInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Input_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fb642bb5-3"
}).withConfig({
    componentId: "sc-6258f4b6-3"
})(_templateObject3(), function(param) {
    var _textAlign = param.textAlign, textAlign = _textAlign === void 0 ? "right" : _textAlign;
    return textAlign;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});


/***/ }),

/***/ 55209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e97edbbd-0"
}).withConfig({
    componentId: "sc-206fd2b9-0"
})(_templateObject(), function(param) {
    var theme = param.theme, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    return theme.card.cardHeaderBackground[variant];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardHeader.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);


/***/ }),

/***/ 79207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Progress_Progress; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/StyledProgress.tsx + 1 modules
var StyledProgress = __webpack_require__(6531);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/ProgressBunnyWrapper.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  z-index: 2;\n  top: -65%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  transition: left 200ms ease-out;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProgressBunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a698ef92-0"
}).withConfig({
    componentId: "sc-d864b77e-0"
})(_templateObject());
/* harmony default export */ var Progress_ProgressBunnyWrapper = (ProgressBunnyWrapper);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ProgressBunny.tsx
var ProgressBunny = __webpack_require__(62968);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/types.ts
var types = __webpack_require__(94065);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/Progress.tsx






var stepGuard = function stepGuard(step) {
    if (step < 0) {
        return 0;
    }
    if (step > 100) {
        return 100;
    }
    return step;
};
var Progress = function Progress(param) {
    var _variant = param.variant, variant = _variant === void 0 ? types/* variants.ROUND */.o.ROUND : _variant, _scale = param.scale, scale = _scale === void 0 ? types/* scales.MD */.Q.MD : _scale, _primaryStep = param.primaryStep, primaryStep = _primaryStep === void 0 ? 0 : _primaryStep, _secondaryStep = param.secondaryStep, secondaryStep = _secondaryStep === void 0 ? null : _secondaryStep, _showProgressBunny = param.showProgressBunny, showProgressBunny = _showProgressBunny === void 0 ? false : _showProgressBunny, _useDark = param.useDark, useDark = _useDark === void 0 ? true : _useDark, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgress/* default */.Z, {
        $useDark: useDark,
        variant: variant,
        scale: scale,
        children: children || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                showProgressBunny && /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress_ProgressBunnyWrapper, {
                    style: {
                        left: "".concat(stepGuard(primaryStep), "%")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBunny/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgress/* Bar */.$, {
                    $useDark: useDark,
                    primary: true,
                    style: {
                        width: "".concat(stepGuard(primaryStep), "%")
                    }
                }),
                secondaryStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgress/* Bar */.$, {
                    $useDark: useDark,
                    style: {
                        width: "".concat(stepGuard(secondaryStep), "%")
                    }
                }) : null
            ]
        })
    });
};
/* harmony default export */ var Progress_Progress = (Progress);


/***/ }),

/***/ 6531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Bar; },
  "Z": function() { return /* binding */ Progress_StyledProgress; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/theme/colors.ts
var colors = __webpack_require__(16557);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/types.ts
var types = __webpack_require__(94065);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/themes.ts


var _obj;
var styleVariants = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* variants.ROUND */.o.ROUND, {
    borderRadius: "32px"
}), (0,_define_property/* default */.Z)(_obj, types/* variants.FLAT */.o.FLAT, {
    borderRadius: 0
}), _obj);
var _obj1;
var styleScales = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, types/* scales.MD */.Q.MD, {
    height: "1px"
}), (0,_define_property/* default */.Z)(_obj1, types/* scales.SM */.Q.SM, {
    height: "1px"
}), _obj1);
/* harmony default export */ var themes = ((/* unused pure expression or super */ null && (styleVariants)));

;// CONCATENATED MODULE: ./packages/uikit/src/components/Progress/StyledProgress.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  height: 100%;\n  transition: width 200ms ease;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  overflow: hidden;\n\n  ",
        " {\n    border-top-left-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Bar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4136c9a-0"
}).withConfig({
    componentId: "sc-2ec3c4d2-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $useDark = param.$useDark, primary = param.primary, $background = param.$background;
    if ($background) return $background;
    if ($useDark) return primary ? theme.colors.alienPurple : "".concat(theme.colors.secondary80);
    return primary ? colors/* lightColors.secondary */.C.secondary : "".concat(colors/* lightColors.secondary80 */.C.secondary80);
});
Bar.defaultProps = {
    primary: false
};
var StyledProgress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4136c9a-1"
}).withConfig({
    componentId: "sc-2ec3c4d2-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, $useDark = param.$useDark;
    return $useDark ? theme.colors.input : colors/* lightColors.input */.C.input;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, Bar, function(param) {
    var variant = param.variant;
    return variant === types/* variants.FLAT */.o.FLAT ? "0" : "32px";
}, function(param) {
    var variant = param.variant;
    return variant === types/* variants.FLAT */.o.FLAT ? "0" : "32px";
}, (0,index_esm/* variant */.bU)({
    variants: styleVariants
}), (0,index_esm/* variant */.bU)({
    prop: "scale",
    variants: styleScales
}), index_esm/* space */.Dh);
/* harmony default export */ var Progress_StyledProgress = (StyledProgress);


/***/ }),

/***/ 94065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; },
/* harmony export */   "o": function() { return /* binding */ variants; }
/* harmony export */ });
var variants = {
    ROUND: "round",
    FLAT: "flat"
};
var scales = {
    MD: "md",
    SM: "sm"
};


/***/ }),

/***/ 39964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Icon = function Icon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "8",
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7 7.5L0 0.5H14L7 7.5Z",
                fill: "#FF66D4"
            }),
            "     "
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 90634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Icon = function Icon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "14",
        height: "8",
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7 0.5L14 7.5L0 7.5L7 0.5Z",
            fill: "#66FFB6"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 83330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20.0833 29.8056C20.5741 29.8056 20.9884 29.6366 21.3264 29.2987C21.6643 28.9607 21.8333 28.5463 21.8333 28.0556C21.8333 27.5649 21.6643 27.1505 21.3264 26.8125C20.9884 26.4746 20.5741 26.3056 20.0833 26.3056C19.5926 26.3056 19.1782 26.4746 18.8403 26.8125C18.5023 27.1505 18.3333 27.5649 18.3333 28.0556C18.3333 28.5463 18.5023 28.9607 18.8403 29.2987C19.1782 29.6366 19.5926 29.8056 20.0833 29.8056ZM18.6111 23.6112H21.2778C21.2778 22.8241 21.3727 22.1436 21.5625 21.5695C21.7523 20.9954 22.324 20.2963 23.2777 19.4723C24.0926 18.75 24.6898 18.0486 25.0694 17.3681C25.4491 16.6875 25.6389 15.9167 25.6389 15.0556C25.6389 13.5556 25.1296 12.3704 24.1111 11.5C23.0926 10.6297 21.7963 10.1945 20.2222 10.1945C18.787 10.1945 17.5579 10.5602 16.5347 11.2917C15.5116 12.0232 14.7778 12.9815 14.3333 14.1667L16.7222 15.0834C16.9722 14.3982 17.3819 13.8148 17.9514 13.3334C18.5208 12.8519 19.25 12.6112 20.1389 12.6112C21.0648 12.6112 21.7963 12.8635 22.3333 13.3681C22.8704 13.8727 23.1389 14.4908 23.1389 15.2223C23.1389 15.8149 22.963 16.3727 22.6111 16.8959C22.2592 17.419 21.7685 17.9445 21.1389 18.4723C20.1759 19.3149 19.5139 20.0649 19.1528 20.7223C18.7917 21.3797 18.6111 22.3426 18.6111 23.6112ZM20 36.6667C17.713 36.6667 15.5556 36.2292 13.5278 35.3542C11.5 34.4792 9.73147 33.2871 8.22219 31.7778C6.71294 30.2686 5.52081 28.5 4.64581 26.4723C3.77081 24.4445 3.33331 22.2871 3.33331 20C3.33331 17.6945 3.77081 15.5278 4.64581 13.5C5.52081 11.4723 6.71294 9.70837 8.22219 8.20837C9.73147 6.70837 11.5 5.52087 13.5278 4.64587C15.5556 3.77087 17.713 3.33337 20 3.33337C22.3055 3.33337 24.4722 3.77087 26.5 4.64587C28.5278 5.52087 30.2916 6.70837 31.7916 8.20837C33.2916 9.70837 34.4792 11.4723 35.3542 13.5C36.2292 15.5278 36.6667 17.6945 36.6667 20C36.6667 22.2871 36.2292 24.4445 35.3542 26.4723C34.4792 28.5 33.2916 30.2686 31.7916 31.7778C30.2916 33.2871 28.5278 34.4792 26.5 35.3542C24.4722 36.2292 22.3055 36.6667 20 36.6667ZM20 33.889C23.8703 33.889 27.1528 32.5371 29.8472 29.8334C32.5417 27.1297 33.8889 23.8519 33.8889 20C33.8889 16.1297 32.5417 12.8473 29.8472 10.1528C27.1528 7.45835 23.8703 6.11113 20 6.11113C16.1481 6.11113 12.8703 7.45835 10.1666 10.1528C7.46292 12.8473 6.11106 16.1297 6.11106 20C6.11106 23.8519 7.46292 27.1297 10.1666 29.8334C12.8703 32.5371 16.1481 33.889 20 33.889Z",
            fill: "#9F9DAE"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 80323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 96 96"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "48",
                cy: "48",
                r: "48",
                fill: "#F0B90B"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30.9008 25.9057L47.8088 16.0637L64.7169 25.9057L58.5007 29.5416L47.8088 23.3355L37.117 29.5416L30.9008 25.9057ZM64.7169 38.3179L58.5007 34.682L47.8088 40.8881L37.117 34.682L30.9008 38.3179V45.5897L41.5926 51.7958V64.2079L47.8088 67.8438L54.0251 64.2079V51.7958L64.7169 45.5897V38.3179ZM64.7169 58.0018V50.7301L58.5007 54.366V61.6377L64.7169 58.0018ZM69.1305 60.572L58.4386 66.7781V74.0499L75.3467 64.2079V44.524L69.1305 48.1599V60.572ZM62.9143 32.1118L69.1305 35.7477V43.0195L75.3467 39.3836V32.1118L69.1305 28.4759L62.9143 32.1118ZM41.5926 69.411V76.6828L47.8088 80.3187L54.0251 76.6828V69.411L47.8088 73.0469L41.5926 69.411ZM30.9008 58.0018L37.117 61.6377V54.366L30.9008 50.7301V58.0018ZM41.5926 32.1118L47.8088 35.7477L54.0251 32.1118L47.8088 28.4759L41.5926 32.1118ZM26.4872 35.7477L32.7034 32.1118L26.4872 28.4759L20.271 32.1118V39.3836L26.4872 43.0195V35.7477ZM26.4872 48.1599L20.271 44.524V64.2079L37.1791 74.0499V66.7781L26.4872 60.572V48.1599Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 87907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0967 17.8521L7.87565 20.2891C6.91907 20.8414 5.69589 20.5136 5.1436 19.557L0.999729 12.3796C0.447444 11.4231 0.775193 10.1999 1.73178 9.64759L6.31754 7C6.53486 6.87453 6.76593 6.79448 6.99977 6.75691V6C6.99977 4.89543 7.8952 4 8.99977 4H14.9998C16.1043 4 16.9998 4.89543 16.9998 6V6.73545C17.299 6.75379 17.5986 6.83993 17.8759 7L22.4616 9.64759C23.4182 10.1999 23.746 11.4231 23.1937 12.3796L19.0498 19.557C18.4975 20.5136 17.2743 20.8414 16.3178 20.2891L12.0967 17.8521ZM8.99977 6L14.9998 6L14.9998 7.98154L11.2363 14.5H8.99977L8.99977 6ZM6.99977 14.5L6.99977 8.91551L2.73178 11.3796L6.87565 18.557L10.4386 16.5H8.99977C7.8952 16.5 6.99977 15.6046 6.99977 14.5ZM16.8759 8.73205L21.4616 11.3796L17.3178 18.557L12.732 15.9094L16.8759 8.73205Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 78593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: 20,
        height: 14,
        viewBox: "0 0 20 14"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 13.5L0 12L7.5 4.5L11.5 8.5L18.6 0.5L20 1.9L11.5 11.5L7.5 7.5L1.5 13.5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 42210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "5",
                fill: "#FF6666",
                "fill-opacity": "0.15"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "9.99995",
                r: "2.77778",
                fill: "#FF6666"
            }),
            " "
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 95703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "11",
        height: "10",
        viewBox: "0 0 11 10"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9 10V0H10.5V10H9ZM0.5 9.5V0.5L7.5 5L0.5 9.5Z",
            fill: "#9F9DAE"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 98468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 40 40"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.1667 35V32.2223H18.6111V26.3889C17.1574 26.0833 15.8634 25.4606 14.7292 24.5208C13.5949 23.581 12.7963 22.4074 12.3333 21C10.2685 20.7685 8.5301 19.9097 7.11804 18.4236C5.70601 16.9375 5 15.1667 5 13.1111V11.3333C5 10.5648 5.27083 9.90971 5.8125 9.36804C6.35417 8.82638 7.00925 8.55554 7.77775 8.55554H11.7778V5H28.2222V8.55554H32.2223C32.9908 8.55554 33.6458 8.82638 34.1875 9.36804C34.7292 9.90971 35 10.5648 35 11.3333V13.1111C35 15.1667 34.294 16.9375 32.882 18.4236C31.4699 19.9097 29.7315 20.7685 27.6667 21C27.2037 22.4074 26.4051 23.581 25.2708 24.5208C24.1366 25.4606 22.8426 26.0833 21.3889 26.3889V32.2223H27.8333V35H12.1667ZM11.7778 18.0555V11.3333H7.77775V13.1111C7.77775 14.2963 8.15275 15.3403 8.90275 16.243C9.65278 17.1458 10.6111 17.75 11.7778 18.0555ZM28.2222 18.0555C29.3889 17.75 30.3472 17.1458 31.0973 16.243C31.8473 15.3403 32.2223 14.2963 32.2223 13.1111V11.3333H28.2222V18.0555Z",
                fill: (props === null || props === void 0 ? void 0 : props.color) || "#9F9DAE"
            }),
            "     "
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 62968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 34 38"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "8.83594",
                width: "5.30132",
                height: "17.3191",
                rx: "2.65066",
                fill: "#D1884F"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "19.4385",
                width: "5.30132",
                height: "17.3191",
                rx: "2.65066",
                fill: "#D1884F"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.5 13.0084C13.1944 8.40751 20.8056 8.40751 25.5 13.0084C30.1944 17.6093 30.1944 25.0689 25.5 29.6698L17.6538 37.3597C17.2927 37.7136 16.7073 37.7136 16.3462 37.3597L8.5 29.6698C3.80558 25.0689 3.80558 17.6093 8.5 13.0084Z",
                fill: "#D1884F"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                cx: "12.3696",
                cy: "19.9172",
                rx: "1.76711",
                ry: "2.59786",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                cx: "21.2056",
                cy: "19.9172",
                rx: "1.76711",
                ry: "2.59786",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 24686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 17.01V11C16 10.45 15.55 10 15 10C14.45 10 14 10.45 14 11V17.01H12.21C11.76 17.01 11.54 17.55 11.86 17.86L14.65 20.64C14.85 20.83 15.16 20.83 15.36 20.64L18.15 17.86C18.47 17.55 18.24 17.01 17.8 17.01H16ZM8.65003 3.35002L5.86003 6.14002C5.54003 6.45002 5.76003 6.99002 6.21003 6.99002H8.00003V13C8.00003 13.55 8.45003 14 9.00003 14C9.55003 14 10 13.55 10 13V6.99002H11.79C12.24 6.99002 12.46 6.45002 12.14 6.14002L9.35003 3.35002C9.16003 3.16002 8.84003 3.16002 8.65003 3.35002Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 91770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "20",
        height: "19",
        viewBox: "0 0 20 19"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16 18.1458L14.3542 16.4792C13.7292 16.9792 13.0451 17.3576 12.3021 17.6146C11.559 17.8715 10.7917 18 10 18C9.02778 18 8.11806 17.816 7.27083 17.4479C6.42361 17.0799 5.68403 16.5799 5.05208 15.9479C4.42014 15.316 3.92014 14.5764 3.55208 13.7292C3.18403 12.8819 3 11.9722 3 11C3 10.2083 3.12847 9.44097 3.38542 8.69792C3.64236 7.95486 4.02083 7.27083 4.52083 6.64583L1.875 4L2.9375 2.9375L17.0625 17.0833L16 18.1458ZM7.5 3V1.5H12.5V3H7.5ZM16.25 14.1458L10.7708 8.64583L10.75 7H9.25V7.125L6.875 4.75C7.36111 4.48611 7.86806 4.29514 8.39583 4.17708C8.92361 4.05903 9.45833 4 10 4C10.8056 4 11.5833 4.13542 12.3333 4.40625C13.0833 4.67708 13.7708 5.0625 14.3958 5.5625L15.4792 4.47917L16.5208 5.54167L15.4583 6.625C15.9583 7.25 16.3403 7.9375 16.6042 8.6875C16.8681 9.4375 17 10.2083 17 11C17 11.5417 16.9375 12.0799 16.8125 12.6146C16.6875 13.1493 16.5 13.6597 16.25 14.1458Z",
                fill: "#9F9DAE"
            }),
            " "
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 56658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "60",
        height: "60",
        viewBox: "0 0 60 60"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.3333 60V54.4445H27.2223V42.7778C24.3148 42.1666 21.7268 40.9213 19.4583 39.0417C17.1898 37.162 15.5926 34.8148 14.6667 32C10.5371 31.537 7.06019 29.8194 4.23608 26.8472C1.41203 23.8749 0 20.3333 0 16.2222V12.6667C0 11.1296 0.541667 9.81942 1.625 8.73608C2.70833 7.65275 4.0185 7.11108 5.5555 7.11108H13.5556V0H46.4444V7.11108H54.4445C55.9815 7.11108 57.2917 7.65275 58.375 8.73608C59.4583 9.81942 60 11.1296 60 12.6667V16.2222C60 20.3333 58.588 23.8749 55.7639 26.8472C52.9398 29.8194 49.4629 31.537 45.3333 32C44.4074 34.8148 42.8102 37.162 40.5417 39.0417C38.2732 40.9213 35.6852 42.1666 32.7778 42.7778V54.4445H45.6667V60H14.3333ZM13.5556 26.1111V12.6667H5.5555V16.2222C5.5555 18.5926 6.3055 20.6805 7.8055 22.4861C9.30556 24.2916 11.2222 25.5 13.5556 26.1111ZM46.4444 26.1111C48.7778 25.5 50.6944 24.2916 52.1945 22.4861C53.6945 20.6805 54.4445 18.5926 54.4445 16.2222V12.6667H46.4444V26.1111Z",
            fill: props.fill || "#FFE766"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 13522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7.75C12.5 7.33579 12.1642 7 11.75 7C11.3358 7 11 7.33579 11 7.75V13L15.5537 15.8022C15.9106 16.0219 16.3781 15.9106 16.5978 15.5537C16.8192 15.1938 16.7041 14.7225 16.3419 14.5051L12.5 12.2V7.75Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 69117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 8px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 8px solid #ddd;\n  border-bottom: 8px solid #ddd;\n  width: 20px;\n  height: 20px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Loading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-57089fde-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 54757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ TabToggleGroup; },
/* harmony export */   "o": function() { return /* binding */ TabToggle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-x: scroll;\n  padding: 0;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  scrollbar-width: none; /* Firefox */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  cursor: pointer;\n  flex: 1;\n  border-radius: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: ",
        ";\n  box-shadow: ",
        ";\n  @media only screen and (max-width: 966px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d1f389bb-0"
})(_templateObject());
var Inner = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d1f389bb-1"
})(_templateObject1());
var TabToggle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    as: "button"
}).withConfig({
    componentId: "sc-d1f389bb-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.text : theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? "inset 0px -2px 0px ".concat(theme.colors.alienPurple) : "none";
});
TabToggle.defaultProps = {
    p: "16px"
};
var TabToggleGroup = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        p: [
            "0 4px",
            "0 16px"
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Inner, {
            children: children
        })
    });
};


/***/ }),

/***/ 13351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ LocalContext; },
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);



var LocalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var children = param.children, store = param.store;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_redux__WEBPACK_IMPORTED_MODULE_2__/* .Provider */ .zt, {
        store: store,
        context: LocalContext,
        children: children
    });
};


/***/ }),

/***/ 29807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalDispatch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50308);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13351);



function useLocalDispatch() {
    var ref;
    var localContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Provider__WEBPACK_IMPORTED_MODULE_2__/* .LocalContext */ .A);
    var emptyFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((lodash_noop__WEBPACK_IMPORTED_MODULE_1___default()), []);
    return (localContext === null || localContext === void 0 ? void 0 : (ref = localContext.store) === null || ref === void 0 ? void 0 : ref.dispatch) || emptyFn;
}


/***/ }),

/***/ 91543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useCallNoGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64487);






function useCallNoGasPrice() {
    /**
   * Perform a contract call without setting a gas price, allowing MetaMask to handle it
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callNoGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call without setting gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(methodArgs).concat([
                                overrides
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callNoGasPrice: callNoGasPrice
    };
}


/***/ }),

/***/ 78872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Prediction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/views/Predictions/context/PredictionConfigProviders.tsx + 2 modules
var PredictionConfigProviders = __webpack_require__(63322);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var hooks = __webpack_require__(88770);
// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./src/state/predictions/hooks.ts + 2 modules
var predictions_hooks = __webpack_require__(89890);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/useLocalDispatch.ts
var useLocalDispatch = __webpack_require__(29807);
// EXTERNAL MODULE: ./src/state/global/actions.ts
var actions = __webpack_require__(51904);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
;// CONCATENATED MODULE: ./src/hooks/useAccountLocalEventListener.ts




var useAccountLocalEventListener = function() {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId, connector = ref.connector;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    (0,react.useEffect)(function() {
        if (account && connector) {
            var handleEvent = function() {
                dispatch((0,actions/* resetUserState */.t)({
                    chainId: chainId
                }));
            };
            connector.addListener("disconnect", handleEvent);
            connector.addListener("change", handleEvent);
            return function() {
                connector.removeListener("disconnect", handleEvent);
                connector.removeListener("change", handleEvent);
            };
        }
        return undefined;
    }, [
        account,
        chainId,
        dispatch,
        connector
    ]);
};

// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(15426);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box_Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(92052);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
;// CONCATENATED MODULE: ./src/views/Predictions/components/ChartDisclaimer.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  list-style-position: outside;\n  margin-left: 16px;\n\n  & > li {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Ul = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-feefc07b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ChartDisclaimer = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChartDisclaimerShow */.TL)(), 2), showDisclaimer = ref[0], setShowDisclaimer = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleConfirm = function() {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        $minWidth: "320px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
            p: "24px 20px",
            maxWidth: "400px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    as: "h3",
                    size: "sm",
                    children: [
                        t("Warning"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    as: "h4",
                    size: "sm",
                    mb: "24px",
                    children: [
                        t("Prices shown on cards and charts are different"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    as: "p",
                    fontSize: "14px",
                    color: "textSubtle",
                    children: [
                        t("The price you see come from difference places"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ul, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("Prices on cards come from Chainlink’s verifiable price oracle.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("Prices on charts come from Coinbase.com. Chart's are provided for your reference only.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    mb: "16px",
                    fontSize: "14px",
                    color: "textSubtle",
                    children: t("Only the price from Chainlink (shown on the cards) determines the round's result.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "https://docs.alienbase.xyz/predictions",
                    external: true,
                    mb: "24px",
                    children: t("Learn More")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        onClick: handleConfirm,
                        mb: "16px",
                        children: t("I understand")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: "checkbox",
                    style: {
                        display: "block",
                        cursor: "pointer",
                        marginBottom: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    flex: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    id: "checkbox",
                                    scale: "sm",
                                    checked: !showDisclaimer,
                                    onChange: function() {
                                        return setShowDisclaimer(!showDisclaimer);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "8px",
                                children: t("Don't show this again")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ChartDisclaimer = (ChartDisclaimer);

;// CONCATENATED MODULE: ./src/views/Predictions/components/ChainlinkChartDisclaimer.tsx


function ChainlinkChartDisclaimer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  list-style-position: outside;\n  margin-left: 16px;\n\n  & > li {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n"
    ]);
    ChainlinkChartDisclaimer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ChainlinkChartDisclaimer_Ul = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-8a26c552-0"
})(ChainlinkChartDisclaimer_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ChainlinkChartDisclaimer_ChartDisclaimer = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChainlinkChartDisclaimerShow */.sg)(), 2), showDisclaimer = ref[0], setShowDisclaimer = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleConfirm = function() {
        onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        $minWidth: "320px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
            p: "24px",
            maxWidth: "400px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    as: "h3",
                    size: "sm",
                    children: t("Currently showing charts from Chainlink oracle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "14px",
                    my: "24px",
                    children: t("The price you see come directly from the Chainlink oracle, which powers the Prediction game.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChainlinkChartDisclaimer_Ul, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("Oracle price refreshes every 20 minutes or after at least a 0.15% deviation from the last price.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("When compared to TradingView chart. This chart refreshes slower and with fewer features.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        variant: "primary",
                        onClick: handleConfirm,
                        my: "16px",
                        children: t("I understand")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: "checkbox",
                    style: {
                        display: "block",
                        cursor: "pointer",
                        marginBottom: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    flex: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    id: "checkbox",
                                    scale: "sm",
                                    checked: !showDisclaimer,
                                    onChange: function() {
                                        return setShowDisclaimer(!showDisclaimer);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "8px",
                                children: t("Don't show this again")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ChainlinkChartDisclaimer = (ChainlinkChartDisclaimer_ChartDisclaimer);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Container.tsx

function Container_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  @media only screen and (max-width: 575px) and (min-height: 740px) {\n    height: calc(100vh - 150px);\n  }\n  ",
        " {\n    height: calc(100vh - 100px);\n  }\n  overflow: hidden;\n"
    ]);
    Container_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2166081-0"
})(Container_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
/* harmony default export */ var components_Container = (/*#__PURE__*/(0,react.memo)(Container));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/DisclaimerModal/index.tsx



function DisclaimerModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding-bottom: 24px;\n  padding-top: 24px;\n"
    ]);
    DisclaimerModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var GradientModalHeader = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalHeader */.xB).withConfig({
    componentId: "sc-62a59ff0-0"
})(DisclaimerModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientBubblegum;
});
// TODO: Copy from src/views/Predictions/components/RiskDisclaimer.tsx
// Will replace that with this modal.
var DisclaimerModal = function(param) {
    var id = param.id, onSuccess = param.onSuccess, onDismiss = param.onDismiss, checks = param.checks, header = param.header, subtitle = param.subtitle;
    var ref = (0,react.useState)(checks || []), checkState = ref[0], setCheckState = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleSetAcknowledgeRisk = (0,react.useCallback)(function(currentKey) {
        var newCheckState = checkState.map(function(check) {
            if (currentKey === check.key) {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, check), {
                    value: !check.value
                });
            }
            return check;
        });
        setCheckState(newCheckState);
    }, [
        checkState
    ]);
    var handleConfirm = (0,react.useCallback)(function() {
        onSuccess();
        onDismiss();
    }, [
        onSuccess,
        onDismiss
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        title: t("Welcome!"),
        $minWidth: "320px",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientModalHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("Welcome!")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                maxWidth: [
                    "100%",
                    "100%",
                    "100%",
                    "400px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        maxHeight: "300px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h3",
                                mb: "24px",
                                children: header
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: "p",
                                color: "textSubtle",
                                mb: "24px",
                                children: subtitle
                            }),
                            checkState.map(function(check) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: check.key,
                                    style: {
                                        display: "block",
                                        cursor: "pointer",
                                        marginBottom: "24px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    flex: "none",
                                                    alignSelf: "flex-start",
                                                    paddingTop: "8px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: check.key,
                                                    scale: "sm",
                                                    checked: check.value,
                                                    onChange: function() {
                                                        return handleSetAcknowledgeRisk(check.key);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                ml: "8px",
                                                children: check.content
                                            })
                                        ]
                                    })
                                }, check.key);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "".concat(id, "-continue"),
                        width: "100%",
                        onClick: handleConfirm,
                        disabled: checkState.some(function(check) {
                            return !check.value;
                        }),
                        children: t("Continue")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DisclaimerModal = (DisclaimerModal);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RiskDisclaimer.tsx







function RiskDisclaimer() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionAcceptedRisk */.oI)(), 2), hasAcceptedRisk = ref[0], setHasAcceptedRisk = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_DisclaimerModal, {
        id: "predictions-risk-disclaimer",
        header: t("This Product is in beta."),
        subtitle: t("Once you enter a position, you cannot cancel or adjust it."),
        checks: [
            {
                key: "responsibility-checkbox",
                content: t("I understand that I am using this product at my own risk. Any losses incurred due to my actions are my own responsibility.")
            },
            {
                key: "beta-checkbox",
                content: t("I understand that this product is still in beta. I am participating at my own risk")
            }, 
        ],
        onSuccess: function() {
            return setHasAcceptedRisk(true);
        }
    }), false, false), 2), onPresentRiskDisclaimer = ref1[0], onDismiss = ref1[1];
    (0,react.useEffect)(function() {
        if (!hasAcceptedRisk) {
            onPresentRiskDisclaimer();
        }
        return function() {
            onDismiss();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasAcceptedRisk
    ]);
    return null;
}
/* harmony default export */ var components_RiskDisclaimer = (/*#__PURE__*/(0,react.memo)(RiskDisclaimer));

// EXTERNAL MODULE: ./src/views/Predictions/context/SwiperProvider.tsx
var SwiperProvider = __webpack_require__(69241);
// EXTERNAL MODULE: ./node_modules/split-grid/dist/split-grid.mjs
var split_grid = __webpack_require__(26741);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(78593);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/lodash/delay.js
var delay = __webpack_require__(98066);
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/components/Chart/ChartbyLabel.tsx







var ChartbyLabel_ChartByLabel = function(_param) {
    var symbol = _param.symbol, link = _param.link, by = _param.by, linkProps = _param.linkProps, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "symbol",
        "link",
        "by",
        "linkProps"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        px: "24px"
    }, props), {
        style: {
            background: theme.colors.modalBg
        },
        height: "30px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "14px",
                mr: "4px",
                children: [
                    symbol,
                    " ",
                    t("Chart"),
                    " ",
                    t("by")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                color: "alienPurple",
                fontSize: "14px",
                href: link,
                external: true
            }, linkProps), {
                children: by
            }))
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/TabToggle/index.tsx
var TabToggle = __webpack_require__(54757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/TradingView.tsx











/**
 * When the script tag is injected the TradingView object is not immediately
 * available on the window. So we listen for when it gets set
 */ var tradingViewListener = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return Object.defineProperty(window, "TradingView", {
                        configurable: true,
                        set: function set(value) {
                            this.tv = value;
                            resolve(value);
                        }
                    });
                })
            ];
        });
    });
    return function tradingViewListener() {
        return _ref.apply(this, arguments);
    };
}();
var initializeTradingView = function(TradingViewObj, theme, localeCode, opts) {
    var timezone = "Etc/UTC";
    try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
    // noop
    }
    /* eslint-disable new-cap */ /* eslint-disable no-new */ // @ts-ignore
    return new TradingViewObj.widget((0,src_object_spread/* default */.Z)({
        // Advanced Chart Widget uses the legacy embedding scheme,
        // an id property should be specified in the settings object
        id: opts.container_id,
        autosize: true,
        height: "100%",
        symbol: "BINANCE:BNBBUSD",
        interval: "5",
        timezone: timezone,
        theme: "dark",
        style: "1",
        locale: localeCode,
        toolbar_bg: "#f1f3f6",
        enable_publishing: false,
        allow_symbol_change: true,
        hide_side_toolbar: false,
        enabled_features: [
            "header_fullscreen_button"
        ]
    }, opts));
};
var TradingView = function(param) {
    var id = param.id, symbol = param.symbol;
    var currentLanguage = (0,localization_src/* useTranslation */.$G)().currentLanguage;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    (0,react.useEffect)(function() {
        var opts = {
            container_id: id,
            symbol: symbol
        };
        if (isMobile) {
            opts.hide_side_toolbar = true;
        }
        // @ts-ignore
        if (window.tv) {
            // @ts-ignore
            initializeTradingView(window.tv, theme, currentLanguage.code, opts);
        } else {
            tradingViewListener().then(function(tv) {
                initializeTradingView(tv, theme, currentLanguage.code, opts);
            });
        }
    // Ignore isMobile to avoid re-render TV
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        theme,
        currentLanguage,
        id,
        symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        overflow: "hidden",
        className: "tradingview_container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://s3.tradingview.com/tv.js",
                strategy: "lazyOnload",
                id: "tv.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: id
            })
        ]
    });
};
function useTradingViewEvent(param) {
    var id = param.id, onNoDataEvent = param.onNoDataEvent, onLoadedEvent = param.onLoadedEvent;
    useEffect(function() {
        var onNoDataAvailable = function(event) {
            var payload = event.data;
            if (payload.name === "tv-widget-no-data") {
                if (id && payload.frameElementId === id) {
                    onNoDataEvent === null || onNoDataEvent === void 0 ? void 0 : onNoDataEvent();
                }
            }
            if (payload.name === "tv-widget-load") {
                if (id && payload.frameElementId === id) {
                    onLoadedEvent === null || onLoadedEvent === void 0 ? void 0 : onLoadedEvent();
                }
            }
        };
        window.addEventListener("message", onNoDataAvailable);
        // eslint-disable-next-line consistent-return
        return function() {
            window.removeEventListener("message", onNoDataAvailable);
        };
    }, [
        id,
        onNoDataEvent,
        onLoadedEvent
    ]);
}
// Required to link to TradingView website for the widget
var TradingViewLabel = function(_param) {
    var symbol = _param.symbol, props = _object_without_properties(_param, [
        "symbol"
    ]);
    return /*#__PURE__*/ _jsx(ChartByLabel, _object_spread({
        link: "https://www.tradingview.com/symbols/".concat(symbol),
        symbol: symbol,
        by: "TradingView"
    }, props));
};
/* harmony default export */ var components_TradingView = (TradingView);

// EXTERNAL MODULE: ./src/views/Predictions/context/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(65238);
;// CONCATENATED MODULE: ./src/views/Predictions/components/TradingView.tsx



var TRADING_VIEW_COMPONENT_ID = "tradingview_b239c";
var TradingView_TradingView = function() {
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TradingView, {
        id: TRADING_VIEW_COMPONENT_ID,
        symbol: "COINBASE:ETHUSD"
    });
};
/* harmony default export */ var Predictions_components_TradingView = (TradingView_TradingView);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(87844);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/Notification.tsx

function Notification_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex: 1;\n  height: 100%;\n  justify-content: center;\n"
    ]);
    Notification_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 320px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 12px;\n  text-align: center;\n  width: 100%;\n  z-index: 5;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 120px;\n  width: 40%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae1d9a1d-0"
})(Notification_templateObject());
var CardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae1d9a1d-1"
})(_templateObject1());
var BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae1d9a1d-2"
})(_templateObject2());
var BackButtonStyle = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-ae1d9a1d-3"
})(_templateObject3());
var BackButton = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackButtonStyle, {
        variant: "primary",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                color: "white",
                mr: "8px"
            }),
            t("Back")
        ]
    });
};
var Notification = function(param) {
    var title = param.title, children = param.children;
    var router = (0,next_router.useRouter)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyDecoration, {
                    onClick: function() {
                        if (token.symbol === types/* PredictionSupportedSymbol.CAKE */.ru.CAKE) {
                            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
                        } else if (token.symbol === types/* PredictionSupportedSymbol.BNB */.ru.BNB) {
                            router.query.token = types/* PredictionSupportedSymbol.CAKE */.ru.CAKE;
                        }
                        router.push(router);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/check-your-network.png",
                        alt: "bunny decoration",
                        height: "121px",
                        width: "130px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mb: "24px",
                                children: title
                            }),
                            children
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Notification_Notification = (Notification);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/ErrorNotification.tsx






var ErrorNotification = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var handleOpenHistory = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Notification_Notification, {
        title: t("Error"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                mb: "24px",
                children: t("This page can’t be displayed right now due to an error. Please check back soon.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "primary",
                width: "100%",
                onClick: handleOpenHistory,
                children: t("Show History")
            })
        ]
    });
};
/* harmony default export */ var Notification_ErrorNotification = (ErrorNotification);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/PauseNotification.tsx






var PauseNotification = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var handleOpenHistory = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Notification_Notification, {
        title: t("Markets Paused"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        children: t("Prediction markets have been paused due to an error.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        children: t("All open positions have been cancelled.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        children: t("You can reclaim any funds entered into existing positions via the History tab on this page.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "primary",
                width: "100%",
                onClick: handleOpenHistory,
                children: t("Show History")
            })
        ]
    });
};
/* harmony default export */ var Notification_PauseNotification = (PauseNotification);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/index.tsx




// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx + 2 modules
var Spinner = __webpack_require__(69136);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./src/state/predictions/helpers.ts + 6 modules
var helpers = __webpack_require__(79279);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Wait.tsx
var Wait = __webpack_require__(13522);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PlayCircleOutline.tsx
var PlayCircleOutline = __webpack_require__(95703);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Info.tsx
var Info = __webpack_require__(95459);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(1274);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(57049);
// EXTERNAL MODULE: ./src/state/predictions/config.ts
var config = __webpack_require__(81272);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/helpers.ts


var formatUsd = function(usd, displayedDecimals) {
    return "$".concat((0,formatBalance/* formatNumber */.uf)(usd || 0, displayedDecimals, displayedDecimals));
};
var formatBnb = function(bnb, displayedDecimals) {
    return bnb ? bnb.toLocaleString(undefined, {
        minimumFractionDigits: displayedDecimals,
        maximumFractionDigits: displayedDecimals
    }) : "0";
};
var getMultiplier = function(total, amount) {
    if (total === 0 || amount === 0) {
        return 0;
    }
    return total / amount;
};
/**
 * Calculates the total payout given a bet
 */ var getPayout = function(bet) {
    var rewardRate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!bet || !bet.round) {
        return 0;
    }
    var _round = bet.round, bullAmount = _round.bullAmount, bearAmount = _round.bearAmount, totalAmount = _round.totalAmount;
    var multiplier = getMultiplier(totalAmount, bet.position === types/* BetPosition.BULL */.Tu.BULL ? bullAmount : bearAmount);
    return bet.amount * multiplier * rewardRate;
};
var getNetPayout = function(bet) {
    var rewardRate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!bet || !bet.round) {
        return 0;
    }
    var payout = getPayout(bet, rewardRate);
    return payout - bet.amount;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TrophyGold.tsx
var TrophyGold = __webpack_require__(56658);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(2629);
// EXTERNAL MODULE: ./src/hooks/useCallDefaultGasPrice.ts
var useCallDefaultGasPrice = __webpack_require__(91543);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(93146);
// EXTERNAL MODULE: ./src/utils/prices.ts
var prices = __webpack_require__(98045);
// EXTERNAL MODULE: ./src/views/Swap/components/AdvancedSwapDetails.tsx + 1 modules
var AdvancedSwapDetails = __webpack_require__(3252);
;// CONCATENATED MODULE: ./src/views/Predictions/components/CollectRoundWinningsModal.tsx







function CollectRoundWinningsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n"
    ]);
    CollectRoundWinningsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectRoundWinningsModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -116px; // line up bunny at the top of the modal\n  left: 0px;\n  text-align: center;\n  width: 100%;\n"
    ]);
    CollectRoundWinningsModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var Modal = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-d09973ae-0"
})(CollectRoundWinningsModal_templateObject());
var CollectRoundWinningsModal_BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d09973ae-1"
})(CollectRoundWinningsModal_templateObject1());
var calculateClaimableRounds = function(history) {
    if (!history) {
        return {
            epochs: [],
            total: 0
        };
    }
    return history.reduce(function(accum, bet) {
        if (!bet.claimed && bet.position === bet.round.position) {
            var betPayout = getPayout(bet, config/* REWARD_RATE */.Ck);
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, accum), {
                epochs: (0,_to_consumable_array/* default */.Z)(accum.epochs).concat([
                    bet.round.epoch
                ]),
                total: accum.total + betPayout
            });
        }
        return accum;
    }, {
        epochs: [],
        total: 0
    });
};
var CollectRoundWinningsModal = function(param) {
    var onDismiss = param.onDismiss, onSuccess = param.onSuccess, history = param.history, isLoadingHistory = param.isLoadingHistory, dispatch = param.dispatch, predictionsAddress = param.predictionsAddress, token = param.token, isV1Claim = param.isV1Claim;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, isPendingTx = ref.loading;
    var callNoGasPrice = (0,useCallDefaultGasPrice/* useCallNoGasPrice */.s)().callNoGasPrice;
    var predictionsContract = (0,useContract/* usePredictionsContract */.Tu)(predictionsAddress, token.symbol);
    var bnbBusdPrice = (0,useBUSDPrice/* default */.ZP)(token);
    var ref1 = calculateClaimableRounds(history), epochs = ref1.epochs, total = ref1.total;
    var totalBnb = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, total);
    var isLoading = isLoadingHistory || !(epochs === null || epochs === void 0 ? void 0 : epochs.length);
    (0,react.useEffect)(function() {
        // Fetch history if they have not opened the history pane yet
        if (history.length === 0 && !isV1Claim) {
            dispatch((0,predictions/* fetchNodeHistory */.uP)({
                account: account
            }));
        }
    }, [
        account,
        history,
        dispatch,
        isV1Claim
    ]);
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callNoGasPrice(predictionsContract, "claim", [
                                    epochs
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (!(receipt === null || receipt === void 0 ? void 0 : receipt.status)) return [
                            3,
                            3
                        ];
                        if (!isV1Claim) {
                            // Immediately mark rounds as claimed
                            dispatch((0,predictions/* markAsCollected */.WB)(epochs.reduce(function(accum, epoch) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, epoch, true));
                            }, {})));
                        }
                        return [
                            4,
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess()
                        ];
                    case 2:
                        _state.sent();
                        toastSuccess(t("Winnings collected!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("Your prizes have been sent to your wallet")
                        }));
                        onDismiss();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        $minWidth: "288px",
        position: "relative",
        mt: "124px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: t("Collect Winnings")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px 20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrophyGold/* default */.Z, {
                        width: "96px",
                        mx: "auto",
                        mb: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
                        showBorderBottom: true,
                        showBorderTop: true,
                        isSmall: true,
                        mb: "8px",
                        style: {
                            height: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                children: t("Collecting")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                style: {
                                    textAlign: "right"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "".concat((0,formatBalance/* formatNumber */.uf)(total, 0, 4), " ").concat(token.symbol)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        children: "~$".concat(totalBnb.toFixed(2))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "start",
                        justifyContent: "center",
                        mb: "24px",
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            height: "21",
                            width: "140px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            fontSize: "14px",
                            children: epochs.length === 1 ? t("From round %round%", {
                                round: epochs[0]
                            }) : t("From rounds %rounds%", {
                                rounds: epochs.join(", ")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        mb: "8px",
                        onClick: handleClick,
                        isLoading: isPendingTx || isLoading,
                        endIcon: isPendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }) : null,
                        children: t("Confirm")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CollectRoundWinningsModal = (CollectRoundWinningsModal);

;// CONCATENATED MODULE: ./src/views/Predictions/components/CollectWinningsButton.tsx










var CollectWinningsButton = function(_param) {
    var hasClaimed = _param.hasClaimed, onSuccess = _param.onSuccess, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "hasClaimed",
        "onSuccess",
        "children"
    ]);
    var ref = (0,predictions_hooks/* useCollectWinningModalProps */.Dh)(), history = ref.history, isLoadingHistory = ref.isLoadingHistory;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), predictionsAddress = ref1.address, token = ref1.token;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectRoundWinningsModal, {
        dispatch: dispatch,
        history: history,
        isLoadingHistory: isLoadingHistory,
        onSuccess: onSuccess,
        predictionsAddress: predictionsAddress,
        token: token
    }), false, true, "CollectRoundWinningsModal"), 1), onPresentCollectWinningsModal = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: onPresentCollectWinningsModal,
        disabled: hasClaimed
    }, props), {
        children: children
    }));
};
/* harmony default export */ var components_CollectWinningsButton = (CollectWinningsButton);

;// CONCATENATED MODULE: ./src/views/Predictions/components/ReclaimPositionButton.tsx













var ReclaimPositionButton = function(_param) {
    var epoch = _param.epoch, onSuccess = _param.onSuccess, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "epoch",
        "onSuccess",
        "children"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), predictionsAddress = ref.address;
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var predictionsContract = (0,useContract/* usePredictionsContract */.Tu)(predictionsAddress, token.symbol);
    var callNoGasPrice = (0,useCallDefaultGasPrice/* useCallNoGasPrice */.s)().callNoGasPrice;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref1 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, isPendingTx = ref1.loading;
    var handleReclaim = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callNoGasPrice(predictionsContract, "claim", [
                                    [
                                        epoch
                                    ]
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (!(receipt === null || receipt === void 0 ? void 0 : receipt.status)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess()
                        ];
                    case 2:
                        _state.sent();
                        toastSuccess(t("Position reclaimed!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReclaim() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: handleReclaim,
        isLoading: isPendingTx,
        endIcon: isPendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "white"
        }) : null
    }, props), {
        children: children || t("Reclaim Position")
    }));
};
/* harmony default export */ var components_ReclaimPositionButton = (ReclaimPositionButton);

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/views/Predictions/helpers.ts
var Predictions_helpers = __webpack_require__(62682);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(40696);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUpPrediction.tsx
var ArrowUpPrediction = __webpack_require__(90634);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDownPrediction.tsx
var ArrowDownPrediction = __webpack_require__(39964);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
;// CONCATENATED MODULE: ./src/views/Predictions/components/PositionTag.tsx




function PositionTag_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n"
    ]);
    PositionTag_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledTag = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4c64acb3-0"
})(PositionTag_templateObject());
var Tag = function(_param) {
    var _bg = _param.bg, bg = _bg === void 0 ? "success" : _bg, startIcon = _param.startIcon, children = _param.children, onClick = _param.onClick, isUpPosition = _param.isUpPosition, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "bg",
        "startIcon",
        "children",
        "onClick",
        "isUpPosition"
    ]);
    var icon = startIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
        color: "white"
    });
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTag, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        bg: bg,
        py: "4px",
        px: "8px",
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : "normal"
        }
    }, props), {
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: "syncopate",
                fontWeight: 700,
                textTransform: "uppercase",
                color: isUpPosition ? theme.colors.success : theme.colors.failure,
                ml: "4px",
                children: children
            })
        ]
    }));
};
var PositionTag = function(_param) {
    var betPosition = _param.betPosition, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "betPosition",
        "children"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isUpPosition = betPosition === types/* BetPosition.BULL */.Tu.BULL;
    var icon = isUpPosition ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpPrediction/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownPrediction/* default */.Z, {});
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Neither side wins this round")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The Locked Price & Closed Price are exactly the same (within 8 decimals), so neither side wins. All funds entered into UP and DOWN positions will go to the weekly CAKE burn.")
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    if (betPosition === types/* BetPosition.HOUSE */.Tu.HOUSE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tooltipVisible && tooltip,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                    ref: targetRef,
                    color: "secondary",
                    fontWeight: "300",
                    textTransform: "uppercase",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            t("To Burn"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                width: "16px",
                                ml: "4px",
                                color: "secondary"
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        isUpPosition: isUpPosition,
        bg: "transparent",
        startIcon: icon
    }, props), {
        children: children
    }));
};
/* harmony default export */ var components_PositionTag = (PositionTag);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/styles.tsx




function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  padding: 0px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 14px;\n  padding: 16px 0px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var getPrizePoolAmount = function(totalAmount, displayedDecimals) {
    if (!totalAmount) {
        return "0";
    }
    return (0,Predictions_helpers/* formatBnbv2 */.rc)(totalAmount, displayedDecimals);
};
var Row = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "space-between"
    }, props), {
        children: children
    }));
};
var PrizePoolRow = function(_param) {
    var totalAmount = _param.totalAmount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "totalAmount"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        my: "20px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "18px",
                color: "textSubtle",
                children: [
                    t("Prize Pool"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "18px",
                children: "".concat(getPrizePoolAmount(totalAmount, displayedDecimals), " ").concat(token.symbol)
            })
        ]
    }));
};
var PayoutRow = function(_param) {
    var positionLabel = _param.positionLabel, multiplier = _param.multiplier, amount = _param.amount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "positionLabel",
        "multiplier",
        "amount"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var formattedMultiplier = "".concat(multiplier.toLocaleString(undefined, {
        maximumFractionDigits: 2
    }), "x");
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
        isSmall: true,
        showBorderBottom: true,
        showBorderTop: positionLabel === "up",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: "14px",
                textTransform: "uppercase",
                children: [
                    positionLabel,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        lineHeight: "14px",
                        children: t("%multiplier% Payout", {
                            multiplier: formattedMultiplier
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mx: "4px",
                        children: "|"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        lineHeight: "14px",
                        children: "".concat(formatBnb(amount, displayedDecimals), " ").concat(token.symbol)
                    })
                ]
            })
        ]
    });
};
var LockPriceRow = function(_param) {
    var lockPrice = _param.lockPrice, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "lockPrice"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), displayedDecimals = ref.displayedDecimals, minPriceUsdDisplayed = ref.minPriceUsdDisplayed;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        pb: "10px",
        mb: "-10px",
        style: {
            borderBottom: "1px solid ".concat(theme.colors.cardBorder)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "18px",
                children: [
                    t("Locked Price"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "18px",
                children: (0,Predictions_helpers/* formatUsdv2 */.pf)(lockPrice, minPriceUsdDisplayed, displayedDecimals)
            })
        ]
    }));
};
var getBackgroundColor = function(param) {
    var theme = param.theme, betPosition = param.betPosition, isNext = param.isNext, isLive = param.isLive, hasEntered = param.hasEntered;
    if (isNext) {
        return "linear-gradient(180deg, #53DEE9 0%, #7645D9 100%)";
    }
    if (hasEntered || isLive) {
        return theme.colors.secondary;
    }
    switch(betPosition){
        case BetPosition.BULL:
            return theme.colors.success;
        case BetPosition.BEAR:
            return theme.colors.failure;
        case BetPosition.HOUSE:
            return theme.colors.textDisabled;
        default:
            return theme.colors.cardBorder;
    }
};
var Background = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-75419c31-0"
})(styles_templateObject());
var StyledRoundResultBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-75419c31-1"
})(styles_templateObject1());
var RoundResultBox = function(_param) {
    var _isNext = _param.isNext, isNext = _isNext === void 0 ? false : _isNext, _hasEntered = _param.hasEntered, hasEntered = _hasEntered === void 0 ? false : _hasEntered, _isLive = _param.isLive, isLive = _isLive === void 0 ? false : _isLive, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isNext",
        "hasEntered",
        "isLive",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        isNext: isNext,
        hasEntered: hasEntered,
        isLive: isLive
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRoundResultBox, {
            children: children
        })
    }));
};
var RoundPrice = function(param) {
    var lockPrice = param.lockPrice, closePrice = param.closePrice;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), displayedDecimals = ref.displayedDecimals, minPriceUsdDisplayed = ref.minPriceUsdDisplayed;
    var betPosition = (0,Predictions_helpers/* getRoundPosition */.XW)(lockPrice, closePrice);
    var priceDifference = (0,Predictions_helpers/* getPriceDifference */.kJ)(closePrice, lockPrice);
    var textColor = (0,react.useMemo)(function() {
        switch(betPosition){
            case types/* BetPosition.BULL */.Tu.BULL:
                return "success";
            case types/* BetPosition.BEAR */.Tu.BEAR:
                return "failure";
            case types/* BetPosition.HOUSE */.Tu.HOUSE:
            default:
                return "textDisabled";
        }
    }, [
        betPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        mb: "16px",
        height: "36px",
        children: [
            closePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: textColor,
                fontWeight: 700,
                fontSize: "18px",
                className: "syncopate",
                children: (0,Predictions_helpers/* formatUsdv2 */.pf)(closePrice, minPriceUsdDisplayed, displayedDecimals)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                height: "34px",
                my: "1px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                betPosition: betPosition,
                children: (0,Predictions_helpers/* formatUsdv2 */.pf)(priceDifference, minPriceUsdDisplayed, displayedDecimals)
            })
        ]
    });
};
var getPrizePoolAmountHistory = function(totalAmount, displayedDecimals) {
    if (!totalAmount) {
        return "0";
    }
    return formatBnb(totalAmount, displayedDecimals);
};
var PrizePoolHistoryRow = function(_param) {
    var totalAmount = _param.totalAmount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "totalAmount"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
        isSmall: true,
        showBorderBottom: true,
        showBorderTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: "14px",
                children: [
                    t("Prize Pool"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                children: "".concat(getPrizePoolAmountHistory(totalAmount, displayedDecimals), " ").concat(token.symbol)
            })
        ]
    });
};
var LockPriceHistoryRow = function(_param) {
    var lockPrice = _param.lockPrice, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "lockPrice"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var displayedDecimals = (0,ConfigProvider/* useConfig */.ZR)().displayedDecimals;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
        isSmall: true,
        showBorderBottom: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: "14px",
                children: [
                    t("Locked Price"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                children: formatUsd(lockPrice, displayedDecimals)
            })
        ]
    });
} /**
 * END TEMPORARY COMPONENTS
 */ ;

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/RoundResult.tsx








var RoundResult = function(_param) {
    var round = _param.round, _hasFailed = _param.hasFailed, hasFailed = _hasFailed === void 0 ? false : _hasFailed, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "round",
        "hasFailed",
        "children"
    ]);
    var lockPrice = round.lockPrice, closePrice = round.closePrice, totalAmount = round.totalAmount;
    var betPosition = (0,Predictions_helpers/* getRoundPosition */.XW)(lockPrice, closePrice);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultBox, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        betPosition: betPosition
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                fontWeight: 500,
                fontSize: "14px",
                bold: true,
                textTransform: "uppercase",
                mb: "8px",
                children: t("Closed Price")
            }),
            hasFailed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                textTransform: "uppercase",
                color: "textDisabled",
                mb: "16px",
                fontSize: "24px",
                children: t("Cancelled")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundPrice, {
                lockPrice: lockPrice,
                closePrice: closePrice
            }),
            lockPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockPriceRow, {
                lockPrice: lockPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                totalAmount: totalAmount
            }),
            children
        ]
    }));
};
/* harmony default export */ var RoundResult_RoundResult = (RoundResult);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/RoundResultHistory.tsx











var RoundResultHistory_RoundResult = function(_param) {
    var round = _param.round, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "round",
        "children"
    ]);
    var displayedDecimals = (0,ConfigProvider/* useConfig */.ZR)().displayedDecimals;
    var lockPrice = round.lockPrice, closePrice = round.closePrice, totalAmount = round.totalAmount;
    var betPosition = closePrice > lockPrice ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR;
    var isPositionUp = betPosition === types/* BetPosition.BULL */.Tu.BULL;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var priceDifference = closePrice - lockPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultBox, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        betPosition: betPosition
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
                isSmall: true,
                showBorderTop: true,
                showBorderBottom: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        fontSize: "14px",
                        children: t("Closed Price")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: isPositionUp ? "success" : "failure",
                        bold: true,
                        fontSize: "14px",
                        children: formatUsd(closePrice, displayedDecimals)
                    })
                ]
            }),
            lockPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockPriceHistoryRow, {
                lockPrice: lockPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolHistoryRow, {
                totalAmount: totalAmount
            }),
            children
        ]
    }));
};
/* harmony default export */ var RoundResultHistory = (RoundResultHistory_RoundResult);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/index.tsx




// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Prize.tsx
var Prize = __webpack_require__(98468);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Block.tsx
var Block = __webpack_require__(31246);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 34 modules
var contractHelpers = __webpack_require__(49592);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useIsRefundable.ts






var useIsRefundable = function(epoch) {
    var ref = (0,react.useState)(false), isRefundable = ref[0], setIsRefundable = ref[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var address = (0,ConfigProvider/* useConfig */.ZR)().address;
    (0,react.useEffect)(function() {
        var fetchRefundableStatus = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var predictionsContract, refundable, ledger;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            predictionsContract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                            return [
                                4,
                                predictionsContract.refundable(epoch, account)
                            ];
                        case 1:
                            refundable = _state.sent();
                            if (!refundable) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                predictionsContract.ledger(epoch, account)
                            ];
                        case 2:
                            ledger = _state.sent();
                            setIsRefundable(ledger.claimed === false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setIsRefundable(false);
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchRefundableStatus() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) {
            fetchRefundableStatus();
        }
    }, [
        account,
        epoch,
        setIsRefundable,
        address
    ]);
    return {
        isRefundable: isRefundable,
        setIsRefundable: setIsRefundable
    };
};
/* harmony default export */ var hooks_useIsRefundable = (useIsRefundable);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/BetResult.tsx




function BetResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    BetResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-5a48d37-0"
})(BetResult_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var BetResult = function(param) {
    var bet = param.bet, result = param.result;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var isRefundable = hooks_useIsRefundable(bet.round.epoch).isRefundable;
    var canClaim = (0,predictions_hooks/* useGetIsClaimable */.Wx)(bet.round.epoch);
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var bnbBusdPrice = (0,useBUSDPrice/* default */.ZP)(token);
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        as: "p",
        children: t("Includes your original position and your winnings, minus the %fee% fee.", {
            fee: "3%"
        })
    }), {
        placement: "auto"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var isWinner = result === helpers/* Result.WIN */.x4.WIN;
    // Winners get the payout, otherwise the claim what they put it if it was canceled
    var payout = isWinner ? getNetPayout(bet, config/* REWARD_RATE */.Ck) : bet.amount;
    var totalPayout = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, payout);
    var returned = payout + bet.amount;
    var headerColor = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return "yellow";
            case helpers/* Result.LOSE */.x4.LOSE:
                return "textSubtle";
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return "textDisabled";
            case helpers/* Result.HOUSE */.x4.HOUSE:
                return "textDisabled";
            default:
                return "text";
        }
    }, [
        result
    ]);
    var headerText = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return t("Win");
            case helpers/* Result.LOSE */.x4.LOSE:
                return t("Lose");
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return t("Cancelled");
            case helpers/* Result.HOUSE */.x4.HOUSE:
                return t("To Burn");
            default:
                return "";
        }
    }, [
        t,
        result
    ]);
    var headerIcon = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Prize/* default */.Z, {
                    color: theme.colors.yellow
                });
            case helpers/* Result.LOSE */.x4.LOSE:
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                    color: headerColor
                });
            default:
                return null;
        }
    }, [
        result,
        headerColor
    ]);
    var resultColor = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return "success";
            case helpers/* Result.LOSE */.x4.LOSE:
                return "failure";
            case helpers/* Result.CANCELED */.x4.CANCELED:
            case helpers/* Result.HOUSE */.x4.HOUSE:
            default:
                return "text";
        }
    }, [
        result
    ]);
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // We have to mark the bet as claimed immediately because it does not update fast enough
                dispatch((0,predictions/* markAsCollected */.WB)((0,_define_property/* default */.Z)({}, bet.round.epoch, true)));
                dispatch((0,predictions/* fetchLedgerData */.Ub)({
                    account: account,
                    epochs: [
                        bet.round.epoch
                    ]
                }));
                return [
                    2
                ];
            });
        });
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "18px",
                        fontWeight: 500,
                        children: t("Your History")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h3",
                                color: headerColor,
                                textTransform: "uppercase",
                                bold: true,
                                mr: "4px",
                                children: headerText
                            }),
                            headerIcon
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                children: [
                    bet.claimed && bet.claimedHash && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                            href: (0,utils/* getBlockExploreLink */.C)(bet.claimedHash, "transaction"),
                            mb: "16px",
                            children: t("View on BscScan")
                        })
                    }),
                    result === helpers/* Result.CANCELED */.x4.CANCELED && isRefundable && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReclaimPositionButton, {
                        epoch: bet.round.epoch,
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
                        isSmall: true,
                        showBorderBottom: true,
                        showBorderTop: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "14px",
                                children: [
                                    t("Your direction"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                                betPosition: bet.position,
                                children: bet.position === types/* BetPosition.BULL */.Tu.BULL ? t("Up") : t("Down")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
                        isSmall: true,
                        showBorderBottom: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "14px",
                                children: t("Your position")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "".concat(formatBnb(bet.amount, displayedDecimals), " ").concat(token.symbol)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
                        style: {
                            height: "auto"
                        },
                        isSmall: true,
                        showBorderBottom: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "14px",
                                children: [
                                    isWinner ? t("Your winnings") : t("Your Result"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                style: {
                                    textAlign: "right"
                                },
                                py: "5px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: resultColor,
                                        children: "".concat(isWinner ? "+" : "-").concat(formatBnb(payout, displayedDecimals), " ").concat(token.symbol)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        children: "~$".concat(totalPayout.toFixed(2))
                                    })
                                ]
                            })
                        ]
                    }),
                    isWinner && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSwapDetails/* StyledRowBorders */.S, {
                            showBorderBottom: true,
                            isSmall: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: [
                                        t("Amount to collect"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    justifyContent: "end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "text",
                                        children: "".concat(formatBnb(returned, displayedDecimals), " ").concat(token.symbol)
                                    })
                                }),
                                tooltipVisible && tooltip
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var History_BetResult = (BetResult);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/BetDetails.tsx

function BetDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-bottom: 2px solid ",
        ";\n  padding: 10px 20px;\n"
    ]);
    BetDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledBetDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4dfff6d-0"
})(BetDetails_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var BetDetails = function(param) {
    var bet = param.bet, result = param.result;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var _round = bet.round, totalAmount = _round.totalAmount, bullAmount = _round.bullAmount, bearAmount = _round.bearAmount;
    var bullMultiplier = getMultiplier(totalAmount, bullAmount);
    var bearMultiplier = getMultiplier(totalAmount, bearAmount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetDetails, {
        children: [
            result === helpers/* Result.CANCELED */.x4.CANCELED && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                color: "failure",
                mb: "24px",
                children: t("This round was automatically cancelled due to an error. If you entered a position, please reclaim your funds below.")
            }),
            result !== helpers/* Result.LIVE */.x4.LIVE && /*#__PURE__*/ (0,jsx_runtime.jsx)(History_BetResult, {
                bet: bet,
                result: result
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "8px",
                mt: "20px",
                children: t("Round History")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultHistory, {
                round: bet.round,
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutRow, {
                        positionLabel: t("Up"),
                        multiplier: bullMultiplier,
                        amount: bullAmount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutRow, {
                        positionLabel: t("Down"),
                        multiplier: bearMultiplier,
                        amount: bearAmount
                    })
                ]
            }),
            bet.round.lockBlock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Opening Block")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: (0,utils/* getBlockExploreLink */.C)(bet.round.lockBlock, "block"),
                        external: true,
                        children: bet.round.lockBlock
                    })
                ]
            }),
            bet.round.closeBlock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Closing Block")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: (0,utils/* getBlockExploreLink */.C)(bet.round.closeBlock, "block"),
                        external: true,
                        children: bet.round.closeBlock
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var History_BetDetails = (BetDetails);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/HistoricalBet.tsx




function HistoricalBet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n  transition: background-color 200ms ease-in-out;\n  &:hover {\n    background-color: ",
        ";\n  }\n\n"
    ]);
    HistoricalBet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HistoricalBet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    HistoricalBet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var StyledBet = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    alignItems: "center",
    p: "16px"
}).withConfig({
    componentId: "sc-5b47fe8b-0"
})(HistoricalBet_templateObject(), function(param) {
    var theme = param.theme, isOpen = param.isOpen;
    return isOpen ? theme.colors.borderModal : theme.colors.modalBg;
}, function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
}, function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
});
var YourResult = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-5b47fe8b-1"
})(HistoricalBet_templateObject1());
var HistoricalBet = function(param) {
    var bet = param.bet;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var amount = bet.amount, round = bet.round;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Neither side wins this round")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The Locked Price & Closed Price are exactly the same (within 8 decimals), so neither side wins. All funds entered into UP and DOWN positions will go to the weekly CAKE burn.")
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var canClaim = (0,predictions_hooks/* useGetIsClaimable */.Wx)(bet.round.epoch);
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var displayedDecimals = (0,ConfigProvider/* useConfig */.ZR)().displayedDecimals;
    var toggleOpen = function() {
        return setIsOpen(!isOpen);
    };
    var getRoundColor = function(result) {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return "success";
            case helpers/* Result.LOSE */.x4.LOSE:
                return "failure";
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return "textSubtle";
            case helpers/* Result.HOUSE */.x4.HOUSE:
                return "textSubtle";
            default:
                return "text";
        }
    };
    var getRoundPrefix = function(result) {
        if (result === helpers/* Result.LOSE */.x4.LOSE) {
            return "-";
        }
        if (result === helpers/* Result.WIN */.x4.WIN) {
            return "+";
        }
        return "";
    };
    var roundResult = (0,helpers/* getRoundResult */.yz)(bet, currentEpoch);
    var resultTextColor = getRoundColor(roundResult);
    var resultTextPrefix = getRoundPrefix(roundResult);
    var isOpenRound = round.epoch === currentEpoch;
    var isLiveRound = status === types/* PredictionStatus.LIVE */.Gw.LIVE && round.epoch === currentEpoch - 1;
    // Winners get the payout, otherwise the claim what they put it if it was canceled
    var payout = roundResult === helpers/* Result.WIN */.x4.WIN ? getNetPayout(bet, config/* REWARD_RATE */.Ck) : amount;
    var renderBetLabel = function() {
        if (isOpenRound) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wait/* default */.Z, {
                        color: "primary",
                        mr: "6px",
                        width: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "primary",
                        bold: true,
                        children: t("Starting Soon")
                    })
                ]
            });
        }
        if (isLiveRound) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutline/* default */.Z, {
                        color: "secondary",
                        mr: "6px",
                        width: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        bold: true,
                        children: t("Live Now")
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    children: t("Your Result")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    bold: true,
                    color: resultTextColor,
                    lineHeight: 1,
                    children: roundResult === helpers/* Result.CANCELED */.x4.CANCELED ? t("Cancelled") : roundResult === helpers/* Result.HOUSE */.x4.HOUSE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            tooltipVisible && tooltip,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                ref: targetRef,
                                children: [
                                    t("To Burn"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                        width: "16px",
                                        ml: "4px",
                                        color: "secondary"
                                    })
                                ]
                            })
                        ]
                    }) : "".concat(resultTextPrefix).concat(formatBnb(payout, displayedDecimals))
                })
            ]
        });
    };
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // We have to mark the bet as claimed immediately because it does not update fast enough
                dispatch((0,predictions/* markAsCollected */.WB)((0,_define_property/* default */.Z)({}, bet.round.epoch, true)));
                dispatch((0,predictions/* fetchLedgerData */.Ub)({
                    account: account,
                    epochs: [
                        bet.round.epoch
                    ]
                }));
                return [
                    2
                ];
            });
        });
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBet, {
                onClick: toggleOpen,
                role: "button",
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        width: "48px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            textAlign: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    textAlign: "left",
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    children: t("Round")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    textAlign: "left",
                                    lineHeight: 1,
                                    children: round.epoch.toLocaleString()
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YourResult, {
                        px: "24px",
                        children: renderBetLabel()
                    }),
                    roundResult === helpers/* Result.WIN */.x4.WIN && canClaim && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectWinningsButton, {
                        style: {
                            fontSize: "14px",
                            fontWeight: 500,
                            textTransform: "capitalize",
                            fontFamily: "DM Sans"
                        },
                        hasClaimed: !canClaim,
                        onSuccess: handleSuccess,
                        scale: "sm",
                        mr: "8px",
                        children: t("Collect")
                    }),
                    roundResult === helpers/* Result.CANCELED */.x4.CANCELED && canClaim && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReclaimPositionButton, {
                        epoch: bet.round.epoch,
                        scale: "sm",
                        mr: "8px",
                        children: t("Reclaim")
                    }),
                    !isOpenRound && !isLiveRound && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        style: {
                            border: "none"
                        },
                        variant: "text",
                        scale: "sm",
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(History_BetDetails, {
                bet: bet,
                result: (0,helpers/* getRoundResult */.yz)(bet, currentEpoch)
            })
        ]
    });
};
/* harmony default export */ var History_HistoricalBet = (HistoricalBet);

// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(51983);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(81641);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/Header.tsx



function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n  display: inline-flex;\n  margin-right: 16px;\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  flex: none;\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n  width: 100%;\n  & > div {\n    width: 100%;\n  }\n\n  & button {\n    width: 100%;\n  }\n  div {\n    background: none;\n  }\n"
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-radius: 0;\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: -1px;\n  width: 50%;\n"
    ]);
    Header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n  align-items: center;\n  gap: 0px;\n  padding: 20px;\n  margin: auto auto 20px auto;\n  > button {\n    &:active {\n      box-shadow: 0px 0px 0px 1px ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var Filter = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-6abc7a24-0"
})(Header_templateObject());
var StyledHeader = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-6abc7a24-1"
})(Header_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.modalBg;
});
var ButtonMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6abc7a24-2"
})(Header_templateObject2());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenuItem/* default */.Z).withConfig({
    componentId: "sc-6abc7a24-3"
})(Header_templateObject3());
var ButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6abc7a24-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.alienPurple;
});
var HistoryTabs;
(function(HistoryTabs) {
    HistoryTabs[HistoryTabs["ROUNDS"] = 0] = "ROUNDS";
    HistoryTabs[HistoryTabs["PNL"] = 1] = "PNL";
})(HistoryTabs || (HistoryTabs = {}));
var Header = function(param) {
    var activeTab = param.activeTab, setActiveTab = param.setActiveTab;
    var historyFilter = (0,predictions_hooks/* useGetHistoryFilter */.J7)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleClick = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(false));
    };
    var handleChange = function(newFilter) {
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (newFilter !== historyFilter) {
                    dispatch((0,predictions/* setHistoryFilter */.Yq)(newFilter));
                }
                return [
                    2
                ];
            });
        });
    };
    var switchTab = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tabIndex) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setActiveTab(tabIndex);
                        return [
                            4,
                            handleChange(types/* HistoryFilter.ALL */.dZ.ALL)()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function switchTab(tabIndex) {
            return _ref.apply(this, arguments);
        };
    }();
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                px: "20px",
                alignItems: "center",
                justifyContent: "space-between",
                style: {
                    borderBottom: "1px solid ".concat(theme.colors.borderModal),
                    borderTop: "1px solid ".concat(theme.colors.borderModal)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h3",
                        size: "md",
                        children: t("History")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleClick,
                        variant: "text",
                        px: "0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            color: "text",
                            width: "24px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        isActive: activeTab === HistoryTabs.ROUNDS,
                        onClick: function() {
                            return setActiveTab(HistoryTabs.ROUNDS);
                        },
                        children: t("Rounds")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        isActive: activeTab === HistoryTabs.PNL,
                        onClick: function() {
                            return setActiveTab(HistoryTabs.PNL);
                        },
                        children: t("PNL")
                    })
                ]
            }),
            activeTab === HistoryTabs.ROUNDS && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "center",
                    mb: "20px",
                    width: "100%",
                    px: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            side: "left",
                            width: "33%",
                            isActive: historyFilter === types/* HistoryFilter.ALL */.dZ.ALL,
                            disabled: isFetchingHistory || !account,
                            onClick: handleChange(types/* HistoryFilter.ALL */.dZ.ALL),
                            children: t("All")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            side: "center",
                            width: "33%",
                            isActive: historyFilter === types/* HistoryFilter.COLLECTED */.dZ.COLLECTED,
                            disabled: isFetchingHistory || !account,
                            onClick: handleChange(types/* HistoryFilter.COLLECTED */.dZ.COLLECTED),
                            children: t("Collected")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            side: "right",
                            width: "33%",
                            isActive: historyFilter === types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED,
                            disabled: isFetchingHistory || !account,
                            onClick: handleChange(types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED),
                            children: t("Uncollected")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var History_Header = (Header);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/index.tsx



// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(37303);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(69117);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 7 modules
var tokens_src = __webpack_require__(48872);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(8414);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
;// CONCATENATED MODULE: ./src/views/Predictions/components/v1/helpers.ts



function helpers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getV1BetHistory($skip: Int!, $where: Bet_filter) {\n        bets(first: 1000, skip: $skip, where: $where, orderBy: createdAt, orderDirection: desc) {\n          hash\n          amount\n          position\n          claimed\n          claimedAmount\n          claimedHash\n          round {\n            epoch\n            bullAmount\n            bearAmount\n            position\n            failed\n            totalAmount\n            lockPrice\n            closePrice\n            totalBets\n            totalAmount\n          }\n        }\n      }\n    "
    ]);
    helpers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getV1History = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var skip, where, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skip = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0, where = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    return [
                        4,
                        dist_default()(endpoints/* GRAPH_API_PREDICTION_V1 */.Kt, (0,dist.gql)(helpers_templateObject()), {
                            skip: skip,
                            where: where
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.bets
                    ];
            }
        });
    });
    return function getV1History() {
        return _ref.apply(this, arguments);
    };
}();
var getAllV1History = function() {
    var where = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new Promise(function(resolve, reject) {
        var bets = {};
        var getHistoryChunk = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(skip) {
                var betHistory, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                getV1History(skip, where)
                            ];
                        case 1:
                            betHistory = _state.sent();
                            bets[skip] = betHistory;
                            if (betHistory.length === 0) {
                                resolve(flatten_default()(Object.values(bets)));
                            } else {
                                getHistoryChunk(skip + 1000);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            reject(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getHistoryChunk(skip) {
                return _ref.apply(this, arguments);
            };
        }();
        getHistoryChunk(0);
    });
};

;// CONCATENATED MODULE: ./src/views/Predictions/components/v1/NothingToClaimModal.tsx




function NothingToClaimModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n"
    ]);
    NothingToClaimModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NothingToClaimModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -116px; // line up bunny at the top of the modal\n  left: 0px;\n  text-align: center;\n  width: 100%;\n"
    ]);
    NothingToClaimModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var NothingToClaimModal_Modal = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-71e37b67-0"
})(NothingToClaimModal_templateObject());
var NothingToClaimModal_BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71e37b67-1"
})(NothingToClaimModal_templateObject1());
var NothingToClaimModal_CollectRoundWinningsModal = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,react.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react.useState)([]), history = ref1[0], setHistory = ref1[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleClick = function() {
        var header = [
            "Round",
            "Result",
            "Your Position",
            "Bet Amount",
            "Transaction",
            "Claimed Transaction",
            "Lock Price",
            "Close Price",
            "Total Bets",
            "Total Amount",
            "Round Failed", 
        ].join(",");
        var rows = history.reduce(function(accum, bet) {
            return (0,_to_consumable_array/* default */.Z)(accum).concat([
                [
                    bet.round.epoch,
                    bet.round.position,
                    bet.position,
                    bet.amount,
                    bet.hash,
                    bet.claimedHash || "",
                    bet.round.lockPrice,
                    bet.round.closePrice,
                    bet.round.totalBets,
                    bet.round.totalAmount,
                    bet.round.failed, 
                ].join(","), 
            ]);
        }, []);
        var anchor = document.createElement("a");
        var blob = new Blob([
            "".concat(header, "\n").concat(rows.join("\n"))
        ], {
            type: "text/csv;charset=utf-8;"
        });
        anchor.href = URL.createObjectURL(blob);
        anchor.target = "_blank";
        anchor.download = "pancakeswap-prediction-v1-history.csv";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };
    (0,react.useEffect)(function() {
        var fetchAllHistory = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsFetching(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                getAllV1History({
                                    user: account.toLowerCase()
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            setHistory(response);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Unable to fetch history", error);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsFetching(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAllHistory() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) {
            fetchAllHistory();
        }
    }, [
        account,
        setHistory,
        setIsFetching
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NothingToClaimModal_Modal, {
        $minWidth: "288px",
        position: "relative",
        mt: "124px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NothingToClaimModal_BunnyDecoration, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/decorations/prize-bunny.png",
                    alt: "bunny decoration",
                    height: "124px",
                    width: "168px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: t("Nothing to Collect")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px 20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        fontSize: "14px",
                        children: t("You have no unclaimed v0.1 prizes.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        fontSize: "14px",
                        mb: "24px",
                        children: t("Download your v0.1 Prediction history below.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleClick,
                        isLoading: isFetching,
                        endIcon: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            width: "24px",
                            color: "white"
                        }) : null,
                        children: t("Download .CSV")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NothingToClaimModal = (NothingToClaimModal_CollectRoundWinningsModal);

;// CONCATENATED MODULE: ./src/views/Predictions/components/v1/V1ClaimCheck.tsx




function V1ClaimCheck_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n  justify-content: space-between;\n  padding: 16px;\n"
    ]);
    V1ClaimCheck_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var StyledClaimCheck = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b2c1b7c-0"
})(V1ClaimCheck_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ClaimCheck = function() {
    var ref = (0,react.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react.useState)([]), history = ref1[0], setHistory = ref1[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var predictionsV1Address = (0,react.useMemo)(function() {
        return (0,addressHelpers/* getPredictionsV1Address */.wA)();
    }, []);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectRoundWinningsModal, {
        predictionsAddress: predictionsV1Address,
        token: tokens_src/* bscTokens.bnb */.ds.bnb,
        dispatch: dispatch,
        history: history,
        isLoadingHistory: isFetching,
        isV1Claim: true
    }), false, true, "CollectRoundWinningsModalV1"), 1), onPresentCollectWinningsModal = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(NothingToClaimModal, {})), 1), onPresentNothingToClaimModal = ref3[0];
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var betHistory, unclaimedBets, transformer, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsFetching(true);
                        return [
                            4,
                            getAllV1History({
                                user: account.toLowerCase(),
                                claimed: false
                            })
                        ];
                    case 1:
                        betHistory = _state.sent();
                        unclaimedBets = betHistory.filter(function(bet) {
                            return bet.round.position === bet.position || bet.round.failed === true;
                        });
                        if (unclaimedBets.length > 0) {
                            transformer = (0,helpers/* transformBetResponse */.ld)(tokens_src/* bscTokens.bnb */.ds.bnb);
                            setHistory(unclaimedBets.map(transformer));
                            onPresentCollectWinningsModal();
                        } else {
                            onPresentNothingToClaimModal();
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("Unable to check v1 history", error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsFetching(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledClaimCheck, {
        onClick: account ? handleClick : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Showing history for Prediction v0.2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "primary",
                                children: t("Check for unclaimed v0.1 winnings")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                color: "primary",
                                width: "24px"
                            })
                        ]
                    })
                ]
            }),
            isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                px: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var V1ClaimCheck = (ClaimCheck);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/RoundsTab.tsx











var RoundsTab = function(param) {
    var hasBetHistory = param.hasBetHistory, bets = param.bets;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var hasHistoryLoaded = (0,predictions_hooks/* useGetHasHistoryLoaded */.sz)();
    var currentHistoryPage = (0,predictions_hooks/* useGetCurrentHistoryPage */.Gc)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var handleClick = function() {
        dispatch((0,predictions/* fetchNodeHistory */.uP)({
            account: account,
            page: currentHistoryPage + 1
        }));
    };
    var v1Claim = token.symbol === "BNB" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(V1ClaimCheck, {}) : null;
    return hasBetHistory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            v1Claim,
            orderBy_default()(bets, [
                "round.epoch"
            ], [
                "desc"
            ]).map(function(bet) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(History_HistoricalBet, {
                    bet: bet
                }, bet.round.epoch);
            }),
            hasBetHistory && !hasHistoryLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                py: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    scale: "sm",
                    onClick: handleClick,
                    disabled: isFetchingHistory,
                    children: t("View More")
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            v1Claim,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        size: "lg",
                        textAlign: "center",
                        mb: "8px",
                        children: t("No prediction history available")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        textAlign: "center",
                        children: t("If you are sure you should see history here, make sure you’re connected to the correct wallet and try again.")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var History_RoundsTab = (RoundsTab);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/OpenNew.tsx
var OpenNew = __webpack_require__(30793);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/PnlChartStyles.tsx
// @ts-nocheck
/**
 * There is ts-nocheck at the top of this file for the following reasons:
 * 1. You can't ignore block in TS at the moment https://stackoverflow.com/questions/51145180/how-to-use-ts-ignore-for-a-block
 * 2. Interpolations in keyframes are indeed supported and work fine https://github.com/styled-components/styled-components/issues/2263
 * But TypeScript definitions are not updated to reflect that - https://github.com/DefinitelyTyped/DefinitelyTyped/issues/48907
 * 3. Since this error is in the middle of a template string there is no way to add @ts-ignore on just that one line
 * without also messing prettier.
 *
 * I'll leave TODO: comment here to check back later if there is update to types
 *
 */ 
function PnlChartStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    stroke-dasharray: 0, 339.292\n  }\n  to {\n    stroke-dasharray: ",
        " 339.292;\n  }\n"
    ]);
    PnlChartStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    stroke-dashoffset: 0\n  }\n  to {\n    stroke-dashoffset: ",
        ";\n  }\n"
    ]);
    PnlChartStyles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 128px;\n  height: 128px;\n  transform: rotate(-90deg);\n"
    ]);
    PnlChartStyles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  stroke-width: 2;\n  stroke-dasharray: ",
        ";\n"
    ]);
    PnlChartStyles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stroke: #ed4b9e;\n  animation: ",
        " 1s ease;\n"
    ]);
    PnlChartStyles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stroke: #31d0aa;\n  stroke-dashoffset: ",
        ";\n  animation: ",
        " 1s ease, ",
        " 1s ease;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 128px;\n  height: 128px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 128px;\n  height: 128px;\n  border-radius: 50%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var DrawAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(PnlChartStyles_templateObject(), function(param) {
    var length = param.length;
    return length;
});
var OffsetAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(PnlChartStyles_templateObject1(), function(props) {
    return -props.offset;
});
var SVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-58592dbe-0"
})(PnlChartStyles_templateObject2());
var DefaultSlice = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-58592dbe-1"
})(PnlChartStyles_templateObject3(), function(props) {
    return "".concat(props.length, " 339.292");
});
var LostSlice = (0,styled_components_browser_esm/* default */.ZP)(DefaultSlice).withConfig({
    componentId: "sc-58592dbe-2"
})(PnlChartStyles_templateObject4(), DrawAnimation);
var WonSlice = (0,styled_components_browser_esm/* default */.ZP)(DefaultSlice).withConfig({
    componentId: "sc-58592dbe-3"
})(_templateObject5(), function(props) {
    return -props.offset;
}, DrawAnimation, OffsetAnimation);
var PnlChartStyles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58592dbe-4"
})(_templateObject6());
var PnlChartStyles_Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58592dbe-5"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/PnlChart.tsx




// 2 * Pi * R
var CIRCUMFERENCE = 339.292;
var PnlChart = function(param) {
    var lost = param.lost, won = param.won;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var percentageWon = won * 100 / (lost + won);
    var percentageWonDisplay = !Number.isNaN(percentageWon) ? "".concat(percentageWon.toFixed(2), "%") : "0%";
    var paintLost = lost / (won + lost) * CIRCUMFERENCE;
    var paintWon = CIRCUMFERENCE - paintLost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PnlChartStyles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SVG, {
                viewBox: "0 0 128 128",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LostSlice, {
                        r: "54",
                        cx: "64",
                        cy: "64",
                        length: paintLost
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WonSlice, {
                        r: "54",
                        cx: "64",
                        cy: "64",
                        length: paintWon,
                        offset: paintLost
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PnlChartStyles_Info, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        lineHeight: "1",
                        children: t("Won")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        fontSize: "20px",
                        lineHeight: "1",
                        children: [
                            won,
                            "/",
                            won + lost
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        lineHeight: "1",
                        color: "textSubtle",
                        children: percentageWonDisplay
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PnlTab_PnlChart = (PnlChart);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/SummaryRow.tsx

function SummaryRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n  flex-direction: column;\n  padding: 12px 0;\n"
    ]);
    SummaryRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6d2aabff-0"
})(SummaryRow_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
}, function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
});
var summaryTypeColors = {
    won: "success",
    lost: "failure",
    entered: "text"
};
var summaryTypeSigns = {
    won: "+",
    lost: "-",
    entered: ""
};
var SummaryRow = function(param) {
    var type = param.type, summary = param.summary, bnbBusdPrice = param.bnbBusdPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var color = summaryTypeColors[type];
    var _type = summary[type], rounds = _type.rounds, amount = _type.amount;
    var totalRounds = summary.entered.rounds;
    var roundsInPercents = (rounds * 100 / totalRounds).toFixed(2);
    var typeTranslationKey = type.charAt(0).toUpperCase() + type.slice(1);
    var displayAmount = type === "won" ? summary[type].payout : amount;
    var amountInUsd = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, displayAmount);
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var roundsInPercentsDisplay = !Number.isNaN(parseFloat(roundsInPercents)) ? "".concat(roundsInPercents, "%") : "0%";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlex, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                children: t(typeTranslationKey)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "2",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "18px",
                                color: color,
                                children: [
                                    rounds,
                                    " ",
                                    t("Rounds").toLocaleLowerCase()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: type === "entered" ? t("Total").toLocaleLowerCase() : roundsInPercentsDisplay
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "3",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                color: color,
                                children: "".concat(summaryTypeSigns[type]).concat(formatBnb(displayAmount, displayedDecimals), " ").concat(token.symbol)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: "~$".concat(amountInUsd.toFixed(2))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PnlTab_SummaryRow = (SummaryRow);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/PnlTab.tsx

function PnlTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 1px;\n  margin: 12px auto;\n  width: 100%;\n"
    ]);
    PnlTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var PnlTab_Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46613e56-0"
})(PnlTab_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
});
var initialPnlSummary = {
    won: {
        rounds: 0,
        amount: 0,
        payout: 0,
        bestRound: {
            id: "0",
            payout: 0,
            multiplier: 0
        }
    },
    lost: {
        rounds: 0,
        amount: 0
    },
    entered: {
        rounds: 0,
        amount: 0
    }
};
var getPnlSummary = function(bets, currentEpoch) {
    return bets.reduce(function(summary, bet) {
        var roundResult = (0,helpers/* getRoundResult */.yz)(bet, currentEpoch);
        if (roundResult === helpers/* Result.WIN */.x4.WIN) {
            var payout = getNetPayout(bet, config/* REWARD_RATE */.Ck);
            var bestRound = summary.won.bestRound;
            if (payout > bestRound.payout) {
                var _round = bet.round, bullAmount = _round.bullAmount, bearAmount = _round.bearAmount, totalAmount = _round.totalAmount;
                var multiplier = getMultiplier(totalAmount, bet.position === types/* BetPosition.BULL */.Tu.BULL ? bullAmount : bearAmount);
                bestRound = {
                    id: bet.round.epoch.toString(),
                    payout: payout,
                    multiplier: multiplier
                };
            }
            return {
                won: {
                    rounds: summary.won.rounds + 1,
                    amount: summary.won.amount + bet.amount,
                    payout: summary.won.payout + payout,
                    bestRound: bestRound
                },
                entered: {
                    rounds: summary.entered.rounds + 1,
                    amount: summary.entered.amount + bet.amount
                },
                lost: summary.lost
            };
        }
        if (roundResult === helpers/* Result.LOSE */.x4.LOSE || roundResult === helpers/* Result.HOUSE */.x4.HOUSE) {
            return {
                lost: {
                    rounds: summary.lost.rounds + 1,
                    amount: summary.lost.amount + bet.amount
                },
                entered: {
                    rounds: summary.entered.rounds + 1,
                    amount: summary.entered.amount + bet.amount
                },
                won: summary.won
            };
        }
        // Ignore Canceled and Live rounds
        return summary;
    }, initialPnlSummary);
};
var PnlTab = function(param) {
    var hasBetHistory = param.hasBetHistory, bets = param.bets;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var bnbBusdPrice = (0,useBUSDPrice/* default */.ZP)(token);
    var summary = getPnlSummary(bets, currentEpoch);
    var netResultAmount = summary.won.payout - summary.lost.amount;
    var netResultIsPositive = netResultAmount > 0;
    var avgPositionEntered = summary.entered.amount / summary.entered.rounds;
    var avgBnbWonPerRound = netResultAmount / summary.entered.rounds;
    var avgBnbWonIsPositive = avgBnbWonPerRound > 0;
    // Guard in case user has only lost rounds
    var hasBestRound = summary.won.bestRound.payout !== 0;
    var netResultInUsd = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, netResultAmount);
    var avgBnbWonInUsd = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, avgBnbWonPerRound);
    var avgBnbWonInUsdDisplay = !Number.isNaN(avgBnbWonInUsd) ? "~".concat(avgBnbWonInUsd.toFixed(2)) : "~$0.00";
    var betRoundInUsd = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, summary.won.bestRound.payout);
    var avgPositionEnteredInUsd = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, avgPositionEntered);
    var avgPositionEnteredInUsdDisplay = !Number.isNaN(avgPositionEnteredInUsd) ? "~".concat(avgPositionEnteredInUsd.toFixed(2)) : "~$0.00";
    return hasBetHistory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        p: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_PnlChart, {
                        lost: summary.lost.rounds,
                        won: summary.won.rounds
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        pl: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                children: t("Net results")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "24px",
                                lineHeight: "1",
                                color: netResultIsPositive ? "success" : "failure",
                                children: "".concat(netResultIsPositive ? "+" : "").concat(formatBnb(netResultAmount, displayedDecimals), " ").concat(token.symbol)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                small: true,
                                color: "textSubtle",
                                children: "~$".concat(netResultInUsd.toFixed(2))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                pl: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "24px",
                        color: "textSubtle",
                        children: t("Average return / round")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: avgBnbWonIsPositive ? "success" : "failure",
                        children: "".concat(avgBnbWonIsPositive ? "+" : "").concat(formatBnb(avgBnbWonPerRound, displayedDecimals), " ").concat(token.symbol)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        children: avgBnbWonInUsdDisplay
                    }),
                    hasBestRound && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "16px",
                                color: "textSubtle",
                                children: t("Best round: #%roundId%", {
                                    roundId: summary.won.bestRound.id
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "success",
                                        children: "+".concat(formatBnb(summary.won.bestRound.payout, displayedDecimals), " ").concat(token.symbol)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        ml: "4px",
                                        small: true,
                                        color: "textSubtle",
                                        children: [
                                            "(",
                                            summary.won.bestRound.multiplier.toFixed(2),
                                            "x)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                small: true,
                                color: "textSubtle",
                                children: "~$".concat(betRoundInUsd.toFixed(2))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "16px",
                        color: "textSubtle",
                        children: t("Average position entered / round")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "".concat(formatBnb(avgPositionEntered, displayedDecimals), " ").concat(token.symbol)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "16px",
                        small: true,
                        color: "textSubtle",
                        children: avgPositionEnteredInUsdDisplay
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_SummaryRow, {
                        type: "won",
                        summary: summary,
                        bnbBusdPrice: bnbBusdPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_SummaryRow, {
                        type: "lost",
                        summary: summary,
                        bnbBusdPrice: bnbBusdPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_SummaryRow, {
                        type: "entered",
                        summary: summary,
                        bnbBusdPrice: bnbBusdPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mt: "12px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "".concat((0,utils/* getBlockExploreLink */.C)(account, "address"), "#internaltx"),
                            mb: "16px",
                            external: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                mt: "8px",
                                width: "100%",
                                variant: "secondary",
                                style: {
                                    border: "none",
                                    height: "auto",
                                    fontSize: "14px"
                                },
                                children: [
                                    t("View Reclaimed & Won"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNew/* default */.Z, {
                                        color: "white",
                                        ml: "4px"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        p: "24px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                size: "lg",
                textAlign: "center",
                mb: "8px",
                children: t("No prediction history available")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                textAlign: "center",
                children: t("If you are sure you should see history here, make sure you’re connected to the correct wallet and try again.")
            })
        ]
    });
};
/* harmony default export */ var PnlTab_PnlTab = (PnlTab);

;// CONCATENATED MODULE: ./src/views/Predictions/History.tsx

function History_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"
    ]);
    History_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function History_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  height: 100%;\n  overflow-y: auto;\n  position: relative;\n"
    ]);
    History_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function History_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  display: flex;\n  left: 0;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"
    ]);
    History_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var StyledHistory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74fa20b0-0"
})(History_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.modalBg;
});
var BetWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74fa20b0-1"
})(History_templateObject1());
var SpinnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74fa20b0-2"
})(History_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.modalBg;
});
var History = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var historyFilter = (0,predictions_hooks/* useGetHistoryFilter */.J7)();
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var currentHistoryPage = (0,predictions_hooks/* useGetCurrentHistoryPage */.Gc)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var bets = (0,predictions_hooks/* useGetHistory */.pw)();
    var ref = (0,react.useState)(HistoryTabs.ROUNDS), activeTab = ref[0], setActiveTab = ref[1];
    (0,react.useEffect)(function() {
        if (account && isHistoryPaneOpen) {
            dispatch((0,predictions/* fetchNodeHistory */.uP)({
                account: account
            }));
        }
    }, [
        account,
        currentEpoch,
        isHistoryPaneOpen,
        dispatch
    ]);
    var results = (0,helpers/* getFilteredBets */.fq)(bets, historyFilter);
    var hasBetHistory = results && results.length > 0;
    var activeTabComponent = null;
    switch(activeTab){
        case HistoryTabs.PNL:
            activeTabComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_PnlTab, {
                hasBetHistory: hasBetHistory,
                bets: results
            });
            break;
        case HistoryTabs.ROUNDS:
        default:
            activeTabComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(History_RoundsTab, {
                hasBetHistory: hasBetHistory,
                bets: results
            });
            break;
    }
    if (!account) {
        activeTabComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            mt: "32px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mt: "8px",
                    children: t("Connect your wallet to view your prediction history")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHistory, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(History_Header, {
                activeTab: activeTab,
                setActiveTab: setActiveTab
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BetWrapper, {
                children: isFetchingHistory && currentHistoryPage === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        size: 72
                    })
                }) : activeTabComponent
            })
        ]
    });
};
/* harmony default export */ var Predictions_History = (History);

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 105 modules
var swiper_react = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(40025);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Timeout.tsx
var Timeout = __webpack_require__(91770);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(12851);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/LivePrediction.tsx
var LivePrediction = __webpack_require__(42210);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/Predictions/RoundMultiplierArrows.tsx






var RoundMultiplierDownArrow = function(_param) {
    var isActive = _param.isActive, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isActive"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var fill = theme.colors[isActive ? "failure" : "multiplierCardBg"];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "270",
        height: "57",
        viewBox: "0 0 270 57"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "18.5",
                y: "5",
                width: "233",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "36.5",
                y: "13",
                width: "197",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "54.5",
                y: "21",
                width: "161",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "73.5",
                y: "29",
                width: "123",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "91.5",
                y: "37",
                width: "87",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "110.5",
                y: "45",
                width: "49",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "128.5",
                y: "53",
                width: "13",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "1",
                width: "270",
                height: "56",
                fill: "url(#paint0_linear_3853_6594)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 1H270V-1H0V1Z",
                fill: "white",
                "fill-opacity": "0.1",
                mask: "url(#path-1-inside-1_3853_6594)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_3853_6594",
                    x1: "135",
                    y1: "1",
                    x2: "135",
                    y2: "57",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#050217"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            "stop-color": "#050217",
                            "stop-opacity": "0"
                        })
                    ]
                })
            })
        ]
    }));
};
var RoundMultiplierUpArrow = function(_param) {
    var isActive = _param.isActive, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isActive"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var fill = theme.colors[isActive ? "success" : "multiplierCardBg"];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "270",
        height: "57",
        viewBox: "0 0 270 57"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "128.5",
                width: "13",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "110.5",
                y: "8",
                width: "49",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "91.5",
                y: "16",
                width: "87",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "73.5",
                y: "24",
                width: "123",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "54.5",
                y: "32",
                width: "161",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "36.5",
                y: "40",
                width: "197",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "18.5",
                y: "48",
                width: "233",
                height: "4",
                rx: "2",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "270",
                height: "56",
                fill: "url(#paint0_linear_3853_6391)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M270 56H0V58H270V56Z",
                fill: "white",
                "fill-opacity": "0.1",
                mask: "url(#path-1-inside-1_3853_6391)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_3853_6391",
                    x1: "135",
                    y1: "0",
                    x2: "135",
                    y2: "56",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#050217",
                            "stop-opacity": "0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            "stop-color": "#050217"
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag_Tag = __webpack_require__(22769);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CheckmarkCircleFill.tsx
var CheckmarkCircleFill = __webpack_require__(95984);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CheckmarkCircle.tsx
var CheckmarkCircle = __webpack_require__(39398);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/EnteredTag.tsx









var EnteredTag = function(param) {
    var amount = param.amount, _hasClaimed = param.hasClaimed, hasClaimed = _hasClaimed === void 0 ? false : _hasClaimed, multiplier = param.multiplier;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var formattedAmount = (0,react.useMemo)(function() {
        var tokenAmount;
        if (hasClaimed) {
            if (amount) {
                var multiplierNumber = parseFloat(multiplier);
                tokenAmount = bignumber/* BigNumber.from */.O$.from((0,bigNumber/* ethersToBigNumber */.i9)(amount).times(Number.isFinite(multiplierNumber) ? multiplierNumber * config/* REWARD_RATE */.Ck : 1).toFixed(0));
            }
        } else {
            tokenAmount = amount;
        }
        return (0,Predictions_helpers/* formatBnbv2 */.rc)(tokenAmount, displayedDecimals);
    }, [
        amount,
        displayedDecimals,
        hasClaimed,
        multiplier
    ]);
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: "".concat(formattedAmount, " ").concat(token.symbol)
    }), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltipVisible = ref1.tooltipVisible, tooltip = ref1.tooltip;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                ref: targetRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag/* default */.Z, {
                        variant: "secondary",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        outline: !hasClaimed,
                        startIcon: hasClaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircleFill/* default */.Z, {
                            width: "18px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircle/* default */.Z, {
                            width: "18px"
                        }),
                        children: hasClaimed ? t("Claimed") : t("Entered")
                    }),
                    " "
                ]
            }),
            " ",
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var RoundCard_EnteredTag = (EnteredTag);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/MultiplierArrow.tsx

function MultiplierArrow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 65px;\n  margin: 0 auto;\n  width: 270px;\n"
    ]);
    MultiplierArrow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MultiplierArrow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  left: 0;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"
    ]);
    MultiplierArrow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MultiplierArrow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 10;\n"
    ]);
    MultiplierArrow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MultiplierArrow_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 8px 16px;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    MultiplierArrow_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-216d906a-0"
})(MultiplierArrow_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-216d906a-1"
})(MultiplierArrow_templateObject1());
var EnteredTagWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-216d906a-2"
})(MultiplierArrow_templateObject2());
var EpochContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-216d906a-3"
})(MultiplierArrow_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var getTextColor = function() {
    var fallback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "textSubtle";
    return function(isActive, isDisabled, isHouse) {
        if (isDisabled || isHouse) {
            return "textSubtle";
        }
        if (isActive) {
            return "white";
        }
        return fallback;
    };
};
var MultiplierArrow = function(param) {
    var betAmount = param.betAmount, epoch = param.epoch, multiplier = param.multiplier, _hasEntered = param.hasEntered, hasEntered = _hasEntered === void 0 ? false : _hasEntered, _hasClaimed = param.hasClaimed, hasClaimed = _hasClaimed === void 0 ? false : _hasClaimed, _betPosition = param.betPosition, betPosition = _betPosition === void 0 ? types/* BetPosition.BULL */.Tu.BULL : _betPosition, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _isHouse = param.isHouse, isHouse = _isHouse === void 0 ? false : _isHouse;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var upColor = getTextColor("success")(isActive, isDisabled, isHouse);
    var downColor = getTextColor("failure")(isActive, isDisabled, isHouse);
    var textColor = getTextColor()(isActive, isDisabled, isHouse);
    var multiplierText = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            height: "14px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: textColor,
                    bold: true,
                    lineHeight: "14x",
                    children: multiplier !== undefined ? "".concat(multiplier, "x") : "-"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: textColor,
                    lineHeight: "14x",
                    ml: "4px",
                    children: t("Payout")
                })
            ]
        })
    });
    var getEnteredTag = function(position) {
        if (!hasEntered) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EnteredTagWrapper, {
            style: position,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_EnteredTag, {
                amount: betAmount,
                hasClaimed: hasClaimed,
                multiplier: multiplier
            })
        });
    };
    if (betPosition === types/* BetPosition.BEAR */.Tu.BEAR) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            mt: "-1px",
            position: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundMultiplierDownArrow, {
                        isActive: isActive
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            !isDisabled && multiplierText,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                fontSize: "20px",
                                mb: "8px",
                                color: "text",
                                textTransform: "uppercase",
                                children: t("Down")
                            })
                        ]
                    }),
                    epoch >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(EpochContainer, {
                        children: [
                            t("#"),
                            " ",
                            epoch
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        mb: "-1px",
        position: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundMultiplierUpArrow, {
                    isActive: isActive
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            fontSize: "20px",
                            lineHeight: "21px",
                            color: "text",
                            textTransform: "uppercase",
                            children: t("Up")
                        }),
                        !isDisabled && multiplierText
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RoundCard_MultiplierArrow = (MultiplierArrow);

;// CONCATENATED MODULE: ./src/utils/getNow.ts
var getNow = function() {
    return Math.floor(Date.now() / 1000);
};

;// CONCATENATED MODULE: ./src/utils/accurateTimer.ts
var accurateTimer = function(callback) {
    var time = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    var nextAt;
    var timeout;
    nextAt = new Date().getTime() + time;
    var wrapper = function() {
        nextAt += time;
        timeout = setTimeout(wrapper, nextAt - new Date().getTime());
        callback === null || callback === void 0 ? void 0 : callback();
    };
    var cancel = function() {
        return clearTimeout(timeout);
    };
    timeout = setTimeout(wrapper, nextAt - new Date().getTime());
    return {
        cancel: cancel
    };
};

// EXTERNAL MODULE: ./packages/hooks/src/index.ts + 4 modules
var hooks_src = __webpack_require__(74903);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useCountdown.ts




var getSecondsRemainingToNow = function(timestamp) {
    var now = getNow();
    return Number.isFinite(timestamp) && timestamp > now ? timestamp - now : 0;
};
/**
 * Consider this moving up to the global level
 */ var useCountdown_useCountdown = function(timestamp) {
    var timerCancelRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(function() {
        return getSecondsRemainingToNow(timestamp);
    }), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var ref1 = (0,react.useState)(false), isPaused = ref1[0], setIsPaused = ref1[1];
    var isWindowVisible = (0,hooks_src/* useIsWindowVisible */.yr)();
    var pause = (0,react.useCallback)(function() {
        return setIsPaused(true);
    }, [
        setIsPaused
    ]);
    var unpause = (0,react.useCallback)(function() {
        return setIsPaused(false);
    }, [
        setIsPaused
    ]);
    (0,react.useEffect)(function() {
        var cancel;
        if (!isPaused) {
            var ref = accurateTimer(function() {
                setSecondsRemaining(function(prevSecondsRemaining) {
                    var ref;
                    if (prevSecondsRemaining) {
                        return prevSecondsRemaining - 1;
                    }
                    (ref = timerCancelRef.current) === null || ref === void 0 ? void 0 : ref.call(timerCancelRef);
                    return prevSecondsRemaining;
                });
            }), timerCancel = ref.cancel;
            cancel = timerCancel;
            timerCancelRef.current = timerCancel;
        }
        return function() {
            cancel === null || cancel === void 0 ? void 0 : cancel();
        };
    }, [
        isPaused,
        timestamp,
        setSecondsRemaining
    ]);
    // Pause the timer if the tab becomes inactive to avoid it becoming out of sync
    (0,react.useEffect)(function() {
        if (isWindowVisible) {
            setSecondsRemaining(getSecondsRemainingToNow(timestamp));
            unpause();
        } else {
            pause();
        }
    }, [
        pause,
        unpause,
        timestamp,
        setSecondsRemaining,
        isWindowVisible
    ]);
    return {
        secondsRemaining: secondsRemaining,
        pause: pause,
        unpause: unpause
    };
};
/* harmony default export */ var hooks_useCountdown = (useCountdown_useCountdown);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CardHeader.tsx

function CardHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ",
        ";\n  padding: 20px 10px;\n  gap: 10px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    CardHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 2px 8px 2px 4px;\n  align-items: center;\n  gap: 2px;\n  border-radius: 100px;\n  border: 1px solid ",
        ";\n  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01);\n  box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.08) inset; \n  height: 24px;\n  div {\n    font-family: DM Sans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 100%;\n    text-transform: uppercase; \n    color: ",
        ";\n  }\n"
    ]);
    CardHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-self: center;\n"
    ]);
    CardHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var HEADER_HEIGHT = "64px";
// Used to get the gradient for the card border, which depends on the header color to create the illusion
// that header is overlapping the 1px card border.
// 'live' is not included into the switch case because it has isActive border style
var getBorderBackground = function(theme, status) {
    var gradientStopPoint = "calc(".concat(HEADER_HEIGHT, " + 1px)");
    switch(status){
        case "calculating":
            return "linear-gradient(transparent ".concat(gradientStopPoint, ", ").concat(theme.colors.cardBorder, " ").concat(gradientStopPoint, "), ").concat(theme.colors.gradientCardHeader);
        case "canceled":
            return "linear-gradient(".concat(theme.colors.warning, " ").concat(gradientStopPoint, ", ").concat(theme.colors.cardBorder, " ").concat(gradientStopPoint, ")");
        case "next":
            return "linear-gradient(".concat(theme.colors.secondary, " ").concat(gradientStopPoint, ", ").concat(theme.colors.cardBorder, " ").concat(gradientStopPoint, ")");
        case "expired":
        case "soon":
        default:
            return theme.colors.cardBorder;
    }
};
var CardHeader_getBackgroundColor = function(theme, status) {
    switch(status){
        case "calculating":
            return theme.colors.gradientCardHeader;
        case "live":
            return "transparent";
        case "canceled":
            return theme.colors.warning;
        case "next":
            return theme.colors.secondary;
        case "expired":
        case "soon":
        default:
            return theme.colors.cardBorder;
    }
};
var getTextColorByStatus = function(status, fallback) {
    switch(status){
        case "expired":
            return "textDisabled";
        case "next":
            return "white";
        case "live":
            return "secondary";
        case "canceled":
        case "calculating":
            return "text";
        default:
            return fallback;
    }
};
var StyledCardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38cca08-0"
})(CardHeader_templateObject(), HEADER_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var CardHeader_StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38cca08-1"
})(CardHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.liquidityBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var Round = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38cca08-2"
})(CardHeader_templateObject2());
var CardHeader = function(param) {
    var status = param.status, title = param.title, epoch = param.epoch, icon = param.icon, hasClaimed = param.hasClaimed, winnerIcon = param.winnerIcon, liveIcon = param.liveIcon, trophyIcon = param.trophyIcon, betAmount = param.betAmount, multiplier = param.multiplier, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown;
    var currentRoundCloseTimestamp = (0,predictions_hooks/* useGetCurrentRoundCloseTimestamp */.ds)();
    var secondsRemaining = hooks_useCountdown(currentRoundCloseTimestamp).secondsRemaining;
    var countdown = (0,Predictions_helpers/* formatRoundTime */.tw)(secondsRemaining);
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var isClaimable = (0,predictions_hooks/* useGetIsClaimable */.Wx)(epoch);
    var formattedAmount = (0,react.useMemo)(function() {
        var tokenAmount;
        if (hasClaimed) {
            if (betAmount) {
                var multiplierNumber = parseFloat(multiplier);
                tokenAmount = bignumber/* BigNumber.from */.O$.from((0,bigNumber/* ethersToBigNumber */.i9)(betAmount).times(Number.isFinite(multiplierNumber) ? multiplierNumber * config/* REWARD_RATE */.Ck : 1).toFixed(0));
            }
        } else {
            tokenAmount = betAmount;
        }
        return (0,Predictions_helpers/* formatBnbv2 */.rc)(tokenAmount, displayedDecimals);
    }, [
        betAmount,
        displayedDecimals,
        hasClaimed,
        multiplier
    ]);
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: "".concat(formattedAmount, " ").concat(token.symbol)
    }), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltipVisible = ref1.tooltipVisible, tooltip = ref1.tooltip;
    var textColor = getTextColorByStatus(status, "text");
    var isLive = status === "live";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardHeader, {
        style: {
            justifyContent: hasClaimed || isLive || isClaimable ? "space-between" : "center"
        },
        status: status,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                style: {
                    gap: "10px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader_StyledFlex, {
                        children: [
                            icon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: title
                            })
                        ]
                    }),
                    hasClaimed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader_StyledFlex, {
                        ref: targetRef,
                        children: [
                            winnerIcon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "Claimed"
                            }),
                            tooltipVisible && tooltip
                        ]
                    }),
                    (hasEnteredUp || hasEnteredDown) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader_StyledFlex, {
                        children: [
                            hasEnteredUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M10 7L15 12L5 12L10 7Z",
                                    fill: "#66FFB6"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M10 13L5 8L15 8L10 13Z",
                                    fill: "#FF4D4D"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    hasEnteredUp ? "Up" : "Down",
                                    " Entered"
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasClaimed && trophyIcon,
            isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: countdown
            }),
            isClaimable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                ref: targetRef,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mr: "5px",
                        className: "syncopate",
                        color: "yellow",
                        fontWeight: 700,
                        children: "WIN"
                    }),
                    trophyIcon,
                    tooltipVisible && tooltip
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_CardHeader = (CardHeader);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CollectWinningsOverlay.tsx




function CollectWinningsOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0;\n  position: absolute;\n  width: 100%;\n  z-index: 30;\n  backdrop-filter: blur(4px);\n\n  ",
        "\n"
    ]);
    CollectWinningsOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CollectWinningsOverlay_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a599f437-0"
})(CollectWinningsOverlay_templateObject(), function(param) {
    var isBottom = param.isBottom;
    return isBottom ? "\n      border-radius: 0 0 16px 16px;\n      bottom: 0;\n    " : "\n      top: 37px; // Card header height\n    ";
});
var CollectWinningsOverlay = function(_param) {
    var epoch = _param.epoch, _isBottom = _param.isBottom, isBottom = _isBottom === void 0 ? false : _isBottom, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "epoch",
        "isBottom"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isClaimable = (0,predictions_hooks/* useGetIsClaimable */.Wx)(epoch);
    if (!isClaimable) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectWinningsOverlay_Wrapper, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        p: "16px",
        isBottom: isBottom
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectWinningsButton, {
            hasClaimed: false,
            width: "100%",
            children: t("Collect Winnings")
        })
    }));
};
/* harmony default export */ var RoundCard_CollectWinningsOverlay = (CollectWinningsOverlay);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CanceledRoundCard.tsx



function CanceledRoundCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 370px;\n  padding: 16px;\n"
    ]);
    CanceledRoundCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var CustomCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-4d068d04-0"
})(CanceledRoundCard_templateObject());
var CanceledRoundCard = function(param) {
    var round = param.round;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = hooks_useIsRefundable(round.epoch), isRefundable = ref.isRefundable, setIsRefundable = ref.setIsRefundable;
    var epoch = round.epoch;
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsRefundable(false);
                return [
                    2
                ];
            });
        });
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        borderBackground: getBorderBackground(theme, "canceled"),
        style: {
            height: "439px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                status: "canceled",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                    mr: "4px",
                    width: "21px"
                }),
                title: t("Cancelled"),
                epoch: round.epoch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        isDisabled: true,
                        epoch: epoch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            alignItems: "center",
                            my: "20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "text",
                                    children: t("Round Cancelled")
                                }),
                                isRefundable && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReclaimPositionButton, {
                                    epoch: epoch,
                                    onSuccess: handleSuccess,
                                    width: "100%",
                                    my: "8px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                                    href: "https://docs.alienbase.xyz/predictions",
                                    external: true,
                                    children: t("Learn More")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                        isDisabled: true,
                        epoch: epoch
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_CanceledRoundCard = (CanceledRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CalculatingCard.tsx









var CalculatingCard = function(param) {
    var round = param.round, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,useTooltip/* default */.Z)(t("This round’s closing transaction has been submitted to the blockchain, and is awaiting confirmation."), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                borderBackground: getBorderBackground(theme, "calculating"),
                style: {
                    height: "439px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                        status: "calculating",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wait/* default */.Z, {
                            mr: "4px",
                            width: "21px"
                        }),
                        title: t("Calculating"),
                        epoch: round.epoch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardBody, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                isDisabled: true,
                                hasEntered: hasEnteredUp,
                                epoch: round.epoch
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            size: 96
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            mt: "8px",
                                            ref: targetRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                                    children: t("Calculating")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                    ml: "4px"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                                isDisabled: true,
                                hasEntered: hasEnteredDown,
                                epoch: round.epoch
                            })
                        ]
                    })
                ]
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var RoundCard_CalculatingCard = (CalculatingCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/ExpiredRoundCard.tsx



function ExpiredRoundCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0.7;\n  transition: opacity 300ms;\n\n  &:hover {\n    opacity: 1;\n  }\n"
    ]);
    ExpiredRoundCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var StyledExpiredRoundCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-e0029787-0"
})(ExpiredRoundCard_templateObject());
var ExpiredRoundCard = function(param) {
    var round = param.round, betAmount = param.betAmount, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, hasClaimedUp = param.hasClaimedUp, hasClaimedDown = param.hasClaimedDown, bullMultiplier = param.bullMultiplier, bearMultiplier = param.bearMultiplier, isActive = param.isActive;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var epoch = round.epoch, lockPrice = round.lockPrice, closePrice = round.closePrice;
    var betPosition = (0,Predictions_helpers/* getRoundPosition */.XW)(lockPrice, closePrice);
    var bufferSeconds = (0,predictions_hooks/* useGetBufferSeconds */.XM)();
    var hasRoundFailed = (0,helpers/* getHasRoundFailed */.HJ)(round.oracleCalled, round.closeTimestamp, bufferSeconds);
    if (hasRoundFailed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CanceledRoundCard, {
            round: round
        });
    }
    if (!closePrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CalculatingCard, {
            round: round,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp
        });
    }
    var cardProps = isActive ? {
        isActive: isActive
    } : {
        borderBackground: getBorderBackground(theme, "expired")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExpiredRoundCard, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
                style: {
                    height: "439px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                        status: "expired",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeout/* default */.Z, {
                            mr: "4px",
                            width: "21px",
                            color: "textDisabled"
                        }),
                        title: t("Expired"),
                        epoch: round.epoch,
                        hasClaimed: hasClaimedUp || hasClaimedDown,
                        winnerIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                            width: "21px",
                            color: "textDisabled"
                        }),
                        liveIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivePrediction/* default */.Z, {
                            width: "21px"
                        }),
                        trophyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrophyGold/* default */.Z, {
                            width: "21px"
                        }),
                        betAmount: betAmount,
                        multiplier: betPosition === types/* BetPosition.BULL */.Tu.BULL ? bullMultiplier : bearMultiplier
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardBody, {
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                epoch: epoch,
                                betAmount: betAmount,
                                multiplier: bullMultiplier,
                                isActive: betPosition === types/* BetPosition.BULL */.Tu.BULL,
                                hasEntered: hasEnteredUp,
                                hasClaimed: hasClaimedUp,
                                isHouse: betPosition === types/* BetPosition.HOUSE */.Tu.HOUSE
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResult_RoundResult, {
                                round: round,
                                hasFailed: hasRoundFailed
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                betAmount: betAmount,
                                epoch: epoch,
                                multiplier: bearMultiplier,
                                betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                                isActive: betPosition === types/* BetPosition.BEAR */.Tu.BEAR,
                                hasEntered: hasEnteredDown,
                                hasClaimed: hasClaimedDown,
                                isHouse: betPosition === types/* BetPosition.HOUSE */.Tu.HOUSE
                            })
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CollectWinningsOverlay, {
                epoch: epoch,
                isBottom: true
            })
        ]
    });
};
/* harmony default export */ var RoundCard_ExpiredRoundCard = (ExpiredRoundCard);

// EXTERNAL MODULE: ./src/views/Predictions/hooks/usePollOraclePrice.ts
var usePollOraclePrice = __webpack_require__(37408);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/Progress.tsx + 1 modules
var Progress = __webpack_require__(79207);
;// CONCATENATED MODULE: ./src/components/RoundProgress.tsx




var RoundProgress = function(_param) {
    var lockTimestamp = _param.lockTimestamp, closeTimestamp = _param.closeTimestamp, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "lockTimestamp",
        "closeTimestamp"
    ]);
    var startMs = lockTimestamp * 1000;
    var endMs = closeTimestamp * 1000;
    var now = Date.now();
    var rawProgress = (now - startMs) / (endMs - startMs) * 100;
    var progress = rawProgress <= 100 ? rawProgress : 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, (0,src_object_spread/* default */.Z)({
        primaryStep: progress
    }, props));
};
/* harmony default export */ var components_RoundProgress = (RoundProgress);

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/LiveRoundPrice.tsx





var LiveRoundPrice = function(param) {
    var isBull = param.isBull, price = param.price;
    var priceAsNumber = (0,react.useMemo)(function() {
        return parseFloat((0,formatBalance/* formatBigNumberToFixed */.U1)(price, 4, 8));
    }, [
        price
    ]);
    var priceColor = isBull ? "success" : "failure";
    if (!Number.isFinite(priceAsNumber)) {
        return null;
    }
    if (price.lt(0)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            height: "36px",
            width: "94px"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        start: 0,
        preserveValue: true,
        delay: 0,
        end: priceAsNumber,
        prefix: "$",
        decimals: 4,
        duration: 1,
        children: function(param) {
            var countUpRef = param.countUpRef;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                style: {
                    textDecoration: "none"
                },
                bold: true,
                color: priceColor,
                fontSize: "18px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "syncopate",
                    ref: countUpRef
                })
            });
        }
    });
};
/* harmony default export */ var RoundCard_LiveRoundPrice = (/*#__PURE__*/(0,react.memo)(LiveRoundPrice));

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/LiveRoundCard.tsx

function LiveRoundCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  box-shadow: 0px 0px 0px 10px rgba(255, 255, 255, 0.03) inset; \n  padding: 11px;\n  height: 460px;\n  & > div:first-child {\n    border: 1px solid ",
        ";\n    border-radius: 18px;\n    @media (max-width: 767px) {\n      border-radius: 4px;\n    }\n  }\n"
    ]);
    LiveRoundCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var LiveCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-7194634-0"
})(LiveRoundCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var REFRESH_PRICE_BEFORE_SECONDS_TO_CLOSE = 2;
var LiveRoundCard = function(param) {
    var round = param.round, betAmount = param.betAmount, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, bullMultiplier = param.bullMultiplier, bearMultiplier = param.bearMultiplier;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var lockPrice = round.lockPrice, totalAmount = round.totalAmount, lockTimestamp = round.lockTimestamp, closeTimestamp = round.closeTimestamp;
    var ref = (0,usePollOraclePrice/* default */.Z)(), price = ref.price, refresh = ref.refresh;
    var bufferSeconds = (0,predictions_hooks/* useGetBufferSeconds */.XM)();
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), minPriceUsdDisplayed = ref1.minPriceUsdDisplayed, displayedDecimals = ref1.displayedDecimals;
    var ref2 = (0,react.useState)(false), isCalculatingPhase = ref2[0], setIsCalculatingPhase = ref2[1];
    var isBull = lockPrice && price.gt(lockPrice);
    var priceDifference = (0,Predictions_helpers/* getPriceDifference */.kJ)(price, lockPrice);
    var hasRoundFailed = (0,helpers/* getHasRoundFailed */.HJ)(round.oracleCalled, round.closeTimestamp, bufferSeconds);
    var ref3 = (0,useTooltip/* default */.Z)(t("Last price from Chainlink Oracle"), {
        placement: "bottom"
    }), targetRef = ref3.targetRef, tooltip = ref3.tooltip, tooltipVisible = ref3.tooltipVisible;
    (0,react.useEffect)(function() {
        var secondsToClose = closeTimestamp ? closeTimestamp - getNow() : 0;
        if (secondsToClose > 0) {
            var refreshPriceTimeout = setTimeout(function() {
                refresh();
            }, (secondsToClose - REFRESH_PRICE_BEFORE_SECONDS_TO_CLOSE) * 1000);
            var calculatingPhaseTimeout = setTimeout(function() {
                setIsCalculatingPhase(true);
            }, secondsToClose * 1000);
            return function() {
                clearTimeout(refreshPriceTimeout);
                clearTimeout(calculatingPhaseTimeout);
            };
        }
        return undefined;
    }, [
        refresh,
        closeTimestamp
    ]);
    if (hasRoundFailed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CanceledRoundCard, {
            round: round
        });
    }
    if (isCalculatingPhase) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CalculatingCard, {
            round: round,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LiveCard, {
        isActive: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                status: "live",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivePrediction/* default */.Z, {
                    width: "24px",
                    color: "secondary"
                }),
                title: t("Live"),
                epoch: round.epoch,
                betAmount: betAmount,
                multiplier: isBull ? bullMultiplier : bearMultiplier,
                hasEnteredUp: hasEnteredUp,
                hasEnteredDown: hasEnteredDown
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoundProgress, {
                variant: "flat",
                scale: "sm",
                lockTimestamp: lockTimestamp,
                closeTimestamp: closeTimestamp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardBody, {
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        epoch: round.epoch,
                        betAmount: betAmount,
                        multiplier: bullMultiplier,
                        hasEntered: hasEnteredUp,
                        isActive: isBull
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultBox, {
                        betPosition: isBull ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "14px",
                                textTransform: "uppercase",
                                mb: "8px",
                                children: t("Last Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                mb: "16px",
                                height: "36px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: targetRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_LiveRoundPrice, {
                                            isBull: isBull,
                                            price: price
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                                        betPosition: isBull ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
                                        children: (0,Predictions_helpers/* formatUsdv2 */.pf)(priceDifference, minPriceUsdDisplayed, displayedDecimals)
                                    })
                                ]
                            }),
                            lockPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockPriceRow, {
                                lockPrice: lockPrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                mb: "-20px",
                                totalAmount: totalAmount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        betAmount: betAmount,
                        epoch: round.epoch,
                        multiplier: bearMultiplier,
                        betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                        hasEntered: hasEnteredDown,
                        isActive: !isBull
                    })
                ]
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var RoundCard_LiveRoundCard = (LiveRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/CardFlip.tsx


function CardFlip_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  backface-visibility: hidden;\n  display: flex;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: z-index 600ms;\n  width: 100%;\n\n  & > div {\n    flex: 1;\n  }\n"
    ]);
    CardFlip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardFlip_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotateY(180deg);\n"
    ]);
    CardFlip_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardFlip_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n  transform: rotateY(",
        "deg);\n  transform-style: preserve-3d;\n  transition: transform 600ms;\n\n  ",
        " {\n    z-index: ",
        ";\n  }\n\n  ",
        " {\n    z-index: ",
        ";\n  }\n"
    ]);
    CardFlip_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CardFlip_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  perspective: 1000px;\n  z-index: auto;\n"
    ]);
    CardFlip_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Front = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-709c61ff-0"
})(CardFlip_templateObject());
var Back = (0,styled_components_browser_esm/* default */.ZP)(Front).withConfig({
    componentId: "sc-709c61ff-1"
})(CardFlip_templateObject1());
var Inner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-709c61ff-2"
})(CardFlip_templateObject2(), function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 180 : 0;
}, Front, function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 5 : 10;
}, Back, function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 10 : 5;
});
var StyledCardFlip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-709c61ff-3"
})(CardFlip_templateObject3());
var getComponents = function(children) {
    if (children.length !== 2) {
        throw new Error("CardFlip: Two children are required");
    }
    return children;
};
var CardFlip = function(param) {
    var isFlipped = param.isFlipped, height = param.height, children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(getComponents(children), 2), front = ref[0], back = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardFlip, {
        style: {
            height: height
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            isFlipped: isFlipped,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Front, {
                    children: front
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Back, {
                    children: back
                })
            ]
        })
    });
};
/* harmony default export */ var components_CardFlip = (CardFlip);

// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx
var BalanceInput = __webpack_require__(39665);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Binance.tsx
var Binance = __webpack_require__(80323);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Logo.tsx
var Logo = __webpack_require__(67952);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx
var Card_CardHeader = __webpack_require__(55209);
// EXTERNAL MODULE: ./packages/uikit/src/components/Slider/Slider.tsx + 1 modules
var Slider = __webpack_require__(68118);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/hooks/useTokenBalance.ts
var useTokenBalance = __webpack_require__(94186);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
;// CONCATENATED MODULE: ./src/hooks/useCakeApprovalStatus.ts




// TODO: refactor as useTokenApprovalStatus for generic use
var useCakeApprovalStatus = function(spender) {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref = (0,useContract/* useCake */.kL)(), cakeContract = ref.reader;
    var key = (0,react.useMemo)(function() {
        return account && spender ? {
            contract: cakeContract,
            methodName: "allowance",
            params: [
                account,
                spender
            ]
        } : null;
    }, [
        account,
        cakeContract,
        spender
    ]);
    var ref1 = (0,useSWRContract/* useSWRContract */.Av)(key), data = ref1.data, mutate = ref1.mutate;
    return {
        isVaultApproved: data ? data.gt(0) : false,
        setLastUpdated: mutate
    };
};
/* harmony default export */ var hooks_useCakeApprovalStatus = (useCakeApprovalStatus);

// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(85900);
;// CONCATENATED MODULE: ./src/hooks/useCakeApprove.tsx










var useCakeApprove = function(setLastUpdated, spender, successMsg) {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref1 = (0,useContract/* useCake */.kL)(), cakeContract = ref1.signer;
    var handleApprove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(cakeContract, "approve", [
                                    spender,
                                    bignumbers/* MaxUint256 */.Bz
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: successMsg
                            }));
                            setLastUpdated();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleApprove() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};
/* harmony default export */ var hooks_useCakeApprove = (useCakeApprove);

;// CONCATENATED MODULE: ./src/views/Predictions/components/FlexRow.tsx

function FlexRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    FlexRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FlexRow = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    alignItems: "center"
}).withConfig({
    componentId: "sc-1af93e8b-0"
})(FlexRow_templateObject());
/* harmony default export */ var components_FlexRow = (FlexRow);

// EXTERNAL MODULE: ./src/views/RemoveLiquidity/index.tsx
var RemoveLiquidity = __webpack_require__(46483);
;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/SetPositionCard.tsx



function SetPositionCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 26px;\n  width: 46px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 100%;\n  letter-spacing: -0.36px; \n  padding: 9px; \n  color: ",
        ";\n  &:disabled {\n    background: transparent;\n    font-family: 'Syncopate', sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 100%;\n    letter-spacing: -0.36px; \n    padding: 9px; \n    color: ",
        ";\n  }\n\n"
    ]);
    SetPositionCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SetPositionCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.20);\n  height: 44px;\n  padding: 0px;\n  &:active, &:focus-within {\n    border: 1px solid ",
        ";\n  }\n  div{\n    border-bottom: none !important;\n    padding-bottom: 0px !important;\n    padding-left: 5px !important;\n  }\n  input{\n    &:disabled {\n      background: transparent;\n    }\n  }\n"
    ]);
    SetPositionCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}























var StyledBalanceButton = (0,styled_components_browser_esm/* default */.ZP)(RemoveLiquidity/* StyledPercButton */.m).withConfig({
    componentId: "sc-9510a2ee-0"
})(SetPositionCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(BalanceInput/* default */.Z).withConfig({
    componentId: "sc-9510a2ee-1"
})(SetPositionCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.alienPurple;
});
var LOGOS = {
    BNB: Binance/* default */.Z,
    CAKE: Logo/* default */.Z
};
var dust = (0,lib_esm.parseUnits)("0.001", 18);
var percentShortcuts = [
    10,
    25,
    50,
    75
];
var getButtonProps = function(value, bnbBalance, minBetAmountBalance) {
    var hasSufficientBalance = function() {
        if (value.gt(0)) {
            return value.lte(bnbBalance);
        }
        return bnbBalance.gt(0);
    };
    if (!hasSufficientBalance()) {
        return {
            key: "Insufficient %symbol% balance",
            disabled: true
        };
    }
    if (value.eq(0)) {
        return {
            key: "Enter an amount",
            disabled: true
        };
    }
    return {
        key: "Confirm",
        disabled: value.lt(minBetAmountBalance)
    };
};
var getValueAsEthersBn = function(value) {
    var valueAsFloat = parseFloat(value);
    return Number.isNaN(valueAsFloat) ? bignumbers/* Zero */._Y : (0,lib_esm.parseUnits)(value);
};
var TOKEN_BALANCE_CONFIG = {
    ETH: useTokenBalance/* useGetBnbBalance */.nu,
    ALB: useTokenBalance/* useGetCakeBalance */.Nn
};
var SetPositionCard = function(param) {
    var position = param.position, togglePosition = param.togglePosition, epoch = param.epoch, onBack = param.onBack, onSuccess = param.onSuccess;
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(0), percent = ref2[0], setPercent = ref2[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var minBetAmount = (0,predictions_hooks/* useGetMinBetAmount */.eI)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref3 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref3.fetchWithCatchTxError, isTxPending = ref3.loading;
    var callNoGasPrice = (0,useCallDefaultGasPrice/* useCallNoGasPrice */.s)().callNoGasPrice;
    var ref4 = (0,ConfigProvider/* useConfig */.ZR)(), predictionsAddress = ref4.address, token = ref4.token;
    var predictionsContract = (0,useContract/* usePredictionsContract */.Tu)(predictionsAddress, token.symbol);
    var useTokenBalance = (0,react.useMemo)(function() {
        return TOKEN_BALANCE_CONFIG[token.symbol];
    }, [
        token.symbol
    ]);
    var ref5 = hooks_useCakeApprovalStatus(token.symbol === "ALB" ? predictionsAddress : null), isVaultApproved = ref5.isVaultApproved, setLastUpdated = ref5.setLastUpdated;
    var ref6 = hooks_useCakeApprove(setLastUpdated, predictionsAddress, t("You can now start prediction")), handleApprove = ref6.handleApprove, pendingTx = ref6.pendingTx;
    // ETH prediction doesn't need approval
    var doesCakeApprovePrediction = token.symbol === "ETH" || isVaultApproved;
    var ref7 = useTokenBalance(), bnbBalance = ref7.balance;
    var maxBalance = (0,react.useMemo)(function() {
        return bnbBalance.gt(dust) ? bnbBalance.sub(dust) : bignumbers/* Zero */._Y;
    }, [
        bnbBalance
    ]);
    var balanceDisplay = (0,formatBalance/* formatBigNumber */.dp)(bnbBalance);
    var valueAsBn = getValueAsEthersBn(value);
    var showFieldWarning = account && valueAsBn.gt(0) && errorMessage !== null;
    var handleInputChange = function(input) {
        var inputAsBn = getValueAsEthersBn(input);
        if (inputAsBn.eq(0)) {
            setPercent(0);
        } else {
            var inputAsFn = fixednumber/* FixedNumber.from */.xs.from(inputAsBn);
            var maxValueAsFn = fixednumber/* FixedNumber.from */.xs.from(maxBalance);
            var hundredAsFn = fixednumber/* FixedNumber.from */.xs.from(100);
            var percentage = inputAsFn.divUnsafe(maxValueAsFn).mulUnsafe(hundredAsFn);
            var percentageAsFloat = percentage.toUnsafeFloat();
            setPercent(percentageAsFloat > 100 ? 100 : percentageAsFloat);
        }
        setValue(input);
    };
    var handlePercentChange = (0,react.useCallback)(function(sliderPercent) {
        if (sliderPercent > 0) {
            var maxValueAsFn = fixednumber/* FixedNumber.from */.xs.from(maxBalance);
            var hundredAsFn = fixednumber/* FixedNumber.from */.xs.from(100);
            var sliderPercentAsFn = fixednumber/* FixedNumber.from */.xs.from(sliderPercent.toFixed(18)).divUnsafe(hundredAsFn);
            var balancePercentage = maxValueAsFn.mulUnsafe(sliderPercentAsFn);
            setValue((0,formatBalance/* formatFixedNumber */.w$)(balancePercentage));
        } else {
            setValue("");
        }
        setPercent(sliderPercent);
    }, [
        maxBalance
    ]);
    // Clear value
    var handleGoBack = function() {
        setValue("");
        setPercent(0);
        onBack();
    };
    var ref8 = getButtonProps(valueAsBn, maxBalance, minBetAmount), key = ref8.key, disabled = ref8.disabled;
    var handleEnterPosition = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var betMethod, callOptions, args, receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        betMethod = position === types/* BetPosition.BULL */.Tu.BULL ? "betBull" : "betBear";
                        callOptions = token.symbol === "ALB" ? {
                            value: 0
                        } : {
                            value: valueAsBn.toString()
                        };
                        args = token.symbol === "ALB" ? [
                            epoch,
                            valueAsBn.toString()
                        ] : [
                            epoch
                        ];
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callNoGasPrice(predictionsContract, betMethod, args, callOptions);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            onSuccess(receipt.transactionHash);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEnterPosition() {
            return _ref.apply(this, arguments);
        };
    }();
    // Warnings
    (0,react.useEffect)(function() {
        var inputAmount = getValueAsEthersBn(value);
        var hasSufficientBalance = inputAmount.gt(0) && inputAmount.lte(maxBalance);
        if (!hasSufficientBalance) {
            setErrorMessage(t("Insufficient %symbol% balance", {
                symbol: token.symbol
            }));
        } else if (inputAmount.gt(0) && inputAmount.lt(minBetAmount)) {
            setErrorMessage(t("A minimum amount of %num% %token% is required", {
                num: (0,formatBalance/* formatBigNumber */.dp)(minBetAmount),
                token: token.symbol
            }));
        } else {
            setErrorMessage(null);
        }
    }, [
        value,
        maxBalance,
        minBetAmount,
        setErrorMessage,
        t,
        token.symbol
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        background: theme.colors.cardSubtleBg,
        style: {
            height: "439px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardHeader/* default */.Z, {
                p: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            style: {
                                border: "none"
                            },
                            variant: "text",
                            scale: "sm",
                            onClick: handleGoBack,
                            mr: "8px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                                width: "24px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FlexRow, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Set Position")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                            betPosition: position,
                            onClick: togglePosition,
                            children: position === types/* BetPosition.BULL */.Tu.BULL ? t("Up") : t("Down")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                py: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                textAlign: "right",
                                color: "textSubtle",
                                children: [
                                    t("Commit"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    textTransform: "uppercase",
                                    children: token.symbol
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        value: value,
                        onUserInput: handleInputChange,
                        isWarning: showFieldWarning,
                        inputProps: {
                            disabled: !account || isTxPending
                        },
                        className: !account || isTxPending ? "" : "swiper-no-swiping"
                    }),
                    showFieldWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        fontSize: "12px",
                        mt: "4px",
                        textAlign: "right",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "right",
                        mt: "10px",
                        mb: "16px",
                        color: "textSubtle",
                        fontWeight: 500,
                        fontSize: "14px",
                        style: {
                            height: "18px"
                        },
                        children: account && t("Balance: %balance%", {
                            balance: balanceDisplay
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                        name: "balance",
                        min: 0,
                        max: 100,
                        value: percent,
                        onValueChanged: handlePercentChange,
                        valueLabel: account ? "".concat(percent.toFixed(percent > 0 ? 1 : 0), "%") : "",
                        step: 0.01,
                        disabled: !account || isTxPending,
                        mb: "4px",
                        className: !account || isTxPending ? "" : "swiper-no-swiping"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "21px",
                        style: {
                            gap: "5px"
                        },
                        children: [
                            percentShortcuts.map(function(percentShortcut) {
                                var handleClick = function() {
                                    handlePercentChange(percentShortcut);
                                };
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceButton, {
                                    scale: "xs",
                                    variant: "tertiary",
                                    onClick: handleClick,
                                    disabled: !account || isTxPending,
                                    className: !account || isTxPending ? "" : "swiper-no-swiping",
                                    style: {
                                        flex: 1
                                    },
                                    children: "".concat(percentShortcut, "%")
                                }, percentShortcut);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceButton, {
                                scale: "xs",
                                variant: "tertiary",
                                onClick: function() {
                                    return handlePercentChange(100);
                                },
                                disabled: !account || isTxPending,
                                className: !account || isTxPending ? "" : "swiper-no-swiping",
                                children: t("100%")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        mb: "8px",
                        children: account ? doesCakeApprovePrediction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            width: "100%",
                            variant: disabled ? "secondary" : "primary",
                            disabled: disabled,
                            height: 44,
                            className: disabled ? "" : "swiper-no-swiping",
                            onClick: handleEnterPosition,
                            isLoading: isTxPending,
                            endIcon: isTxPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                color: "currentColor",
                                spin: true
                            }) : null,
                            children: t(key, {
                                symbol: token.symbol
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            width: "100%",
                            className: "swiper-no-swiping",
                            onClick: handleApprove,
                            isLoading: pendingTx,
                            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                color: "currentColor",
                                spin: true
                            }) : null,
                            children: t("Enable")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                            className: "swiper-no-swiping",
                            width: "100%"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: 1.3,
                        textAlign: "center",
                        color: "textSubtle",
                        children: t("You won’t be able to remove or change your position once you enter it.")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_SetPositionCard = (SetPositionCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/OpenRoundCard.tsx
























var OpenRoundCard = function(param) {
    var round = param.round, betAmount = param.betAmount, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, bullMultiplier = param.bullMultiplier, bearMultiplier = param.bearMultiplier;
    var ref = (0,react.useState)({
        isSettingPosition: false,
        position: types/* BetPosition.BULL */.Tu.BULL
    }), state = ref[0], setState = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), token = ref1.token, displayedDecimals = ref1.displayedDecimals;
    var lockTimestamp = (round !== null && round !== void 0 ? round : {
        lockTimestamp: null
    }).lockTimestamp;
    var isSettingPosition = state.isSettingPosition, position = state.position;
    var ref2 = (0,react.useState)(false), isBufferPhase = ref2[0], setIsBufferPhase = ref2[1];
    var positionDisplay = (0,react.useMemo)(function() {
        return position === types/* BetPosition.BULL */.Tu.BULL ? t("Up").toUpperCase() : t("Down").toUpperCase();
    }, [
        t,
        position
    ]);
    var positionEnteredText = (0,react.useMemo)(function() {
        return hasEnteredUp ? t("Up").toUpperCase() : hasEnteredDown ? t("Down").toUpperCase() : null;
    }, [
        t,
        hasEnteredUp,
        hasEnteredDown
    ]);
    var positionEnteredIcon = (0,react.useMemo)(function() {
        return hasEnteredUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "15",
            height: "8",
            viewBox: "0 0 15 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 0.5L14.5 7.5L0.5 7.5L7.5 0.5Z",
                fill: "#66FFB6"
            })
        }) : hasEnteredDown ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "15",
            height: "8",
            viewBox: "0 0 15 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 7.5L0.5 0.5H14.5L7.5 7.5Z",
                fill: "#FF66D4"
            })
        }) : null;
    }, [
        hasEnteredUp,
        hasEnteredDown
    ]);
    var ref3 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: "".concat((0,Predictions_helpers/* formatBnbv2 */.rc)(betAmount, displayedDecimals), " ").concat(token.symbol)
    }), {
        placement: "top"
    }), targetRef = ref3.targetRef, tooltipVisible = ref3.tooltipVisible, tooltip = ref3.tooltip;
    (0,react.useEffect)(function() {
        var secondsToLock = lockTimestamp ? lockTimestamp - getNow() : 0;
        if (secondsToLock > 0) {
            var setIsBufferPhaseTimeout = setTimeout(function() {
                setIsBufferPhase(true);
            }, (secondsToLock - config/* ROUND_BUFFER */.fq) * 1000);
            return function() {
                clearTimeout(setIsBufferPhaseTimeout);
            };
        }
        return undefined;
    }, [
        lockTimestamp
    ]);
    var getHasEnteredPosition = function() {
        if (hasEnteredUp || hasEnteredDown) {
            return false;
        }
        if (round.lockPrice !== null) {
            return false;
        }
        return true;
    };
    var canEnterPosition = getHasEnteredPosition();
    var handleBack = function() {
        return setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                isSettingPosition: false
            });
        });
    };
    var handleSetPosition = function(newPosition) {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                isSettingPosition: true,
                position: newPosition
            });
        });
    };
    var togglePosition = function() {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                position: prevState.position === types/* BetPosition.BULL */.Tu.BULL ? types/* BetPosition.BEAR */.Tu.BEAR : types/* BetPosition.BULL */.Tu.BULL
            });
        });
    };
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(hash) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,predictions/* fetchLedgerData */.Ub)({
                                account: account,
                                epochs: [
                                    round.epoch
                                ]
                            }))
                        ];
                    case 1:
                        _state.sent();
                        handleBack();
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: hash,
                            children: t("%position% position entered", {
                                position: positionDisplay
                            })
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSuccess(hash) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_CardFlip, {
        isFlipped: isSettingPosition,
        height: "470px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                borderBackground: getBorderBackground(theme, "next"),
                style: {
                    height: "439px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                        status: "next",
                        epoch: round.epoch,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutline/* default */.Z, {
                            color: "white",
                            mr: "4px",
                            width: "21px"
                        }),
                        title: t("Next")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardBody, {
                        p: "20px 16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                epoch: round.epoch,
                                betAmount: betAmount,
                                multiplier: bullMultiplier,
                                hasEntered: hasEnteredUp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                                isNext: canEnterPosition,
                                isLive: !canEnterPosition,
                                children: canEnterPosition ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "greenPred",
                                            width: "100%",
                                            onClick: function() {
                                                return handleSetPosition(types/* BetPosition.BULL */.Tu.BULL);
                                            },
                                            mb: "4px",
                                            disabled: !canEnterPosition || isBufferPhase,
                                            children: t("Enter UP")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount,
                                            mb: "8px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "pinkPred",
                                            width: "100%",
                                            onClick: function() {
                                                return handleSetPosition(types/* BetPosition.BEAR */.Tu.BEAR);
                                            },
                                            disabled: !canEnterPosition || isBufferPhase,
                                            children: t("Enter DOWN")
                                        })
                                    ]
                                }) : positionEnteredText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        hasEnteredDown && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: targetRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                disabled: true,
                                                startIcon: positionEnteredIcon,
                                                width: "100%",
                                                my: "8px",
                                                style: {
                                                    color: hasEnteredUp ? theme.colors.success : theme.colors.failure,
                                                    fontSize: "18px",
                                                    gap: "10px"
                                                },
                                                children: t("%position% Entered", {
                                                    position: positionEnteredText
                                                })
                                            })
                                        }),
                                        hasEnteredUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount
                                        }),
                                        tooltipVisible && tooltip
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                disabled: true,
                                                width: "100%",
                                                mb: "8px",
                                                children: t("No position entered")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                epoch: round.epoch,
                                betAmount: betAmount,
                                multiplier: bearMultiplier,
                                betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                                hasEntered: hasEnteredDown
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_SetPositionCard, {
                onBack: handleBack,
                onSuccess: handleSuccess,
                position: position,
                togglePosition: togglePosition,
                epoch: round.epoch
            })
        ]
    });
};
/* harmony default export */ var RoundCard_OpenRoundCard = (OpenRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/SoonRoundCard.tsx













var SoonRoundCard = function(param) {
    var round = param.round;
    var intervalSeconds = (0,predictions_hooks/* useGetIntervalSeconds */.m3)();
    var secondsRemaining = hooks_useCountdown(round.startTimestamp + intervalSeconds + config/* ROUND_BUFFER */.fq).secondsRemaining;
    var countdown = (0,Predictions_helpers/* formatRoundTime */.tw)(secondsRemaining);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        borderBackground: getBorderBackground(theme, "soon"),
        style: {
            height: "439px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                status: "soon",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wait/* default */.Z, {
                    mr: "4px",
                    width: "21px"
                }),
                title: t("Later"),
                epoch: round.epoch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        isDisabled: true,
                        epoch: round.epoch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            textAlign: "center",
                            my: "43px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: t("Entry starts")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "24px",
                                    bold: true,
                                    children: "~".concat(countdown)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        epoch: round.epoch,
                        betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                        isDisabled: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_SoonRoundCard = (SoonRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/index.tsx









var RoundCard = function(param) {
    var round = param.round, isActive = param.isActive;
    var epoch = round.epoch, lockPrice = round.lockPrice, closePrice = round.closePrice, totalAmount = round.totalAmount, bullAmount = round.bullAmount, bearAmount = round.bearAmount;
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ledger = (0,predictions_hooks/* useGetBetByEpoch */.n3)(account, epoch);
    var hasEntered = ledger ? ledger.amount.gt(0) : false;
    var hasEnteredUp = hasEntered && ledger.position === types/* BetPosition.BULL */.Tu.BULL;
    var hasEnteredDown = hasEntered && ledger.position === types/* BetPosition.BEAR */.Tu.BEAR;
    var hasClaimedUp = hasEntered && ledger.claimed && ledger.position === types/* BetPosition.BULL */.Tu.BULL;
    var hasClaimedDown = hasEntered && ledger.claimed && ledger.position === types/* BetPosition.BEAR */.Tu.BEAR;
    // Fake future rounds
    if (epoch > currentEpoch) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_SoonRoundCard, {
            round: round
        });
    }
    var bullMultiplier = (0,Predictions_helpers/* getMultiplierV2 */.jw)(totalAmount, bullAmount);
    var bearMultiplier = (0,Predictions_helpers/* getMultiplierV2 */.jw)(totalAmount, bearAmount);
    var formattedBullMultiplier = bullMultiplier.toUnsafeFloat().toFixed(bullMultiplier.isZero() ? 0 : 2);
    var formattedBearMultiplier = bearMultiplier.toUnsafeFloat().toFixed(bearMultiplier.isZero() ? 0 : 2);
    // Next (open) round
    if (epoch === currentEpoch && lockPrice === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_OpenRoundCard, {
            round: round,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp,
            betAmount: ledger === null || ledger === void 0 ? void 0 : ledger.amount,
            bullMultiplier: formattedBullMultiplier,
            bearMultiplier: formattedBearMultiplier
        });
    }
    // Live round
    if (closePrice === null && epoch === currentEpoch - 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_LiveRoundCard, {
            betAmount: ledger === null || ledger === void 0 ? void 0 : ledger.amount,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp,
            round: round,
            bullMultiplier: formattedBullMultiplier,
            bearMultiplier: formattedBearMultiplier
        });
    }
    // Past rounds
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_ExpiredRoundCard, {
        isActive: isActive,
        round: round,
        hasEnteredDown: hasEnteredDown,
        hasEnteredUp: hasEnteredUp,
        hasClaimedDown: hasClaimedDown,
        hasClaimedUp: hasClaimedUp,
        betAmount: ledger === null || ledger === void 0 ? void 0 : ledger.amount,
        bullMultiplier: formattedBullMultiplier,
        bearMultiplier: formattedBearMultiplier
    });
};
/* harmony default export */ var components_RoundCard = (RoundCard);

// EXTERNAL MODULE: ./src/views/Predictions/hooks/useSwiper.ts
var useSwiper = __webpack_require__(82961);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(87613);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useOnNextRound.ts






/**
 * Hooks for actions to be performed when the round changes
 */ var useOnNextRound = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var ref = (0,predictions_hooks/* useGetSortedRoundsCurrentEpoch */.Aq)(), currentEpoch = ref.currentEpoch, rounds = ref.rounds;
    var roundsEpochsString = JSON.stringify(Object.keys(rounds));
    var previousEpoch = (0,hooks_src/* usePreviousValue */.zP)(currentEpoch);
    var previousRoundsEpochsString = (0,hooks_src/* usePreviousValue */.zP)(roundsEpochsString);
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        if (swiper && currentEpoch && previousEpoch && (currentEpoch !== previousEpoch || roundsEpochsString !== previousRoundsEpochsString)) {
            var currentEpochIndex = rounds.findIndex(function(round) {
                return round.epoch === currentEpoch;
            });
            // Slide to the current LIVE round which is always the one before the current round
            if (currentEpoch !== previousEpoch) {
                swiper.slideTo(currentEpochIndex - 1);
            } else if (!swiper.isBeginning && !swiper.isEnd) {
                swiper.slideTo(swiper.activeIndex - 1, 0);
            }
        }
    }, [
        previousEpoch,
        currentEpoch,
        previousRoundsEpochsString,
        roundsEpochsString,
        rounds,
        swiper,
        account,
        dispatch
    ]);
};
/* harmony default export */ var hooks_useOnNextRound = (useOnNextRound);

;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useOnViewChange.ts



/**
 * Hooks for actions to be performed when the view changes (mobile)
 */ var useOnViewChange = function(liveSwiperIndex, view) {
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var prevView = (0,hooks_src/* usePreviousValue */.zP)(view);
    (0,react.useEffect)(function() {
        if (swiper && view !== prevView && swiper.activeIndex !== liveSwiperIndex) {
            swiper.slideTo(liveSwiperIndex, 0.1);
        }
    }, [
        swiper,
        prevView,
        view,
        liveSwiperIndex
    ]);
};
/* harmony default export */ var hooks_useOnViewChange = (useOnViewChange);

;// CONCATENATED MODULE: ./src/views/Predictions/Positions.tsx

function Positions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .swiper-wrapper {\n    align-items: center;\n    display: flex;\n  }\n\n  .swiper-slide {\n    width: 320px;\n  }\n"
    ]);
    Positions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var StyledSwiper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5924c152-0"
})(Positions_templateObject());
var Positions = function(param) {
    var view = param.view;
    var ref = (0,useSwiper/* default */.Z)(), setSwiper = ref.setSwiper, swiper = ref.swiper;
    var ref1 = (0,predictions_hooks/* useGetSortedRoundsCurrentEpoch */.Aq)(), currentEpoch = ref1.currentEpoch, rounds = ref1.rounds;
    var previousEpoch = currentEpoch > 0 ? currentEpoch - 1 : currentEpoch;
    var swiperIndex = rounds.findIndex(function(round) {
        return round.epoch === previousEpoch;
    });
    hooks_useOnNextRound();
    hooks_useOnViewChange(swiperIndex, view);
    (0,react.useEffect)(function() {
        var ref;
        var handleChartDotClick = function() {
            setIsChangeTransition(true);
            delay_default()(function() {
                return setIsChangeTransition(false);
            }, 3000);
        };
        swiper === null || swiper === void 0 ? void 0 : (ref = swiper.el) === null || ref === void 0 ? void 0 : ref.addEventListener(Predictions_helpers/* CHART_DOT_CLICK_EVENT */.o4, handleChartDotClick);
        return function() {
            var ref;
            swiper === null || swiper === void 0 ? void 0 : (ref = swiper.el) === null || ref === void 0 ? void 0 : ref.removeEventListener(Predictions_helpers/* CHART_DOT_CLICK_EVENT */.o4, handleChartDotClick);
        };
    }, [
        swiper === null || swiper === void 0 ? void 0 : swiper.el
    ]);
    var ref2 = (0,react.useState)(false), isChangeTransition = ref2[0], setIsChangeTransition = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            initialSlide: swiperIndex,
            onSwiper: setSwiper,
            spaceBetween: 16,
            slidesPerView: "auto",
            onBeforeDestroy: function() {
                return setSwiper(null);
            },
            freeMode: {
                enabled: true,
                sticky: true,
                momentumRatio: 0.25,
                momentumVelocityRatio: 0.5
            },
            centeredSlides: true,
            mousewheel: true,
            keyboard: true,
            resizeObserver: true,
            children: rounds.map(function(round) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: function(param) {
                        var isActive = param.isActive;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoundCard, {
                            round: round,
                            isActive: isChangeTransition && isActive
                        });
                    }
                }, round.epoch);
            })
        })
    });
};
/* harmony default export */ var Predictions_Positions = (Positions);

;// CONCATENATED MODULE: ./src/views/Predictions/components/LoadingSection.tsx


function LoadingSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        justifyContent: "center",
        width: "100%",
        alignItems: "center",
        height: "404px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
    });
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BigHelp.tsx
var BigHelp = __webpack_require__(83330);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 2 modules
var constants = __webpack_require__(56927);
;// CONCATENATED MODULE: ./src/views/Predictions/components/LabelPrice.tsx

function LabelPrice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 18px;\n  justify-self: start;\n  width: 70px;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    LabelPrice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Price = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-551592e6-0"
})(LabelPrice_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var LabelPrice = function(param) {
    var price = param.price;
    var priceAsNumber = (0,react.useMemo)(function() {
        return parseFloat((0,formatBalance/* formatBigNumberToFixed */.U1)(price, 4, 8));
    }, [
        price
    ]);
    if (!Number.isFinite(priceAsNumber)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        start: 0,
        preserveValue: true,
        delay: 0,
        end: priceAsNumber,
        prefix: "$",
        decimals: 4,
        duration: 1,
        children: function(param) {
            var countUpRef = param.countUpRef;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                fontSize: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: countUpRef
                })
            });
        }
    });
};
/* harmony default export */ var components_LabelPrice = (/*#__PURE__*/(0,react.memo)(LabelPrice));

;// CONCATENATED MODULE: ./src/views/Predictions/components/Label.tsx

function Label_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 58px;\n  width: 150px;\n  padding: 13px 20px; \n"
    ]);
    Label_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Label_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -24px;\n  position: absolute;\n  top: 50%;\n  z-index: 30;\n\n  & > svg {\n    height: 48px;\n    width: 48px;\n  }\n\n  ",
        " {\n    margin-top: -32px;\n\n    & > svg {\n      height: 64px;\n      width: 64px;\n    }\n  }\n"
    ]);
    Label_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Label_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: -0.54px; \n\n  ",
        " {\n    font-size: 18px;\n    line-height: 100%;\n  }\n"
    ]);
    Label_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Label_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 9px;\n  line-height: 21px;\n\n  ",
        " {\n    font-size: 16px;\n  }\n\n  ",
        " {\n    font-size: 20px;\n    line-height: 22px;\n  }\n"
    ]);
    Label_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Label_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    text-align: center;\n    width: 32px;\n  }\n"
    ]);
    Label_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Label_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%{\n    opacity:0;\n  }\n  20%{\n    opacity:1;\n  }\n  30%{\n    transform: translateX(5px);\n  }\n  40%{\n    transform: translateX(0px);\n  }\n  50%{\n    transform: translateX(5px);\n  }\n  60%{\n    transform: translateX(5px);\n  }\n  100%{\n    opacity:1;\n  }\n"
    ]);
    Label_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Label_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -5px;\n  left: 55px;\n  border-radius: 16px;\n  padding: 16px;\n  background: ",
        ";\n  box-shadow: ",
        ";\n  white-space: nowrap;\n  opacity: 0;\n  z-index: 100;\n  animation: ",
        " 3s forwards ease-in-out;\n  ",
        ",svg {\n    color: ",
        ";\n  }\n  ",
        " {\n    top: -10px;\n    left: 81px;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 21px;\n    left: -6px;\n    width: 15px;\n    height: 15px;\n    border-radius: 3px;\n    background: ",
        ";\n    transform: rotate(45deg);\n  }\n"
    ]);
    Label_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Label_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  align-items: ",
        ";\n  border-radius: ",
        ";\n  flex-direction: column;\n  overflow: initial;\n  padding: ",
        ";\n\n  ",
        " {\n    background-color: ",
        ";\n    align-items: center;\n    border-radius: ",
        ";\n    flex-direction: row;\n    padding: ",
        ";\n    transition: 0.3s background-color ease-in-out;\n    will-change: background-color;\n  }\n"
    ]);
    Label_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}














// should be ButtonMenuItem when more pairs are added
var StyledMenuitem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7f6465e1-0"
})(Label_templateObject());
var Token = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-7f6465e1-1"
})(Label_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-7f6465e1-2"
})(Label_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var ClosingTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-7f6465e1-3"
})(Label_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Interval = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-7f6465e1-4"
})(Label_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var tooltipAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(Label_templateObject5());
var Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f6465e1-5"
})(Label_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, tooltipAnimation, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.tooltip.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
});
var Label = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7f6465e1-6"
})(Label_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.level1;
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "flex-end" : "flex-start";
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "8px 8px 8px 24px" : "8px 8px 24px 8px";
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "0 28px 0 8px" : "0 8px 0 24px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme, backgroundOpacity = param.backgroundOpacity;
    return backgroundOpacity ? "transparent" : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "8px 40px 8px 8px" : "8px 8px 8px 40px";
});
var PricePairLabel = function() {
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var router = (0,next_router.useRouter)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var ref = (0,react.useState)(function() {
        if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* PREDICTION_TOOLTIP_DISMISS_KEY */.bF)) return true;
        return false;
    }), dismissTooltip = ref[0], setDismissTooltip = ref[1];
    var onDismissTooltip = (0,react.useCallback)(function() {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(constants/* PREDICTION_TOOLTIP_DISMISS_KEY */.bF, "1");
        setDismissTooltip(true);
    }, []);
    var onTokenSwitch = (0,react.useCallback)(function() {
        if (router.query.token === types/* PredictionSupportedSymbol.CAKE */.ru.CAKE) {
            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
        } else if (router.query.token === undefined && token.symbol === types/* PredictionSupportedSymbol.CAKE */.ru.CAKE) {
            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
        } else if (router.query.token === undefined && token.symbol === types/* PredictionSupportedSymbol.BNB */.ru.BNB) {
            router.query.token = types/* PredictionSupportedSymbol.CAKE */.ru.CAKE;
        } else if (token.symbol === undefined && router.query.token === undefined) {
            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
        } else {
            router.query.token = types/* PredictionSupportedSymbol.CAKE */.ru.CAKE;
        }
        if (!dismissTooltip) onDismissTooltip();
        router.replace(router, undefined, {
            scroll: false
        });
    }, [
        router,
        token,
        dismissTooltip,
        onDismissTooltip
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            pl: [
                "20px",
                "20px",
                "20px",
                "20px",
                "40px"
            ],
            position: "relative",
            display: "inline-block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuitem, {
                    mb: "25px",
                    // side='left'
                    // isActive={router.query.token === PredictionSupportedSymbol.BNB}
                    style: {
                        border: "none",
                        cursor: "default"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "14px",
                                textAlign: "left",
                                mb: "3px",
                                children: "Traded pair"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                textAlign: "left",
                                mb: "3px",
                                className: "syncopate",
                                fontSize: "18px",
                                bold: true,
                                textTransform: "uppercase",
                                children: "ETH-USD"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LabelPrice, {
                                price: price
                            })
                        ]
                    })
                })
            })
        })
    });
};
var TimerLabel = function(param) {
    var interval = param.interval, unit = param.unit;
    var currentRoundCloseTimestamp = useGetCurrentRoundCloseTimestamp();
    var secondsRemaining = useCountdown(currentRoundCloseTimestamp).secondsRemaining;
    var countdown = formatRoundTime(secondsRemaining);
    var t = useTranslation().t;
    if (!currentRoundCloseTimestamp) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Box, {
        pr: "24px",
        position: "relative",
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                dir: "right",
                children: [
                    secondsRemaining !== 0 ? /*#__PURE__*/ _jsx(Title, {
                        bold: true,
                        color: "secondary",
                        children: countdown
                    }) : /*#__PURE__*/ _jsx(ClosingTitle, {
                        bold: true,
                        color: "secondary",
                        children: t("Closing")
                    }),
                    /*#__PURE__*/ _jsx(Interval, {
                        fontSize: "12px",
                        children: "".concat(interval).concat(t(unit))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Token, {
                right: 0,
                children: /*#__PURE__*/ _jsx(PocketWatchIcon, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(18029);
;// CONCATENATED MODULE: ./src/views/Predictions/components/PrevNextNav.tsx

function PrevNextNav_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: none;\n  justify-content: space-between;\n  overflow: initial;\n  position: relative;\n  gap: 10px;\n\n  box-shadow: ",
        ";\n\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    PrevNextNav_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrevNextNav_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  left: 50%;\n  margin-left: -32px;\n  position: absolute;\n"
    ]);
    PrevNextNav_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PrevNextNav_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background: transparent;\n  width: 44px;\n  height: 44px;\n  padding: 10px 14px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;  \n  border-radius: 100px !important; \n  border: 1px solid ",
        ";\n"
    ]);
    PrevNextNav_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledPrevNextNav = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-24854509-0"
})(PrevNextNav_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.level1;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24854509-1"
})(PrevNextNav_templateObject1());
var RoundButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-24854509-2"
})(PrevNextNav_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var PrevNextNav = function() {
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var ref = (0,predictions_hooks/* useGetSortedRoundsCurrentEpoch */.Aq)(), currentEpoch = ref.currentEpoch, rounds = ref.rounds;
    var handlePrevSlide = function() {
        swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    var handleNextSlide = function() {
        swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    var handleSlideToLive = function() {
        if (swiper) {
            var currentEpochIndex = rounds.findIndex(function(round) {
                return round.epoch === currentEpoch;
            });
            swiper.slideTo(currentEpochIndex - 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrevNextNav, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton, {
                variant: "text",
                scale: "sm",
                onClick: handlePrevSlide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                    color: "text",
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton, {
                variant: "text",
                scale: "sm",
                onClick: handleNextSlide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                    color: "text",
                    width: "24px"
                })
            })
        ]
    });
};
/* harmony default export */ var components_PrevNextNav = (PrevNextNav);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/History.tsx
var Icons_History = __webpack_require__(66806);
;// CONCATENATED MODULE: ./src/views/Predictions/components/HistoryButton.tsx






var HistoryButton = function() {
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleClick = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        id: "prediction-history-button",
        variant: "subtle",
        onClick: handleClick,
        isLoading: isFetchingHistory,
        disabled: !account,
        style: {
            background: "none",
            border: "none"
        },
        children: isFetchingHistory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "white"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_History/* default */.Z, {
            width: "40px",
            color: "textSubtle"
        })
    });
};
/* harmony default export */ var components_HistoryButton = (HistoryButton);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Menu.tsx

function Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  width: auto;\n\n  ",
        " {\n    width: 270px;\n  }\n"
    ]);
    Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Menu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n  margin: 0 2px 0 8px;\n\n  ",
        " {\n    order: 2;\n    margin: 0 0 0 8px;\n  }\n"
    ]);
    Menu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Menu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 3;\n  width: 100px;\n\n  ",
        " {\n    order: 1;\n    width: auto;\n  }\n"
    ]);
    Menu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Menu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  order: 2;\n  margin: 0 8px 0 0;\n\n  ",
        " {\n    order: 3;\n    margin: 0 0 0 8px;\n  }\n"
    ]);
    Menu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Menu_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    margin-left: 8px;\n  }\n"
    ]);
    Menu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Menu_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  width: 48px;\n  height: 60px;\n  background: none;\n  box-shadow: none;\n  svg{\n    width: 40px;\n  }\n"
    ]);
    Menu_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var SetCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c45cfdef-0"
})(Menu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var HelpButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c45cfdef-1"
})(Menu_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TimerLabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c45cfdef-2"
})(Menu_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LeaderboardButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c45cfdef-3"
})(Menu_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c45cfdef-4"
})(Menu_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var CustomButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-c45cfdef-5"
})(Menu_templateObject5());
var Menu = function() {
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FlexRow, {
        alignItems: "center",
        p: "16px",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SetCol, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePairLabel, {})
            }),
            status === types/* PredictionStatus.LIVE */.Gw.LIVE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FlexRow, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PrevNextNav, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SetCol, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpButtonWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                                        as: "a",
                                        href: "https://docs.alienbase.xyz/predictions",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BigHelp/* default */.Z, {
                                            width: "40px",
                                            color: "white"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                                    style: {
                                        order: 4
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HistoryButton, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Menu = (Menu);

;// CONCATENATED MODULE: ./src/views/Predictions/Desktop.tsx

function Desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: transparent;\n  border-bottom: 1px solid ",
        ";\n  left: 50%;\n  transform: translateX(-50%);\n  position: absolute;\n  display: none;\n  border-radius: 24px 24px 0 0;\n  z-index: 50;\n  backdrop-filter: blur(10px);\n  ",
        " {\n    display: inline-flex;\n  }\n"
    ]);
    Desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: transparent;\n  border-bottom: 1px solid ",
        ";\n  display: none;\n  border-radius: 24px 24px 0 0;\n  z-index: 50;\n  ",
        " {\n    display: inline-flex;\n  }\n  @media only screen and (max-width: 966px) {\n    width: 100%;\n    background: ",
        ";\n  }\n"
    ]);
    Desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Desktop_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 24px 0;\n  flex: 1;\n  overflow: hidden;\n"
    ]);
    Desktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Desktop_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  background: ",
        ";\n"
    ]);
    Desktop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Desktop_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  border-left: 1px solid ",
        ";\n  overflow: hidden;\n  transition: width 200ms ease-in-out;\n  background: ",
        ";\n  padding-bottom: ",
        ";\n  width: ",
        ";\n"
    ]);
    Desktop_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Desktop_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: flex;\n    height: calc(100vh - 100px);\n  }\n"
    ]);
    Desktop_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Desktop_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  max-width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  & > div {\n    flex: 1;\n    overflow: hidden;\n  }\n"
    ]);
    Desktop_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Desktop_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  cursor: ",
        ";\n  height: 2px;\n  position: relative;\n"
    ]);
    Desktop_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 16px;\n  top: -90px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






















var ChainlinkChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9782), __webpack_require__.e(265), __webpack_require__.e(9386)]).then(__webpack_require__.bind(__webpack_require__, 9386));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9386)
            ];
        }
    },
    ssr: false
});
// The value to set the chart when the user clicks the chart tab at the bottom
var GRID_TEMPLATE_ROW = "1.2fr 24px .8fr";
var ExpandContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1c990de-0"
})(Desktop_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var ExpandButtonGroup = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1c990de-1"
})(Desktop_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.colors.modalBg;
});
var SplitWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-2"
})(Desktop_templateObject2());
var ChartPane = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-3"
})(Desktop_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var HistoryPane = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-4"
})(Desktop_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.borderModal;
}, function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var isChartPaneOpen = param.isChartPaneOpen;
    return isChartPaneOpen ? 0 : "24px";
}, function(param) {
    var isHistoryPaneOpen = param.isHistoryPaneOpen;
    return isHistoryPaneOpen ? "384px" : 0;
});
var StyledDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-5"
})(Desktop_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PositionPane = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-6"
})(Desktop_templateObject6());
var Gutter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-7"
})(Desktop_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.modalBg;
}, function(param) {
    var isChartPaneOpen = param.isChartPaneOpen;
    return isChartPaneOpen ? "row-resize" : "pointer";
});
var PowerLinkStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c990de-8"
})(_templateObject8());
var Desktop = function() {
    var splitWrapperRef = (0,react.useRef)();
    var chartRef = (0,react.useRef)();
    var gutterRef = (0,react.useRef)();
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isChartPaneOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var chartView = (0,predictions_hooks/* useChartView */.WR)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var openChartPane = function() {
        splitWrapperRef.current.style.transition = "grid-template-rows 150ms";
        splitWrapperRef.current.style.gridTemplateRows = GRID_TEMPLATE_ROW;
        // Purely comedic: We only want to animate if we are clicking the open chart button
        // If we keep the transition on the resizing becomes very choppy
        delay_default()(function() {
            splitWrapperRef.current.style.transition = "";
        }, 150);
        dispatch((0,predictions/* setChartPaneState */.nQ)(true));
    };
    var splitInstance = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var height = chartRef.current.getBoundingClientRect().height;
        if (height > 0 && !isChartPaneOpen) {
            dispatch((0,predictions/* setChartPaneState */.nQ)(true));
        }
    }, [
        isChartPaneOpen,
        dispatch
    ]);
    // unmount
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,predictions/* setChartPaneState */.nQ)(false));
        };
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        var threshold = 100;
        var handleDrag = debounce_default()(function() {
            var height = chartRef.current.getBoundingClientRect().height;
            // If the height of the chart pane goes below the "snapOffset" threshold mark the chart pane as closed
            dispatch((0,predictions/* setChartPaneState */.nQ)(height > threshold));
        }, 50);
        if (isChartPaneOpen && !splitInstance.current) {
            splitInstance.current = (0,split_grid/* default */.Z)({
                dragInterval: 1,
                snapOffset: threshold,
                onDrag: handleDrag,
                rowGutters: [
                    {
                        track: 1,
                        element: gutterRef.current
                    }, 
                ]
            });
        } else if (!isChartPaneOpen && splitInstance.current) {
            var ref;
            (ref = splitInstance.current) === null || ref === void 0 ? void 0 : ref.destroy();
            splitInstance.current = undefined;
        }
        return function() {
            var ref;
            (ref = splitInstance.current) === null || ref === void 0 ? void 0 : ref.destroy();
            splitInstance.current = undefined;
        };
    }, [
        gutterRef,
        chartRef,
        dispatch,
        isChartPaneOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktop, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SplitWrapper, {
                    ref: splitWrapperRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PositionPane, {
                            children: [
                                status === types/* PredictionStatus.ERROR */.Gw.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_ErrorNotification, {}),
                                status === types/* PredictionStatus.PAUSED */.Gw.PAUSED && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_PauseNotification, {}),
                                [
                                    types/* PredictionStatus.INITIAL */.Gw.INITIAL,
                                    types/* PredictionStatus.LIVE */.Gw.LIVE
                                ].includes(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    mt: "-100px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {}),
                                        status === types/* PredictionStatus.LIVE */.Gw.LIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Positions, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSection, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gutter, {
                            ref: gutterRef,
                            isChartPaneOpen: isChartPaneOpen,
                            onClick: function() {
                                openChartPane();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PowerLinkStyle, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        style: {
                                            position: "relative",
                                            zIndex: 1
                                        },
                                        src: "/images/powered-by-chainlink.png",
                                        alt: "Powered by ChainLink",
                                        width: "170px",
                                        height: "48px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandButtonGroup, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                                                height: "42px",
                                                as: Button/* default */.Z,
                                                style: {
                                                    whiteSpace: "nowrap",
                                                    alignItems: "center"
                                                },
                                                isActive: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView,
                                                onMouseDown: function(e) {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.TradingView */.RU.TradingView));
                                                },
                                                children: [
                                                    chartView === types/* PredictionsChartView.TradingView */.RU.TradingView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                                        mr: "10px"
                                                    }),
                                                    " TradingView ",
                                                    t("Chart")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                                                as: Button/* default */.Z,
                                                height: "42px",
                                                style: {
                                                    whiteSpace: "nowrap",
                                                    alignItems: "center"
                                                },
                                                isActive: chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink,
                                                onMouseDown: function(e) {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.Chainlink */.RU.Chainlink));
                                                },
                                                children: [
                                                    chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                                        mr: "10px"
                                                    }),
                                                    " Chainlink ",
                                                    t("Chart")
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                isChartPaneOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartbyLabel_ChartByLabel, {
                                    justifyContent: "flex-end",
                                    symbol: "".concat(token.symbol, "/USD"),
                                    by: chartView,
                                    linkProps: {
                                        onMouseDown: function(e) {
                                            window.open(chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? "https://www.tradingview.com/chart/?symbol=BINANCE%3A".concat(token.symbol, "USD") : "https://chain.link/data-feeds", "_blank", "noopener noreferrer");
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }
                                    },
                                    link: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? "https://www.tradingview.com/chart/?symbol=BINANCE%3A".concat(token.symbol, "USD") : "https://chain.link/data-feeds"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartPane, {
                            ref: chartRef,
                            children: isChartPaneOpen && (chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_components_TradingView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainlinkChart, {}))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryPane, {
                    isHistoryPaneOpen: isHistoryPaneOpen,
                    isChartPaneOpen: isChartPaneOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_History, {})
                })
            ]
        })
    });
};
/* harmony default export */ var Predictions_Desktop = (/*#__PURE__*/(0,react.memo)(Desktop));

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/usePollPredictions.ts






var POLL_TIME_IN_SECONDS = 10;
var usePollPredictions = function() {
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    (0,swr_dist/* default */.ZP)(status !== types/* PredictionStatus.INITIAL */.Gw.INITIAL ? [
        "predictions",
        account
    ] : null, function() {
        return dispatch((0,predictions/* fetchPredictionData */.S9)(account));
    }, {
        refreshInterval: POLL_TIME_IN_SECONDS * 1000,
        refreshWhenHidden: true,
        refreshWhenOffline: true
    });
};
/* harmony default export */ var hooks_usePollPredictions = (usePollPredictions);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Cards.tsx
var Cards = __webpack_require__(87907);
;// CONCATENATED MODULE: ./src/views/Predictions/components/MobileMenu.tsx

function MobileMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n"
    ]);
    MobileMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  text-align: center;\n"
    ]);
    MobileMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex: none;\n  height: 64px;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    MobileMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var ButtonNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-604e8f03-0"
})(MobileMenu_templateObject());
var TabNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-604e8f03-1"
})(MobileMenu_templateObject1());
var StyledMobileMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-604e8f03-2"
})(MobileMenu_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var getActiveIndex = function(isHistoryOpen, isChartOpen) {
    if (isHistoryOpen) {
        return 2;
    }
    if (isChartOpen) {
        return 1;
    }
    return 0;
};
var MobileMenu = function() {
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var isHistoryOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isChartOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var activeIndex = getActiveIndex(isHistoryOpen, isChartOpen);
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleItemClick = function(index) {
        switch(index){
            case 2:
                dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
                break;
            case 1:
                dispatch((0,predictions/* setChartPaneState */.nQ)(true));
                dispatch((0,predictions/* setHistoryPaneState */.vR)(false));
                break;
            case 0:
            default:
                dispatch((0,predictions/* setHistoryPaneState */.vR)(false));
                dispatch((0,predictions/* setChartPaneState */.nQ)(false));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileMenu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonNav, {
                style: {
                    marginLeft: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    style: {
                        border: "none"
                    },
                    variant: "text",
                    onClick: function() {
                        return swiper.slidePrev();
                    },
                    disabled: status !== types/* PredictionStatus.LIVE */.Gw.LIVE,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        width: "24px",
                        color: "text"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabNav, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            side: "left",
                            isActive: activeIndex === 0,
                            onClick: function() {
                                return handleItemClick(0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards/* default */.Z, {
                                color: "currentColor"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            side: "center",
                            isActive: activeIndex === 1,
                            onClick: function() {
                                return handleItemClick(1);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                color: "currentColor"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            side: "right",
                            disabled: !account,
                            isActive: activeIndex === 2,
                            onClick: function() {
                                return handleItemClick(2);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_History/* default */.Z, {
                                color: "currentColor"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonNav, {
                style: {
                    marginRight: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    style: {
                        border: "none"
                    },
                    variant: "text",
                    onClick: function() {
                        return swiper.slideNext();
                    },
                    disabled: status !== types/* PredictionStatus.LIVE */.Gw.LIVE,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                        width: "24px",
                        color: "text"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./src/views/Predictions/MobileChart.tsx

function MobileChart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n"
    ]);
    MobileChart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileChart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  height: 100%;\n  background-color: transparent;\n"
    ]);
    MobileChart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileChart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  height: 100%;\n  @media only screen and (max-width: 575px) and (max-height: 739px) {\n    height: 100vh;\n  }\n"
    ]);
    MobileChart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var MobileChart_ChainlinkChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9782), __webpack_require__.e(265), __webpack_require__.e(9386)]).then(__webpack_require__.bind(__webpack_require__, 9386));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9386)
            ];
        }
    },
    ssr: false
});
var MenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df02d424-0"
})(MobileChart_templateObject());
var ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df02d424-1"
})(MobileChart_templateObject1());
var MobileChartWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-df02d424-2"
})(MobileChart_templateObject2());
var MobileChart = function() {
    var chartView = (0,predictions_hooks/* useChartView */.WR)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileChartWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "min-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggleGroup */._, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                            isActive: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView,
                            onClick: function() {
                                return dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.TradingView */.RU.TradingView));
                            },
                            children: [
                                "TradingView ",
                                t("Chart")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                            isActive: chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink,
                            onClick: function() {
                                return dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.Chainlink */.RU.Chainlink));
                            },
                            children: [
                                "Chainlink ",
                                t("Chart")
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartWrapper, {
                children: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_components_TradingView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileChart_ChainlinkChart, {
                    pt: "8px",
                    isMobile: true
                })
            })
        ]
    });
};
/* harmony default export */ var Predictions_MobileChart = (MobileChart);

;// CONCATENATED MODULE: ./src/views/Predictions/types.ts
var PageView;
(function(PageView) {
    PageView["POSITIONS"] = "positions";
    PageView["HISTORY"] = "history";
    PageView["CHART"] = "chart";
})(PageView || (PageView = {}));

;// CONCATENATED MODULE: ./src/views/Predictions/Mobile.tsx

function Mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 100%;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    Mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Mobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 16px;\n"
    ]);
    Mobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var StyledMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0f7bd8e-0"
})(Mobile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var Mobile_PowerLinkStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0f7bd8e-1"
})(Mobile_templateObject1());
var getView = function(isHistoryPaneOpen, isChartPaneOpen) {
    if (isHistoryPaneOpen) {
        return PageView.HISTORY;
    }
    if (isChartPaneOpen) {
        return PageView.CHART;
    }
    return PageView.POSITIONS;
};
var Mobile = function() {
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isChartPaneOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var view = getView(isHistoryPaneOpen, isChartPaneOpen);
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobile, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                height: "100%",
                children: [
                    view === PageView.POSITIONS && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        minHeight: "100%",
                        children: [
                            status === types/* PredictionStatus.ERROR */.Gw.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_ErrorNotification, {}),
                            status === types/* PredictionStatus.PAUSED */.Gw.PAUSED && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_PauseNotification, {}),
                            [
                                types/* PredictionStatus.INITIAL */.Gw.INITIAL,
                                types/* PredictionStatus.LIVE */.Gw.LIVE
                            ].includes(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {}),
                                    status === types/* PredictionStatus.LIVE */.Gw.LIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Positions, {
                                        view: view
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSection, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_PowerLinkStyle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/powered-by-chainlink.png",
                                            alt: "Powered by ChainLink",
                                            style: {
                                                width: "170px",
                                                maxHeight: "100%"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    view === PageView.CHART && /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_MobileChart, {}),
                    view === PageView.HISTORY && /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_History, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileMenu, {})
        ]
    });
};
/* harmony default export */ var Predictions_Mobile = (/*#__PURE__*/(0,react.memo)(Mobile));

;// CONCATENATED MODULE: ./src/views/Predictions/index.tsx





















function Warnings() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChartDisclaimerShow */.TL)(), 1), showDisclaimer = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChainlinkChartDisclaimerShow */.sg)(), 1), showChainlinkDisclaimer = ref1[0];
    var isChartPaneOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var chartView = (0,predictions_hooks/* useChartView */.WR)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChartDisclaimer, {}), false), 1), onPresentChartDisclaimer = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ChainlinkChartDisclaimer, {}), false), 1), onPresentChainlinkChartDisclaimer = ref3[0];
    // TODO: memoize modal's handlers
    var onPresentChartDisclaimerRef = (0,react.useRef)(onPresentChartDisclaimer);
    var onPresentChainlinkChartDisclaimerRef = (0,react.useRef)(onPresentChainlinkChartDisclaimer);
    // Chart Disclaimer
    (0,react.useEffect)(function() {
        if (isChartPaneOpen && showDisclaimer && chartView === types/* PredictionsChartView.TradingView */.RU.TradingView) {
            onPresentChartDisclaimerRef.current();
        }
    }, [
        onPresentChartDisclaimerRef,
        isChartPaneOpen,
        showDisclaimer,
        chartView
    ]);
    // Chainlink Disclaimer
    (0,react.useEffect)(function() {
        if (isChartPaneOpen && showChainlinkDisclaimer && chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink) {
            onPresentChainlinkChartDisclaimerRef.current();
        }
    }, [
        onPresentChainlinkChartDisclaimerRef,
        isChartPaneOpen,
        showChainlinkDisclaimer,
        chartView
    ]);
    return null;
}
var Predictions = function() {
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var initialBlock = (0,hooks/* useInitialBlock */.Xh)();
    useAccountLocalEventListener();
    (0,react.useEffect)(function() {
        if (initialBlock > 0) {
            // Do not start initialization until the first block has been retrieved
            dispatch((0,predictions/* initializePredictions */.uw)(account));
        }
    }, [
        initialBlock,
        dispatch,
        account
    ]);
    hooks_usePollPredictions();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Warnings, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RiskDisclaimer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperProvider/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Desktop, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Mobile, {})
                })
            })
        ]
    });
};
/* harmony default export */ var views_Predictions = (Predictions);

;// CONCATENATED MODULE: ./src/pages/prediction/index.tsx



function Prediction() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Predictions, {});
}
Prediction.Layout = PredictionConfigProviders/* default */.Z;


/***/ }),

/***/ 89890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WR": function() { return /* binding */ useChartView; },
  "Dh": function() { return /* binding */ useCollectWinningModalProps; },
  "n3": function() { return /* binding */ useGetBetByEpoch; },
  "XM": function() { return /* binding */ useGetBufferSeconds; },
  "dJ": function() { return /* binding */ useGetCurrentEpoch; },
  "Gc": function() { return /* binding */ useGetCurrentHistoryPage; },
  "ds": function() { return /* binding */ useGetCurrentRoundCloseTimestamp; },
  "sz": function() { return /* binding */ useGetHasHistoryLoaded; },
  "pw": function() { return /* binding */ useGetHistory; },
  "J7": function() { return /* binding */ useGetHistoryFilter; },
  "m3": function() { return /* binding */ useGetIntervalSeconds; },
  "Wx": function() { return /* binding */ useGetIsClaimable; },
  "dW": function() { return /* binding */ useGetIsFetchingHistory; },
  "YY": function() { return /* binding */ useGetLeaderboardFilters; },
  "Gy": function() { return /* binding */ useGetLeaderboardHasMoreResults; },
  "AC": function() { return /* binding */ useGetLeaderboardLoadingState; },
  "HF": function() { return /* binding */ useGetLeaderboardResults; },
  "Ok": function() { return /* binding */ useGetLeaderboardSkip; },
  "eI": function() { return /* binding */ useGetMinBetAmount; },
  "nB": function() { return /* binding */ useGetOrFetchLeaderboardAddressResult; },
  "hU": function() { return /* binding */ useGetPredictionsStatus; },
  "Z_": function() { return /* binding */ useGetRoundsByCloseOracleId; },
  "dm": function() { return /* binding */ useGetSortedRounds; },
  "Aq": function() { return /* binding */ useGetSortedRoundsCurrentEpoch; },
  "YF": function() { return /* binding */ useIsChartPaneOpen; },
  "e": function() { return /* binding */ useIsHistoryPaneOpen; },
  "b1": function() { return /* binding */ useStatModalProps; }
});

// UNUSED EXPORTS: useGetAddressResult, useGetSelectedAddress

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/useLocalDispatch.ts
var useLocalDispatch = __webpack_require__(29807);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/Provider.tsx
var Provider = __webpack_require__(13351);
;// CONCATENATED MODULE: ./src/contexts/LocalRedux/useSelector.ts


var useSelector = (0,es/* createSelectorHook */.gR)(Provider/* LocalContext */.A);
/* harmony default export */ var LocalRedux_useSelector = (useSelector);

// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/state/predictions/helpers.ts + 6 modules
var helpers = __webpack_require__(79279);
;// CONCATENATED MODULE: ./src/state/predictions/selectors.ts







var selectCurrentEpoch = function(state) {
    return state.currentEpoch;
};
var selectRounds = function(state) {
    return state.rounds;
};
var selectLedgers = function(state) {
    return state.ledgers;
};
var selectClaimableStatuses = function(state) {
    return state.claimableStatuses;
};
var selectMinBetAmount = function(state) {
    return state.minBetAmount;
};
var selectIntervalSeconds = function(state) {
    return state.intervalSeconds;
};
var makeGetBetByEpochSelector = function(account, epoch) {
    return (0,reselect_es/* createSelector */.P1)([
        selectLedgers
    ], function(bets) {
        if (!bets[account]) {
            return null;
        }
        if (!bets[account][epoch]) {
            return null;
        }
        return (0,helpers/* parseBigNumberObj */.zN)(bets[account][epoch]);
    });
};
var makeGetIsClaimableSelector = function(epoch) {
    return (0,reselect_es/* createSelector */.P1)([
        selectClaimableStatuses
    ], function(claimableStatuses) {
        return claimableStatuses[epoch] || false;
    });
};
var getRoundsByCloseOracleIdSelector = (0,reselect_es/* createSelector */.P1)([
    selectRounds
], function(rounds) {
    return Object.keys(rounds).reduce(function(accum, epoch) {
        var parsed = (0,helpers/* parseBigNumberObj */.zN)(rounds[epoch]);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, parsed.closeOracleId, parsed));
    }, {});
});
var getBigNumberRounds = (0,reselect_es/* createSelector */.P1)([
    selectRounds
], function(rounds) {
    return Object.keys(rounds).reduce(function(accum, epoch) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, epoch, (0,helpers/* parseBigNumberObj */.zN)(rounds[epoch])));
    }, {});
});
var getSortedRoundsSelector = (0,reselect_es/* createSelector */.P1)([
    getBigNumberRounds
], function(rounds) {
    return orderBy_default()(Object.values(rounds), [
        "epoch"
    ], [
        "asc"
    ]);
});
var getSortedRoundsCurrentEpochSelector = (0,reselect_es/* createSelector */.P1)([
    selectCurrentEpoch,
    getSortedRoundsSelector
], function(currentEpoch, sortedRounds) {
    return {
        currentEpoch: currentEpoch,
        rounds: sortedRounds
    };
});
var getMinBetAmountSelector = (0,reselect_es/* createSelector */.P1)([
    selectMinBetAmount
], bignumber/* BigNumber.from */.O$.from);
var getCurrentRoundCloseTimestampSelector = (0,reselect_es/* createSelector */.P1)([
    selectCurrentEpoch,
    getBigNumberRounds,
    selectIntervalSeconds
], function(currentEpoch, rounds, intervalSeconds) {
    if (!currentEpoch) {
        return undefined;
    }
    var currentRound = rounds[currentEpoch - 1];
    if (!currentRound) {
        return undefined;
    }
    if (!currentRound.closeTimestamp) {
        return currentRound.lockTimestamp + intervalSeconds;
    }
    return currentRound.closeTimestamp;
});

;// CONCATENATED MODULE: ./src/state/predictions/hooks.ts






var useGetRoundsByCloseOracleId = function() {
    return LocalRedux_useSelector(getRoundsByCloseOracleIdSelector);
};
var useGetSortedRounds = function() {
    return LocalRedux_useSelector(getSortedRoundsSelector);
};
var useGetSortedRoundsCurrentEpoch = function() {
    return LocalRedux_useSelector(getSortedRoundsCurrentEpochSelector);
};
var useGetBetByEpoch = function(account, epoch) {
    var getBetByEpochSelector = (0,react.useMemo)(function() {
        return makeGetBetByEpochSelector(account, epoch);
    }, [
        account,
        epoch
    ]);
    return LocalRedux_useSelector(getBetByEpochSelector);
};
var useGetIsClaimable = function(epoch) {
    var getIsClaimableSelector = (0,react.useMemo)(function() {
        return makeGetIsClaimableSelector(epoch);
    }, [
        epoch
    ]);
    return LocalRedux_useSelector(getIsClaimableSelector);
};
var useIsHistoryPaneOpen = function() {
    return LocalRedux_useSelector(function(state) {
        return state.isHistoryPaneOpen;
    });
};
var useIsChartPaneOpen = function() {
    return LocalRedux_useSelector(function(state) {
        return state.isChartPaneOpen;
    });
};
var useChartView = function() {
    return LocalRedux_useSelector(function(state) {
        return state.chartView;
    });
};
var useGetCurrentEpoch = function() {
    return LocalRedux_useSelector(function(state) {
        return state.currentEpoch;
    });
};
var useGetIntervalSeconds = function() {
    return LocalRedux_useSelector(function(state) {
        return state.intervalSeconds;
    });
};
var useGetPredictionsStatus = function() {
    return LocalRedux_useSelector(function(state) {
        return state.status;
    });
};
var useGetHistoryFilter = function() {
    return LocalRedux_useSelector(function(state) {
        return state.historyFilter;
    });
};
var useGetHasHistoryLoaded = function() {
    return LocalRedux_useSelector(function(state) {
        return state.hasHistoryLoaded;
    });
};
var useGetCurrentHistoryPage = function() {
    return LocalRedux_useSelector(function(state) {
        return state.currentHistoryPage;
    });
};
var useGetMinBetAmount = function() {
    return LocalRedux_useSelector(getMinBetAmountSelector);
};
var useGetBufferSeconds = function() {
    return LocalRedux_useSelector(function(state) {
        return state.bufferSeconds;
    });
};
var useGetIsFetchingHistory = function() {
    return LocalRedux_useSelector(function(state) {
        return state.isFetchingHistory;
    });
};
var useGetHistory = function() {
    return LocalRedux_useSelector(function(state) {
        return state.history;
    });
};
/**
 * The current round's lock timestamp will not be set immediately so we return an estimate until then
 */ var useGetCurrentRoundCloseTimestamp = function() {
    return LocalRedux_useSelector(getCurrentRoundCloseTimestampSelector);
};
// Leaderboard
var useGetLeaderboardLoadingState = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.loadingState;
    });
};
var useGetLeaderboardResults = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.results;
    });
};
var useGetLeaderboardFilters = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.filters;
    });
};
var useGetLeaderboardSkip = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.skip;
    });
};
var useGetLeaderboardHasMoreResults = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.hasMoreResults;
    });
};
var useGetAddressResult = function(account) {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.addressResults[account];
    });
};
var useGetOrFetchLeaderboardAddressResult = function(account) {
    var addressResult = useGetAddressResult(account);
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    (0,react.useEffect)(function() {
        var address = (0,utils/* isAddress */.UJ)(account);
        // If address result is null it means we already tried fetching the results and none came back
        if (!addressResult && addressResult !== null && address) {
            dispatch((0,predictions/* fetchAddressResult */.nI)(account));
        }
    }, [
        dispatch,
        account,
        addressResult
    ]);
    return addressResult;
};
var useGetSelectedAddress = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.selectedAddress;
    });
};
// Because Modal Component is rendered outside the Prediction Page contexts
// We have to pass local state as props instead of retrieving directly in component
var useStatModalProps = function(account) {
    var selectedAddress = useGetSelectedAddress();
    var address = account || selectedAddress;
    var result = useGetOrFetchLeaderboardAddressResult(address);
    var leaderboardLoadingState = useGetLeaderboardLoadingState();
    return {
        address: address,
        result: result,
        leaderboardLoadingState: leaderboardLoadingState
    };
};
var useCollectWinningModalProps = function() {
    var isLoadingHistory = useGetIsFetchingHistory();
    var history = useGetHistory();
    return {
        isLoadingHistory: isLoadingHistory,
        history: history
    };
};


/***/ }),

/***/ 13471:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DAY_IN_SECONDS = 86400;
var MONTH_IN_SECONDS = 2629800;
var YEAR_IN_SECONDS = 31557600;
/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */ var getTimePeriods = function(seconds) {
    var delta = Math.abs(seconds);
    var timeLeft = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    if (delta >= YEAR_IN_SECONDS) {
        timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS);
        delta -= timeLeft.years * YEAR_IN_SECONDS;
    }
    if (delta >= MONTH_IN_SECONDS) {
        timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS);
        delta -= timeLeft.months * MONTH_IN_SECONDS;
    }
    if (delta >= DAY_IN_SECONDS) {
        timeLeft.days = Math.floor(delta / DAY_IN_SECONDS);
        delta -= timeLeft.days * DAY_IN_SECONDS;
    }
    if (delta >= HOUR_IN_SECONDS) {
        timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS);
        delta -= timeLeft.hours * HOUR_IN_SECONDS;
    }
    if (delta >= MINUTE_IN_SECONDS) {
        timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS);
        delta -= timeLeft.minutes * MINUTE_IN_SECONDS;
    }
    timeLeft.seconds = delta;
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (getTimePeriods);


/***/ }),

/***/ 65238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ ConfigProvider; },
/* harmony export */   "ZR": function() { return /* binding */ useConfig; }
/* harmony export */ });
/* unused harmony export ConfigContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
function useConfig() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ConfigContext);
}
function ConfigProvider(param) {
    var children = param.children, config = param.config;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfigContext.Provider, {
        value: config,
        children: children
    });
}


/***/ }),

/***/ 63322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ context_PredictionConfigProviders; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/Provider.tsx
var Provider = __webpack_require__(13351);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
;// CONCATENATED MODULE: ./src/contexts/LocalRedux/makeStore.ts

function makeStore(reducer) {
    var preloadedState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined, extraArgument = arguments.length > 2 ? arguments[2] : void 0;
    return (0,redux_toolkit_esm/* configureStore */.xC)({
        reducer: reducer,
        middleware: function(getDefaultMiddleware) {
            return getDefaultMiddleware({
                thunk: {
                    extraArgument: extraArgument
                }
            });
        },
        preloadedState: preloadedState
    });
}

// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/toUpper.js
var toUpper = __webpack_require__(3945);
var toUpper_default = /*#__PURE__*/__webpack_require__.n(toUpper);
// EXTERNAL MODULE: ./src/views/Predictions/context/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(65238);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 7 modules
var src = __webpack_require__(48872);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
;// CONCATENATED MODULE: ./src/views/Predictions/context/config.ts



var DEFAULT_MIN_PRICE_USD_DISPLAYED = bignumber/* BigNumber.from */.O$.from(1);
/* harmony default export */ var context_config = ({
    BNB: {
        address: "0xFBE87Ee1Ee62244A2dF80a8093Eab829C52863e8",
        api: endpoints/* GRAPH_API_PREDICTION_BNB */.GZ,
        chainlinkOracleAddress: "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70",
        minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
        displayedDecimals: 4,
        token: src/* baseTokens.eth */.jk.eth
    },
    CAKE: {
        address: "0xFBE87Ee1Ee62244A2dF80a8093Eab829C52863e8",
        api: endpoints/* GRAPH_API_PREDICTION_BNB */.GZ,
        chainlinkOracleAddress: "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70",
        minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
        displayedDecimals: 4,
        token: src/* baseTokens.cake */.jk.cake
    }
});

;// CONCATENATED MODULE: ./src/views/Predictions/context/PredictionConfigProviders.tsx










var PREDICTION_TOKEN_KEY = "prediction-token";
var PredictionConfigProviders = function(param) {
    var children = param.children;
    var query = (0,router.useRouter)().query;
    var token = query.token;
    var ref = (0,react.useState)(function() {
        var initToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(PREDICTION_TOKEN_KEY);
        if ([
            types/* PredictionSupportedSymbol.BNB */.ru.BNB,
            types/* PredictionSupportedSymbol.CAKE */.ru.CAKE
        ].includes(initToken)) {
            return initToken;
        }
        return types/* PredictionSupportedSymbol.BNB */.ru.BNB;
    }), selectedToken = ref[0], setConfig = ref[1];
    (0,react.useEffect)(function() {
        var upperToken = toUpper_default()(token);
        if ([
            types/* PredictionSupportedSymbol.BNB */.ru.BNB,
            types/* PredictionSupportedSymbol.CAKE */.ru.CAKE
        ].includes(upperToken)) {
            setConfig(upperToken);
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(PREDICTION_TOKEN_KEY, upperToken);
        }
    }, [
        token
    ]);
    var config = (0,react.useMemo)(function() {
        return context_config[selectedToken];
    }, [
        selectedToken
    ]);
    var store = (0,react.useMemo)(function() {
        return makeStore(predictions/* default */.ZP, predictions/* initialState */.E3, config);
    }, [
        config
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfigProvider/* default */.ZP, {
        config: config,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider/* default */.Z, {
            store: store,
            children: children
        })
    });
};
/* harmony default export */ var context_PredictionConfigProviders = (PredictionConfigProviders);


/***/ }),

/***/ 69241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SwiperContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var SwiperContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var SwiperProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var destroySwiper = function() {
        if (swiper) {
            swiper.destroy();
            setSwiper(null);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwiperContext.Provider, {
        value: {
            swiper: swiper,
            setSwiper: setSwiper,
            destroySwiper: destroySwiper
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SwiperProvider));


/***/ }),

/***/ 62682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XW": function() { return /* binding */ getRoundPosition; },
/* harmony export */   "jw": function() { return /* binding */ getMultiplierV2; },
/* harmony export */   "kJ": function() { return /* binding */ getPriceDifference; },
/* harmony export */   "o4": function() { return /* binding */ CHART_DOT_CLICK_EVENT; },
/* harmony export */   "pf": function() { return /* binding */ formatUsdv2; },
/* harmony export */   "rc": function() { return /* binding */ formatBnbv2; },
/* harmony export */   "tw": function() { return /* binding */ formatRoundTime; }
/* harmony export */ });
/* unused harmony export padTime */
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20335);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96470);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59123);
/* harmony import */ var utils_getTimePeriods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13471);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21046);





var MIN_PRICE_BNB_DISPLAYED = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from("1000000000000000");
var formatPriceDifference = function(param) {
    var _price = param.price, price = _price === void 0 ? _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y : _price, minPriceDisplayed = param.minPriceDisplayed, unitPrefix = param.unitPrefix, displayedDecimals = param.displayedDecimals, decimals = param.decimals;
    if (price.abs().lt(minPriceDisplayed)) {
        var sign = price.isNegative() ? _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .NegativeOne */ .tL : _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .One */ .fh;
        var signedPriceToFormat = minPriceDisplayed.mul(sign);
        return "<".concat(unitPrefix).concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__/* .formatBigNumberToFixed */ .U1)(signedPriceToFormat, displayedDecimals, decimals));
    }
    return "".concat(unitPrefix).concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__/* .formatBigNumberToFixed */ .U1)(price, displayedDecimals, decimals));
};
var formatUsdv2 = function(usd, minPriceDisplayed, displayedDecimals) {
    return formatPriceDifference({
        price: usd,
        minPriceDisplayed: minPriceDisplayed,
        unitPrefix: "$",
        displayedDecimals: displayedDecimals,
        decimals: 8
    });
};
var formatBnbv2 = function(bnb, displayedDecimals) {
    return formatPriceDifference({
        price: bnb,
        minPriceDisplayed: MIN_PRICE_BNB_DISPLAYED,
        unitPrefix: "",
        displayedDecimals: displayedDecimals,
        decimals: 18
    });
};
var padTime = function(num) {
    return num.toString().padStart(2, "0");
};
var formatRoundTime = function(secondsBetweenBlocks) {
    var ref = (0,utils_getTimePeriods__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(secondsBetweenBlocks), hours = ref.hours, minutes = ref.minutes, seconds = ref.seconds;
    var minutesSeconds = "".concat(padTime(minutes), ":").concat(padTime(seconds));
    if (hours > 0) {
        return "".concat(padTime(hours), ":").concat(minutesSeconds);
    }
    return minutesSeconds;
};
var getMultiplierV2 = function(total, amount) {
    if (!total) {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(0);
    }
    if (total.eq(0) || amount.eq(0)) {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(0);
    }
    var rewardAmountFixed = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(total);
    var multiplierAmountFixed = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(amount);
    return rewardAmountFixed.divUnsafe(multiplierAmountFixed);
};
var getPriceDifference = function(price, lockPrice) {
    if (!price || !lockPrice) {
        return _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y;
    }
    return price.sub(lockPrice);
};
var getRoundPosition = function(lockPrice, closePrice) {
    if (!closePrice) {
        return null;
    }
    if (closePrice.eq(lockPrice)) {
        return state_types__WEBPACK_IMPORTED_MODULE_0__/* .BetPosition.HOUSE */ .Tu.HOUSE;
    }
    return closePrice.gt(lockPrice) ? state_types__WEBPACK_IMPORTED_MODULE_0__/* .BetPosition.BULL */ .Tu.BULL : state_types__WEBPACK_IMPORTED_MODULE_0__/* .BetPosition.BEAR */ .Tu.BEAR;
};
var CHART_DOT_CLICK_EVENT = "CHART_DOT_CLICK_EVENT";


/***/ }),

/***/ 37408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93146);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22408);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21046);
/* harmony import */ var _context_ConfigProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65238);




var usePollOraclePrice = function() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
    var chainlinkOracleAddress = (0,_context_ConfigProvider__WEBPACK_IMPORTED_MODULE_2__/* .useConfig */ .ZR)().chainlinkOracleAddress;
    var chainlinkOracleContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_0__/* .useChainlinkOracleContract */ .Hn)(chainlinkOracleAddress, false);
    // Can refactor to subscription later
    var ref = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_1__/* .useSWRContract */ .Av)([
        chainlinkOracleContract,
        "latestAnswer"
    ], {
        refreshInterval: seconds * 1000,
        refreshWhenHidden: true,
        refreshWhenOffline: true,
        dedupingInterval: seconds * 1000,
        fallbackData: _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y
    }), price = ref.data, mutate = ref.mutate;
    return {
        price: price,
        refresh: mutate
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePollOraclePrice);


/***/ }),

/***/ 82961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_SwiperProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69241);


var useSwiper = function() {
    var swiperContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_SwiperProvider__WEBPACK_IMPORTED_MODULE_1__/* .SwiperContext */ .O);
    if (swiperContext === undefined) {
        throw new Error("Swiper not found");
    }
    return swiperContext;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSwiper);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7425,7857,4165,5855,7928,7839,8161,7449,1548,8831,4651,6688,6483,9774,2888,179], function() { return __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);